(function () {
    'use strict';

    document.addEventListener('DOMContentLoaded', function() {
        const seotextBlocks = document.querySelectorAll('.openBlock');

        seotextBlocks.forEach(block => {
            const toggleBtn = block.querySelector('.toggleBtn');
            if (!toggleBtn) return;

            const textBlock = block.querySelector('.seotext-block__text .col2');

            if (textBlock) {
                const textContent = textBlock.textContent || textBlock.innerText;
                const charCount = textContent.length;

                if (charCount < 1422) {
                    const currentTextBlock = block.querySelector('.seotext-block__text');
                    if (currentTextBlock) {
                        currentTextBlock.classList.add('textOnly');
                    }
                    toggleBtn.style.display = 'none';
                    return;
                }
            }

            const toggleText = toggleBtn.querySelector('span');
            const icon = toggleBtn.querySelector('svg, i');

            toggleBtn.addEventListener('click', function() {
                block.classList.toggle('open');

                if (block.classList.contains('open')) {
                    toggleText.textContent = 'Свернуть';
                    if (icon) {
                        icon.classList.add('rotated');
                    }
                } else {
                    toggleText.textContent = 'Читать далее';
                    if (icon) {
                        icon.classList.remove('rotated');
                    }
                }
            });
        });
    });

    document.addEventListener('DOMContentLoaded', function() {
        // Функция для получения числового значения
        function getNumberValue(input) {
            const value = parseInt(input.value);
            return isNaN(value) ? 0 : Math.max(0, value);
        }

        // Функция для обновления значения
        function updateInputValue(input, newValue) {
            input.value = Math.max(0, newValue); // Не меньше 0
            // Триггерим события
            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // Кнопка увеличения
        document.querySelectorAll('.count__up').forEach(button => {
            button.addEventListener('click', function() {
                const input = this.parentElement.querySelector('input');
                const currentValue = getNumberValue(input);
                updateInputValue(input, currentValue + 1);
            });
        });

        // Кнопка уменьшения
        document.querySelectorAll('.count__down').forEach(button => {
            button.addEventListener('click', function() {
                const input = this.parentElement.querySelector('input');
                const currentValue = getNumberValue(input);
                updateInputValue(input, currentValue - 1);
            });
        });

        // Обработка ручного ввода
        document.querySelectorAll('.form__counts input[type="number"]').forEach(input => {
            // При потере фокуса нормализуем значение
            input.addEventListener('blur', function() {
                const value = getNumberValue(this);
                this.value = value;
            });

            // При загрузке страницы нормализуем начальные значения
            const initialValue = getNumberValue(input);
            input.value = initialValue;
        });
    });

    class SortSelector {
        constructor(container) {
            this.container = container;
            this.sortSelect = container.querySelector('.contentSort__select');
            this.sortList = this.sortSelect.querySelector('ul');
            this.listItems = this.sortList.querySelectorAll('li');

            this.customTrigger = null;
            this.isMobile = window.innerWidth <= 1025;

            this.init();
        }

        init() {
            this.createCustomSelect();
            this.bindEvents();
        }

        setActiveItem(value, text) {
            this.listItems.forEach(item => {
                const isActive = item.dataset.value === value;
                item.classList.toggle('active', isActive);
            });

            if (this.customTrigger) {
                this.customTrigger.textContent = text;
            }
        }

        createCustomSelect() {
            if (this.customTrigger) return;

            const activeItem = Array.from(this.listItems).find(item => item.classList.contains('active'));
            const activeText = activeItem ? activeItem.textContent : 'По популярности';

            this.customTrigger = document.createElement('div');
            this.customTrigger.className = 'custom-select-trigger';
            this.customTrigger.textContent = activeText;

            this.sortSelect.insertBefore(this.customTrigger, this.sortList);

            this.customTrigger.addEventListener('click', (e) => {
                e.stopPropagation();
                this.handleTriggerClick();
            });
        }

        handleTriggerClick() {
            this.customTrigger.classList.toggle('active');

            if (this.customTrigger.classList.contains('active')) {
                this.sortList.classList.add('show');
            } else {
                this.sortList.classList.remove('show');
            }
        }

        bindEvents() {
            this.listItems.forEach(item => {
                item.addEventListener('click', (e) => {
                    e.stopPropagation();

                    const value = item.dataset.value;
                    const text = item.textContent;

                    this.setActiveItem(value, text);

                    if (this.customTrigger) {
                        this.customTrigger.classList.remove('active');
                        this.sortList.classList.remove('show');
                        this.customTrigger.textContent = text;
                    }
                });
            });

            document.addEventListener('click', (e) => {
                if (this.customTrigger) {
                    if (!this.customTrigger.contains(e.target) && !this.sortList.contains(e.target)) {
                        this.customTrigger.classList.remove('active');
                        this.sortList.classList.remove('show');
                    }
                }
            });
        }
    }

    document.addEventListener('DOMContentLoaded', function() {
        const sortContainers = document.querySelectorAll('.contentSort');

        if (sortContainers.length === 0) {
            return;
        }

        sortContainers.forEach((container, index) => {
            try {
                new SortSelector(container);
            } catch (error) {
                console.error(`Ошибка инициализации сортировки`, error);
            }
        });
    });

    var ZBRangeSlider = function (id) {
        var self = this;
        var startX = 0,
            x = 0;

        // retrieve touch button
        var slider = document.getElementById(id);
        var touchLeft = slider.querySelector('.slider-touch-left');
        var touchRight = slider.querySelector('.slider-touch-right');
        var lineSpan = slider.querySelector('.slider-line span');

        // get some properties
        var min = parseFloat(slider.getAttribute('se-min'));
        var max = parseFloat(slider.getAttribute('se-max'));

        // retrieve default values
        var defaultMinValue = min;
        if (slider.hasAttribute('se-min-value')) {
            defaultMinValue = parseFloat(slider.getAttribute('se-min-value'));
        }
        var defaultMaxValue = max;
        if (slider.hasAttribute('se-max-value')) {
            defaultMaxValue = parseFloat(slider.getAttribute('se-max-value'));
        }

        // check values are correct
        if (defaultMinValue < min) {
            defaultMinValue = min;
        }
        if (defaultMaxValue > max) {
            defaultMaxValue = max;
        }
        if (defaultMinValue > defaultMaxValue) {
            defaultMinValue = defaultMaxValue;
        }

        var step = 0.0;
        if (slider.getAttribute('se-step')) {
            step = Math.abs(parseFloat(slider.getAttribute('se-step')));
        }

        self.slider = slider;

        self.reset = function () {
            touchLeft.style.left = '0px';
            touchRight.style.left = (slider.offsetWidth - touchRight.offsetWidth) + 'px';
            lineSpan.style.marginLeft = '0px';
            lineSpan.style.width = (slider.offsetWidth - touchLeft.offsetWidth) + 'px';
            startX = 0;
            x = 0;
        };

        self.setMinValue = function (minValue) {
            // Проверка границ
            if (minValue < min) minValue = min;
            var currentMax = parseFloat(slider.getAttribute('se-max-value')) || max;
            if (minValue > currentMax) minValue = currentMax;

            // Расчет позиции левого ползунка
            var ratio = (minValue - min) / (max - min);
            var maxPosition = slider.offsetWidth - touchLeft.offsetWidth;
            var position = Math.round(ratio * maxPosition);

            touchLeft.style.left = position + 'px';
            lineSpan.style.marginLeft = position + 'px';

            var rightPosition = parseFloat(touchRight.style.left) || (slider.offsetWidth - touchRight.offsetWidth);
            lineSpan.style.width = (rightPosition - position) + 'px';

            slider.setAttribute('se-min-value', minValue);
        };

        self.setMaxValue = function (maxValue) {
            // Проверка границ
            if (maxValue > max) maxValue = max;
            var currentMin = parseFloat(slider.getAttribute('se-min-value')) || min;
            if (maxValue < currentMin) maxValue = currentMin;

            // Расчет позиции правого ползунка
            var ratio = (maxValue - min) / (max - min);
            var maxPosition = slider.offsetWidth - touchRight.offsetWidth;
            var position = Math.round(ratio * maxPosition);

            touchRight.style.left = position + 'px';

            var leftPosition = parseFloat(touchLeft.style.left) || 0;
            lineSpan.style.marginLeft = leftPosition + 'px';
            lineSpan.style.width = (position - leftPosition) + 'px';

            slider.setAttribute('se-max-value', maxValue);
        };

        // initial reset
        self.reset();

        // usefull values
        slider.offsetWidth - touchRight.offsetWidth;
        var selectedTouch = null;
        slider.offsetWidth - touchLeft.offsetWidth;

        // set default values
        self.setMinValue(defaultMinValue);
        self.setMaxValue(defaultMaxValue);

        function onStart(event) {
            // Prevent default dragging of selected content
            event.preventDefault();
            var eventTouch = event;

            if (event.touches) {
                eventTouch = event.touches[0];
            }

            if (this === touchLeft) {
                x = touchLeft.offsetLeft;
            } else {
                x = touchRight.offsetLeft;
            }

            startX = eventTouch.pageX - x;
            selectedTouch = this;

            document.addEventListener('mousemove', onMove);
            document.addEventListener('mouseup', onStop);
            document.addEventListener('touchmove', onMove);
            document.addEventListener('touchend', onStop);
        }

        function onMove(event) {
            document.body.classList.add('dragged-slider');

            var eventTouch = event;
            if (event.touches) {
                eventTouch = event.touches[0];
            }

            x = eventTouch.pageX - startX;

            if (selectedTouch === touchLeft) {
                // Ограничения для левого ползунка
                var rightPos = parseFloat(touchRight.style.left) || (slider.offsetWidth - touchRight.offsetWidth);
                var minX = 0;
                var maxX = rightPos - touchLeft.offsetWidth + 2; // +2 для небольшого перекрытия

                if (x < minX) x = minX;
                if (x > maxX) x = maxX;

                touchLeft.style.left = x + 'px';
            } else if (selectedTouch === touchRight) {
                // Ограничения для правого ползунка
                var leftPos = parseFloat(touchLeft.style.left) || 0;
                var minX = leftPos + touchLeft.offsetWidth - 2; // -2 для небольшого перекрытия
                var maxX = slider.offsetWidth - touchRight.offsetWidth;

                if (x < minX) x = minX;
                if (x > maxX) x = maxX;

                touchRight.style.left = x + 'px';
            }

            // update line span
            var leftPos = parseFloat(touchLeft.style.left) || 0;
            var rightPos = parseFloat(touchRight.style.left) || (slider.offsetWidth - touchRight.offsetWidth);

            lineSpan.style.marginLeft = leftPos + 'px';
            lineSpan.style.width = (rightPos - leftPos) + 'px';

            // write new value
            calculateValue();

            // call on change
            if (slider.getAttribute('on-change')) {
                var fn = new Function('min, max', slider.getAttribute('on-change'));
                fn(slider.getAttribute('se-min-value'), slider.getAttribute('se-max-value'));
            }

            if (self.onChange) {
                self.onChange(slider.getAttribute('se-min-value'), slider.getAttribute('se-max-value'));
            }
        }

        function onStop(event) {
            document.removeEventListener('mousemove', onMove);
            document.removeEventListener('mouseup', onStop);
            document.removeEventListener('touchmove', onMove);
            document.removeEventListener('touchend', onStop);

            setTimeout(() => {
                document.body.classList.toggle('dragged-slider', false);
            }, 300);

            selectedTouch = null;

            // write new value
            calculateValue();

            // call did changed
            if (slider.getAttribute('did-changed')) {
                var fn = new Function('min, max', slider.getAttribute('did-changed'));
                fn(slider.getAttribute('se-min-value'), slider.getAttribute('se-max-value'));
            }

            if (self.didChanged) {
                self.didChanged(slider.getAttribute('se-min-value'), slider.getAttribute('se-max-value'));
            }
        }

        function calculateValue() {
            var leftPos = parseFloat(touchLeft.style.left) || 0;
            var rightPos = parseFloat(touchRight.style.left) || (slider.offsetWidth - touchRight.offsetWidth);

            var maxPosition = slider.offsetWidth - touchLeft.offsetWidth;

            // Расчет значений на основе позиций
            var leftRatio = leftPos / maxPosition;
            var rightRatio = rightPos / maxPosition;

            var calculatedMin = min + leftRatio * (max - min);
            var calculatedMax = min + rightRatio * (max - min);

            // Применение шага
            if (step > 0) {
                calculatedMin = Math.round(calculatedMin / step) * step;
                calculatedMax = Math.round(calculatedMax / step) * step;
            }

            // Округление до 2 знаков после запятой
            calculatedMin = Math.round(calculatedMin * 100) / 100;
            calculatedMax = Math.round(calculatedMax * 100) / 100;

            // Проверка границ
            if (calculatedMin < min) calculatedMin = min;
            if (calculatedMax > max) calculatedMax = max;
            if (calculatedMin > calculatedMax) calculatedMin = calculatedMax;

            slider.setAttribute('se-min-value', calculatedMin);
            slider.setAttribute('se-max-value', calculatedMax);
        }

        // link events
        touchLeft.addEventListener('mousedown', onStart);
        touchRight.addEventListener('mousedown', onStart);
        touchLeft.addEventListener('touchstart', onStart);
        touchRight.addEventListener('touchstart', onStart);
    };
    document.addEventListener('DOMContentLoaded', function() {




        if (!document.querySelector('.contentNavigation__menu')) {
            return;
        }

        if (document.querySelector('.filter-properties')) {

            const container = document.querySelector('.contentNavigation__menu');
            if (container) {
                const subMenus = container.querySelectorAll('.filter-properties__list ul');

                subMenus.forEach(ul => {
                    const items = ul.querySelectorAll('li');

                    if (items.length > 5) {
                        items.forEach((item, index) => {
                            if (index >= 5) item.classList.add('hidden');
                        });

                        items.length - 5;
                        const toggleBtn = document.createElement('div');
                        toggleBtn.classList.add('sub-menu-toggle');
                        // toggleBtn.innerHTML = `Ещё <span>${hiddenCount}</span> <i class="icon"></i>`;
                        toggleBtn.innerHTML = `Показать все <i class="icon"></i>`;

                        toggleBtn.addEventListener('click', (event) => {
                            event.stopPropagation();

                            ul.classList.toggle('is-open');
                            toggleBtn.classList.toggle('is-open');

                            const isOpen = ul.classList.contains('is-open');

                            items.forEach((item, index) => {
                                if (index >= 5) {
                                    item.classList.toggle('hidden', !isOpen);
                                }
                            });

                            toggleBtn.innerHTML = isOpen ?
                                `Свернуть <i class="icon"></i>` :
                                `Показать все <i class="icon"></i>`;
                        });

                        ul.after(toggleBtn);
                    }
                });
            }

        }


        // ============================================
        // Хранилище для всех слайдеров
        // ============================================
        const sliders = {};

        function delimiter(num) {
            return String(num).replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1 ');
        }

        // ============================================
        // Инициализация слайдера для дней
        // ============================================
        function initDaySlider() {
            try {
                if (typeof ZBRangeSlider === 'undefined') {
                    console.warn('ZBRangeSlider не загружен');
                    return;
                }

                const sliderContainer = document.getElementById('day-slider');
                if (!sliderContainer) {
                    console.warn('Контейнер слайдера #day-slider не найден');
                    return;
                }

                if (sliders.day) {
                    return;
                }

                console.log('Создаем слайдер для дней...');
                const daySlider = new ZBRangeSlider('day-slider');
                sliders.day = daySlider;

                const inputMax = document.querySelector('[data-day-range="max"]');
                const inputMin = document.querySelector('[data-day-range="min"]');

                const dayMinOriginal = parseFloat(sliderContainer.getAttribute('se-min')) || 1;
                const dayMaxOriginal = parseFloat(sliderContainer.getAttribute('se-max')) || 16;

                if (inputMax) inputMax.value = delimiter(dayMaxOriginal);
                if (inputMin) inputMin.value = delimiter(dayMinOriginal);

                daySlider.onChange = function(min, max) {
                    if (inputMax) inputMax.value = delimiter(Math.round(max)) ;
                    if (inputMin) inputMin.value = delimiter(Math.round(min)) ;
                    console.log('onChange дней', min, max);
                };

                // Обработчики для inputMin дней
                if (inputMin) {
                    inputMin.addEventListener('input', function(e) {
                        e.target.value = e.target.value.replace(/[^\d]/g, '');
                    });

                    inputMin.addEventListener('blur', function(e) {
                        let int = parseFloat(e.target.value.replace(/[^\d]/g, ''));

                        if (isNaN(int)) {
                            int = dayMinOriginal;
                        }

                        let maxInputValue = inputMax ? parseFloat(inputMax.value.replace(/[^\d]/g, '')) : dayMaxOriginal;
                        if (isNaN(maxInputValue)) {
                            maxInputValue = dayMaxOriginal;
                        }

                        if (int < dayMinOriginal) {
                            int = dayMinOriginal;
                        }
                        if (int > dayMaxOriginal) {
                            int = dayMaxOriginal;
                        }
                        if (int > maxInputValue) {
                            int = maxInputValue;
                        }

                        e.target.value = delimiter(int);
                        if (daySlider) {
                            daySlider.setMinValue(int);
                            if (typeof daySlider.onChange === 'function') {
                                const currentMax = parseFloat(daySlider.slider.getAttribute('se-max-value')) || dayMaxOriginal;
                                daySlider.onChange(int, currentMax);
                            }
                        }
                    });
                }

                // Обработчики для inputMax дней
                if (inputMax) {
                    inputMax.addEventListener('input', function(e) {
                        e.target.value = e.target.value.replace(/[^\d]/g, '');
                    });

                    inputMax.addEventListener('blur', function(e) {
                        let int = parseFloat(e.target.value.replace(/[^\d]/g, ''));

                        if (isNaN(int)) {
                            int = dayMaxOriginal;
                        }

                        let minInputValue = inputMin ? parseFloat(inputMin.value.replace(/[^\d]/g, '')) : dayMinOriginal;
                        if (isNaN(minInputValue)) {
                            minInputValue = dayMinOriginal;
                        }

                        if (int < dayMinOriginal) {
                            int = dayMinOriginal;
                        }
                        if (int > dayMaxOriginal) {
                            int = dayMaxOriginal;
                        }
                        if (int < minInputValue) {
                            int = minInputValue;
                        }

                        e.target.value = delimiter(int);
                        if (daySlider) {
                            daySlider.setMaxValue(int);
                            if (typeof daySlider.onChange === 'function') {
                                const currentMin = parseFloat(daySlider.slider.getAttribute('se-min-value')) || dayMinOriginal;
                                daySlider.onChange(currentMin, int);
                            }
                        }
                    });
                }

                console.log('Слайдер для дней инициализирован');

            } catch (error) {
                console.error('Ошибка инициализации слайдера для дней:', error);
            }
        }

        // ============================================
        // Инициализация слайдера для цен (существующий)
        // ============================================
        function initPriceRange() {
            try {
                if (typeof ZBRangeSlider === 'undefined') {
                    console.warn('ZBRangeSlider не загружен');
                    return;
                }

                const sliderContainer = document.getElementById('price-slider');
                if (!sliderContainer) {
                    console.warn('Контейнер слайдера #price-slider не найден');
                    return;
                }

                if (sliders.price) {
                    return;
                }

                console.log('Создаем слайдер для цен...');
                const priceSlider = new ZBRangeSlider('price-slider');
                sliders.price = priceSlider;

                const inputMax = document.querySelector('[data-price-range="max"]');
                const inputMin = document.querySelector('[data-price-range="min"]');

                const priceMinOriginal = parseFloat(sliderContainer.getAttribute('se-min')) || 0;
                const priceMaxOriginal = parseFloat(sliderContainer.getAttribute('se-max')) || 10000;

                if (inputMax) inputMax.value = delimiter(priceMaxOriginal) + ' ₽';
                if (inputMin) inputMin.value = delimiter(priceMinOriginal) + ' ₽';

                priceSlider.onChange = function(min, max) {
                    if (inputMax) inputMax.value = delimiter(max) + ' ₽';
                    if (inputMin) inputMin.value = delimiter(min) + ' ₽';
                    console.log('onChange цен', min, max);
                };

                // Обработчики для inputMin цен
                if (inputMin) {
                    inputMin.addEventListener('input', function(e) {
                        e.target.value = e.target.value.replace(/[^\d]/g, '');
                    });

                    inputMin.addEventListener('blur', function(e) {
                        let int = parseFloat(e.target.value.replace(/[^\d]/g, ''));

                        if (isNaN(int)) {
                            int = priceMinOriginal;
                        }

                        let maxInputValue = inputMax ? parseFloat(inputMax.value.replace(/[^\d]/g, '')) : priceMaxOriginal;
                        if (isNaN(maxInputValue)) {
                            maxInputValue = priceMaxOriginal;
                        }

                        if (int < priceMinOriginal) {
                            int = priceMinOriginal;
                        }
                        if (int > priceMaxOriginal) {
                            int = priceMaxOriginal;
                        }
                        if (int > maxInputValue) {
                            int = maxInputValue;
                        }

                        e.target.value = delimiter(int) + ' ₽';
                        if (priceSlider) {
                            priceSlider.setMinValue(int);
                            if (typeof priceSlider.onChange === 'function') {
                                const currentMax = parseFloat(priceSlider.slider.getAttribute('se-max-value')) || priceMaxOriginal;
                                priceSlider.onChange(int, currentMax);
                            }
                        }
                    });
                }

                // Обработчики для inputMax цен
                if (inputMax) {
                    inputMax.addEventListener('input', function(e) {
                        e.target.value = e.target.value.replace(/[^\d]/g, '');
                    });

                    inputMax.addEventListener('blur', function(e) {
                        let int = parseFloat(e.target.value.replace(/[^\d]/g, ''));

                        if (isNaN(int)) {
                            int = priceMaxOriginal;
                        }

                        let minInputValue = inputMin ? parseFloat(inputMin.value.replace(/[^\d]/g, '')) : priceMinOriginal;
                        if (isNaN(minInputValue)) {
                            minInputValue = priceMinOriginal;
                        }

                        if (int < priceMinOriginal) {
                            int = priceMinOriginal;
                        }
                        if (int > priceMaxOriginal) {
                            int = priceMaxOriginal;
                        }
                        if (int < minInputValue) {
                            int = minInputValue;
                        }

                        e.target.value = delimiter(int) + ' ₽';
                        if (priceSlider) {
                            priceSlider.setMaxValue(int);
                            if (typeof priceSlider.onChange === 'function') {
                                const currentMin = parseFloat(priceSlider.slider.getAttribute('se-min-value')) || priceMinOriginal;
                                priceSlider.onChange(currentMin, int);
                            }
                        }
                    });
                }

                console.log('Слайдер для цен инициализирован');

            } catch (error) {
                console.error('Ошибка инициализации слайдера для цен:', error);
            }
        }

        // ============================================
        // Функция сброса для слайдера дней
        // ============================================
        function resetDaySlider() {
            if (sliders.day) {
                const sliderContainer = document.getElementById('day-slider');
                const dayMinOriginal = parseFloat(sliderContainer.getAttribute('se-min')) || 1;
                const dayMaxOriginal = parseFloat(sliderContainer.getAttribute('se-max')) || 16;

                sliders.day.setMinValue(dayMinOriginal);
                sliders.day.setMaxValue(dayMaxOriginal);

                const minInput = document.querySelector('[data-day-range="min"]');
                const maxInput = document.querySelector('[data-day-range="max"]');

                if (minInput) minInput.value = delimiter(dayMinOriginal);
                if (maxInput) maxInput.value = delimiter(dayMaxOriginal);

                if (typeof sliders.day.onChange === 'function') {
                    sliders.day.onChange(dayMinOriginal, dayMaxOriginal);
                }
            }
        }

        // ============================================
        // Функция сброса для слайдера цен
        // ============================================
        function resetPriceSlider() {
            if (sliders.price) {
                const sliderContainer = document.getElementById('price-slider');
                const priceMinOriginal = parseFloat(sliderContainer.getAttribute('se-min')) || 0;
                const priceMaxOriginal = parseFloat(sliderContainer.getAttribute('se-max')) || 10000;

                sliders.price.setMinValue(priceMinOriginal);
                sliders.price.setMaxValue(priceMaxOriginal);

                const minInput = document.querySelector('[data-price-range="min"]');
                const maxInput = document.querySelector('[data-price-range="max"]');

                if (minInput) minInput.value = delimiter(priceMinOriginal) + ' ₽';
                if (maxInput) maxInput.value = delimiter(priceMaxOriginal) + ' ₽';

                if (typeof sliders.price.onChange === 'function') {
                    sliders.price.onChange(priceMinOriginal, priceMaxOriginal);
                }
            }
        }

        // ============================================
        // Функция сброса для чекбоксов
        // ============================================
        function resetCheckboxes() {
            // Очищаем все чекбоксы в .filter-properties__list
            document.querySelectorAll('.filter-properties__list input[type="checkbox"]').forEach(function(checkbox) {
                checkbox.checked = false;
                const changeEvent = new Event('change', { bubbles: true });
                checkbox.dispatchEvent(changeEvent);
            });

            // Очищаем чекбоксы в .category-filter__item (если есть)
            document.querySelectorAll('.category-filter__item input[type="checkbox"]').forEach(function(checkbox) {
                checkbox.checked = false;
                const changeEvent = new Event('change', { bubbles: true });
                checkbox.dispatchEvent(changeEvent);
            });

            // Сбрасываем активные кнопки
            document.querySelectorAll(".filter-products__button").forEach(function(btn) {
                btn.classList.remove("active");
            });

            // Сбрасываем активные состояния в .filter-properties__list
            document.querySelectorAll('.filter-properties__list .active').forEach(function(el) {
                el.classList.remove('active');
            });
        }

        // ============================================
        // Инициализация всех слайдеров
        // ============================================
        function initializeAllSliders() {
            setTimeout(() => {
                // Инициализируем слайдер для цен
                if (document.getElementById('price-slider')) {
                    initPriceRange();
                }

                // Инициализируем слайдер для дней
                if (document.getElementById('day-slider')) {
                    initDaySlider();
                }
            }, 200);
        }

        // Запускаем инициализацию
        initializeAllSliders();

        // ============================================
        // Обработчик открытия фильтра
        // ============================================
        const filterTrigger = document.querySelector('[data-target="filter"]');
        if (filterTrigger) {
            filterTrigger.addEventListener('click', function() {
                setTimeout(() => {
                    if (document.getElementById('price-slider') && !sliders.price) {
                        initPriceRange();
                    }
                    if (document.getElementById('day-slider') && !sliders.day) {
                        initDaySlider();
                    }
                }, 300);
            });
        }

        // ============================================
        // Обработчик ресайза
        // ============================================
        window.addEventListener('resize', function() {
            Object.keys(sliders).forEach(key => {
                const slider = sliders[key];
                if (slider && typeof slider.reset === 'function') {
                    const sliderElement = slider.slider;
                    const minValue = parseFloat(sliderElement.getAttribute('se-min-value'));
                    const maxValue = parseFloat(sliderElement.getAttribute('se-max-value'));

                    slider.reset();
                    slider.setMinValue(minValue);
                    slider.setMaxValue(maxValue);
                }
            });
        });

        // ============================================
        // Обработчик кнопки сброса
        // ============================================
        const clearButton = document.querySelector('[data-filter="clear"]');
        if (clearButton) {
            clearButton.addEventListener('click', function() {
                // Очищаем чекбоксы
                document.querySelectorAll('.category-filter__item input[type="checkbox"]').forEach(function(checkbox) {
                    checkbox.checked = false;
                    const changeEvent = new Event('change', { bubbles: true });
                    checkbox.dispatchEvent(changeEvent);
                });
                // Очищаем все чекбоксы
                resetCheckboxes();
                // Сбрасываем слайдеры
                resetPriceSlider();
                resetDaySlider();

                // Очищаем активные кнопки
                const buttons = document.querySelectorAll(".filter-products__button");
                buttons.forEach(function(btn) {
                    btn.classList.remove("active");
                });

                // Отправляем форму
                const form = document.querySelector('.category-filter form');
                if (form) {
                    const entity = form.dataset.filter;
                    if (entity && window.Filter && window.Filter[entity]) {
                        window.Filter[entity].submit();
                    } else {
                        form.submit();
                    }
                }
            });
        }
    });

    document.addEventListener('DOMContentLoaded', function() {
        const menuItems = document.querySelectorAll('.contentNavigation__menu_item');

        menuItems.forEach(item => {
            const title = item.querySelector('.contentNavigation__menu_item-title');

            if (!title) return;

            title.addEventListener('click', function(e) {
                e.preventDefault();
                item.classList.toggle('hideBlock');
            });
        });
    });

    document.addEventListener('DOMContentLoaded', function() {
        const openBtn = document.querySelector('.openMobileCategory');
        const closeBtn = document.querySelector('.contentNavigationBox__header_close');
        const navigationBox = document.querySelector('.contentNavigation');

        if (!openBtn || !closeBtn || !navigationBox) {
            console.warn('Элементы не найдены');
            return;
        }

        // Открытие меню
        openBtn.addEventListener('click', function(e) {
            e.preventDefault();
            navigationBox.classList.add('open');
            document.body.style.overflow = 'hidden'; // Блокируем скролл
        });

        // Закрытие меню
        closeBtn.addEventListener('click', function(e) {
            e.preventDefault();
            navigationBox.classList.remove('open');
            document.body.style.overflow = ''; // Возвращаем скролл
        });

        // Закрытие при клике на overlay (если есть)
        const overlay = navigationBox.querySelector('.contentNavigationBox__overlay');
        if (overlay) {
            overlay.addEventListener('click', function() {
                navigationBox.classList.remove('open');
                document.body.style.overflow = '';
            });
        }

        // Закрытие при нажатии ESC
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && navigationBox.classList.contains('open')) {
                navigationBox.classList.remove('open');
                document.body.style.overflow = '';
            }
        });
    });


    document.addEventListener('DOMContentLoaded', function() {
        // Проверяем, загружен ли VanillaCalendar
        if (typeof VanillaCalendar === 'undefined') {
            console.warn('VanillaCalendar не загружен');
            return;
        }

        const calendarInput = document.getElementById('calendar');
        if (!calendarInput) {
            console.warn('Элемент #calendar не найден');
            return;
        }

        // Создаем контейнер для календаря
        let calendarContainer = document.querySelector('.calendar-container');
        if (!calendarContainer) {
            calendarContainer = document.createElement('div');
            calendarContainer.className = 'calendar-container';
            calendarContainer.style.cssText = `
            position: absolute;
            display: none;
            z-index: 1000;
            background: #fff;
            border-radius: 8px;
            box-shadow: 0 4px 20px rgba(0,0,0,0.15);
            padding: 16px;
            min-width: 280px;
        `;
            document.body.appendChild(calendarContainer);
        }

        // Функция форматирования даты
        function formatDate(date) {
            if (!date) return '';
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}.${month}.${year}`;
        }

        const today = new Date();
        const todayISO = today.toISOString().split('T')[0]; // '2024-01-15
        // Инициализируем календарь
        const calendar = new VanillaCalendar(calendarContainer, {
            settings: {
                lang: 'ru',
                iso8601: false,
                visibility: {
                    weekend: true,
                    today: true,
                    disabled: false
                },
                range: {
                    min: todayISO, // Минимальная дата - сегодня
                },
                selection: {
                    day: 'single',
                    time: false
                }
            },
            actions: {
                clickDay(e, dates) {
                    if (dates.selectedDates && dates.selectedDates.length > 0) {
                        const selectedDate = new Date(dates.selectedDates[0]);
                        const formattedDate = formatDate(selectedDate);

                        // Устанавливаем значение в поле ввода
                        calendarInput.value = formattedDate;

                        // Вызываем событие change
                        const changeEvent = new Event('change', { bubbles: true });
                        calendarInput.dispatchEvent(changeEvent);

                        // Скрываем календарь после выбора
                        calendarContainer.style.display = 'none';

                        console.log(`Выбрана дата: ${formattedDate}`);
                    }
                }
            }
        });

        // Сохраняем экземпляр календаря
        window.calendarInstance = calendar;

        // Инициализируем календарь
        calendar.init();

        // Функция обновления позиции
        function updateCalendarPosition() {
            const rect = calendarInput.getBoundingClientRect();

            const spaceBottom = window.innerHeight - rect.bottom;
            const calHeight = 350;

            if (spaceBottom > calHeight) {
                calendarContainer.style.top = rect.bottom + window.scrollY + 'px';
                calendarContainer.style.left = rect.left + window.scrollX + 'px';
            } else {
                calendarContainer.style.top = rect.top + window.scrollY - calHeight + 'px';
                calendarContainer.style.left = rect.left + window.scrollX + 'px';
            }
        }

        // Показываем/скрываем календарь
        calendarInput.addEventListener('click', function(e) {
            e.stopPropagation();

            if (calendarContainer.style.display === 'block') {
                calendarContainer.style.display = 'none';
            } else {
                updateCalendarPosition();
                calendarContainer.style.display = 'block';
                // Обновляем календарь при открытии
                calendar.update();
            }
        });

        // Закрываем при клике вне
        document.addEventListener('click', function(e) {
            if (!calendarContainer.contains(e.target) && e.target !== calendarInput) {
                calendarContainer.style.display = 'none';
            }
        });

        // Обновляем позицию при ресайзе
        window.addEventListener('resize', function() {
            if (calendarContainer.style.display === 'block') {
                updateCalendarPosition();
            }
        });

        window.addEventListener('scroll', function() {
            if (calendarContainer.style.display === 'block') {
                updateCalendarPosition();
            }
        });

        console.log('Календарь успешно инициализирован');
    });

    document.addEventListener('DOMContentLoaded', function() {
        const section = document.querySelector('.sectionCategoryInfo');
        if (!section) return;

        const content = section.querySelector('.sectionCategoryInfo__content');
        const showMoreBtn = section.querySelector('.showMore');

        const contentHeight = content.scrollHeight;
        const maxHeight = 128;

        if (contentHeight > maxHeight) {
            showMoreBtn.style.display = 'inline-block';

            content.style.maxHeight = maxHeight + 'px';
            content.style.overflow = 'hidden';

            content.style.transition = 'max-height 0.3s ease';

            let isExpanded = false;

            showMoreBtn.addEventListener('click', function() {
                if (!isExpanded) {
                    content.style.maxHeight = contentHeight + 'px';
                    showMoreBtn.textContent = 'Скрыть';
                    isExpanded = true;
                } else {
                    content.style.maxHeight = maxHeight + 'px';
                    showMoreBtn.textContent = 'Показать ещё';
                    isExpanded = false;
                }
            });
        } else {
            showMoreBtn.style.display = 'none';
        }
    });

    document.addEventListener('DOMContentLoaded', function() {
        const videos = document.querySelectorAll('.video-responsive');

        videos.forEach(videoContainer => {
            const video = videoContainer.querySelector('video');
            const btnPlay = videoContainer.querySelector('.btnPlay');
            const btnFull = videoContainer.querySelector('.btnFull');

            if (!video || !btnPlay || !btnFull) return;

            // Функция обновления иконки Play/Pause
            function updatePlayIcon() {
                const icon = btnPlay.querySelector('use');
                if (video.paused) {
                    icon.setAttribute('href', '/img/sprites/sprite.svg#ic_play_dark'); // Замените на ID вашей иконки Play
                } else {
                    icon.setAttribute('href', '/img/sprites/sprite.svg#ic_pause_dark'); // Замените на ID вашей иконки Pause
                }
            }

            // Play / Pause
            btnPlay.addEventListener('click', function() {
                if (video.paused) {
                    video.play();
                } else {
                    video.pause();
                }
            });

            // Обновление иконки при смене состояния видео
            video.addEventListener('play', updatePlayIcon);
            video.addEventListener('pause', updatePlayIcon);

            // Fullscreen
            btnFull.addEventListener('click', function() {
                if (video.requestFullscreen) {
                    video.requestFullscreen();
                } else if (video.webkitRequestFullscreen) { // Safari
                    video.webkitRequestFullscreen();
                } else if (video.msRequestFullscreen) { // IE/Edge
                    video.msRequestFullscreen();
                }
            });

            // Инициализация иконки
            updatePlayIcon();
        });
    });

    document.addEventListener('DOMContentLoaded', function() {
        const header = document.querySelector('header');

        if (!header) {
            return;
        }

        function checkScroll() {
            if (window.scrollY > 145) {
                header.classList.add('scroll');
            } else {
                header.classList.remove('scroll');
            }
        }

        checkScroll();

        window.addEventListener('scroll', checkScroll);
    });

    document.addEventListener('DOMContentLoaded', function() {
        const openMenuButtons = document.querySelectorAll('.openMenu');
        const headerMenu = document.querySelector('.header__menu');
        const header = document.querySelector('header');
        const body = document.querySelector('body');

        if (!headerMenu) return;

        // Открытие меню
        function openMenu() {
            headerMenu.classList.add('open');
            if (header) header.classList.add('open');
            if (body) body.classList.add('open');
        }

        // Закрытие меню
        function closeMenu() {
            headerMenu.classList.remove('open');
            if (header) header.classList.remove('open');
            if (body) body.classList.remove('open');
        }

        // Переключение меню (для повторного клика)
        function toggleMenu(event) {
            // Предотвращаем всплытие события, чтобы не сработал document click
            event.stopPropagation();

            if (headerMenu.classList.contains('open')) {
                closeMenu();
            } else {
                openMenu();
            }
        }

        // Добавляем обработчики на кнопки открытия/закрытия
        openMenuButtons.forEach(button => {
            button.addEventListener('click', toggleMenu);
        });

        // Закрытие по клику вне меню
        document.addEventListener('click', function(event) {
            // Проверяем, что клик был не по кнопке openMenu и не по меню
            if (!headerMenu.contains(event.target) &&
                !event.target.closest('.openMenu') &&
                headerMenu.classList.contains('open')) {
                closeMenu();
            }
        });

        // Закрытие по клавише ESC
        document.addEventListener('keydown', function(event) {
            if (event.key === 'Escape' && headerMenu.classList.contains('open')) {
                closeMenu();
            }
        });

        // Закрытие по кнопке закрытия внутри меню (если есть)
        const closeButton = headerMenu.querySelector('.close-menu');
        if (closeButton) {
            closeButton.addEventListener('click', function(event) {
                event.stopPropagation();
                closeMenu();
            });
        }
    });

    document.addEventListener('DOMContentLoaded', function() {
        const tabs = document.querySelectorAll('.header__menu_tabs .tab');
        const tabPanels = document.querySelectorAll('.header__menu_content .tabPanel');

        // Функция для активации таба
        function activateTab(index) {
            // Убираем активный класс у всех табов и панелей
            tabs.forEach(tab => tab.classList.remove('active'));
            tabPanels.forEach(panel => panel.classList.remove('active'));

            // Добавляем активный класс нужному табу и панели
            tabs[index].classList.add('active');
            if (tabPanels[index]) {
                tabPanels[index].classList.add('active');
            }
        }

        // Добавляем обработчики на каждый таб
        tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => {
                activateTab(index);
            });
        });
    });


    document.addEventListener('DOMContentLoaded', function() {
        const openMenuButtonsMob = document.querySelectorAll('.openMenuMob');
        const headerMenuMob = document.querySelector('.MenuMobile');
        const bodyMob = document.querySelector('body');

        if (!headerMenuMob) return;

        // Открытие меню
        function openMenuMob() {
            headerMenuMob.classList.add('open');
            if (bodyMob) bodyMob.classList.add('open');
        }

        // Закрытие меню
        function closeMenuMob() {
            headerMenuMob.classList.remove('open');
            if (bodyMob) bodyMob.classList.remove('open');
        }

        // Переключение меню (для повторного клика)
        function toggleMenuMob(event) {
            // Предотвращаем всплытие события, чтобы не сработал document click
            event.stopPropagation();

            if (headerMenuMob.classList.contains('open')) {
                closeMenuMob();
            } else {
                openMenuMob();
            }
        }

        // Добавляем обработчики на кнопки открытия/закрытия
        openMenuButtonsMob.forEach(button => {
            button.addEventListener('click', toggleMenuMob);
        });

        // Закрытие по клику вне меню
        document.addEventListener('click', function(event) {
            // Проверяем, что клик был не по кнопке openMenu и не по меню
            if (!headerMenuMob.contains(event.target) &&
                !event.target.closest('.openMenuMob') &&
                headerMenuMob.classList.contains('open')) {
                closeMenuMob();
            }
        });

        // Закрытие по клавише ESC
        document.addEventListener('keydown', function(event) {
            if (event.key === 'Escape' && headerMenuMob.classList.contains('open')) {
                closeMenuMob();
            }
        });

        // Закрытие по кнопке закрытия внутри меню (если есть)
        const closeButton = headerMenuMob.querySelector('.closeMenuMob');
        if (closeButton) {
            closeButton.addEventListener('click', function(event) {
                event.stopPropagation();
                closeMenuMob();
            });
        }
    });

    !function(e,t){if("object"==typeof exports&&"object"==typeof module)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else {var n=t();for(var o in n)("object"==typeof exports?exports:e)[o]=n[o];}}(window,(function(){return function(e){var t={};function n(o){if(t[o])return t[o].exports;var i=t[o]={i:o,l:false,exports:{}};return e[o].call(i.exports,i,i.exports,n),i.l=true,i.exports}return n.m=e,n.c=t,n.d=function(e,t,o){n.o(e,t)||Object.defineProperty(e,t,{enumerable:true,get:o});},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:true});},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var o=Object.create(null);if(n.r(o),Object.defineProperty(o,"default",{enumerable:true,value:e}),2&t&&"string"!=typeof e)for(var i in e)n.d(o,i,function(t){return e[t]}.bind(null,i));return o},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=0)}([function(e,t,n){n.r(t);var o,i="fslightbox-",r="".concat(i,"styles"),s="".concat(i,"cursor-grabbing"),a="".concat(i,"full-dimension"),c="".concat(i,"flex-centered"),l="".concat(i,"open"),u="".concat(i,"transform-transition"),d="".concat(i,"absoluted"),f="".concat(i,"slide-btn"),p="".concat(f,"-container"),h="".concat(i,"fade-in"),m="".concat(i,"fade-out"),g=h+"-strong",v=m+"-strong",b="".concat(i,"opacity-"),x="".concat(b,"1"),y="".concat(i,"source");function w(e){return (w="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function S(e){var t=e.stageIndexes,n=e.core.stageManager,o=e.props.sources.length-1;n.getPreviousSlideIndex=function(){return 0===t.current?o:t.current-1},n.getNextSlideIndex=function(){return t.current===o?0:t.current+1},n.updateStageIndexes=0===o?function(){}:1===o?function(){0===t.current?(t.next=1,delete t.previous):(t.previous=0,delete t.next);}:function(){t.previous=n.getPreviousSlideIndex(),t.next=n.getNextSlideIndex();},n.i=o<=2?function(){return  true}:function(e){var n=t.current;if(0===n&&e===o||n===o&&0===e)return  true;var i=n-e;return  -1===i||0===i||1===i};}"object"===("undefined"==typeof document?"undefined":w(document))&&((o=document.createElement("style")).className=r,o.appendChild(document.createTextNode(".fslightbox-absoluted{position:absolute;top:0;left:0}.fslightbox-fade-in{animation:fslightbox-fade-in .3s cubic-bezier(0,0,.7,1)}.fslightbox-fade-out{animation:fslightbox-fade-out .3s ease}.fslightbox-fade-in-strong{animation:fslightbox-fade-in-strong .3s cubic-bezier(0,0,.7,1)}.fslightbox-fade-out-strong{animation:fslightbox-fade-out-strong .3s ease}@keyframes fslightbox-fade-in{from{opacity:.65}to{opacity:1}}@keyframes fslightbox-fade-out{from{opacity:.35}to{opacity:0}}@keyframes fslightbox-fade-in-strong{from{opacity:.3}to{opacity:1}}@keyframes fslightbox-fade-out-strong{from{opacity:1}to{opacity:0}}.fslightbox-cursor-grabbing{cursor:grabbing}.fslightbox-full-dimension{width:100%;height:100%}.fslightbox-open{overflow:hidden;height:100%}.fslightbox-flex-centered{display:flex;justify-content:center;align-items:center}.fslightbox-opacity-0{opacity:0!important}.fslightbox-opacity-1{opacity:1!important}.fslightbox-scrollbarfix{padding-right:17px}.fslightbox-transform-transition{transition:transform .3s}.fslightbox-container{font-family:Arial,sans-serif;position:fixed;top:0;left:0;background:linear-gradient(rgba(30,30,30,.9),#000 1810%);touch-action:pinch-zoom;z-index:1000000000;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-tap-highlight-color:transparent}.fslightbox-container *{box-sizing:border-box}.fslightbox-svg-path{transition:fill .15s ease;fill:#ddd}.fslightbox-nav{height:45px;width:100%;position:absolute;top:0;left:0}.fslightbox-slide-number-container{display:flex;justify-content:center;align-items:center;position:relative;height:100%;font-size:15px;color:#d7d7d7;z-index:0;max-width:55px;text-align:left}.fslightbox-slide-number-container .fslightbox-flex-centered{height:100%}.fslightbox-slash{display:block;margin:0 5px;width:1px;height:12px;transform:rotate(15deg);background:#fff}.fslightbox-toolbar{position:absolute;z-index:3;right:0;top:0;height:100%;display:flex;background:rgba(35,35,35,.65)}.fslightbox-toolbar-button{height:100%;width:45px;cursor:pointer}.fslightbox-toolbar-button:hover .fslightbox-svg-path{fill:#fff}.fslightbox-slide-btn-container{display:flex;align-items:center;padding:12px 12px 12px 6px;position:absolute;top:50%;cursor:pointer;z-index:3;transform:translateY(-50%)}@media (min-width:476px){.fslightbox-slide-btn-container{padding:22px 22px 22px 6px}}@media (min-width:768px){.fslightbox-slide-btn-container{padding:30px 30px 30px 6px}}.fslightbox-slide-btn-container:hover .fslightbox-svg-path{fill:#f1f1f1}.fslightbox-slide-btn{padding:9px;font-size:26px;background:rgba(35,35,35,.65)}@media (min-width:768px){.fslightbox-slide-btn{padding:10px}}@media (min-width:1600px){.fslightbox-slide-btn{padding:11px}}.fslightbox-slide-btn-container-previous{left:0}@media (max-width:475.99px){.fslightbox-slide-btn-container-previous{padding-left:3px}}.fslightbox-slide-btn-container-next{right:0;padding-left:12px;padding-right:3px}@media (min-width:476px){.fslightbox-slide-btn-container-next{padding-left:22px}}@media (min-width:768px){.fslightbox-slide-btn-container-next{padding-left:30px}}@media (min-width:476px){.fslightbox-slide-btn-container-next{padding-right:6px}}.fslightbox-down-event-detector{position:absolute;z-index:1}.fslightbox-slide-swiping-hoverer{z-index:4}.fslightbox-invalid-file-wrapper{font-size:22px;color:#eaebeb;margin:auto}.fslightbox-video{object-fit:cover}.fslightbox-youtube-iframe{border:0}.fslightboxl{display:block;margin:auto;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:67px;height:67px}.fslightboxl div{box-sizing:border-box;display:block;position:absolute;width:54px;height:54px;margin:6px;border:5px solid;border-color:#999 transparent transparent transparent;border-radius:50%;animation:fslightboxl 1.2s cubic-bezier(.5,0,.5,1) infinite}.fslightboxl div:nth-child(1){animation-delay:-.45s}.fslightboxl div:nth-child(2){animation-delay:-.3s}.fslightboxl div:nth-child(3){animation-delay:-.15s}@keyframes fslightboxl{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}.fslightbox-source{position:relative;z-index:2;opacity:0}")),document.head.appendChild(o));function L(e){var t,n=e.props,o=0,i={};this.getSourceTypeFromLocalStorageByUrl=function(e){return t[e]?t[e]:r(e)},this.handleReceivedSourceTypeForUrl=function(e,n){if(false===i[n]&&(o--,"invalid"!==e?i[n]=e:delete i[n],0===o)){!function(e,t){for(var n in t)e[n]=t[n];}(t,i);try{localStorage.setItem("fslightbox-types",JSON.stringify(t));}catch(e){}}};var r=function(e){o++,i[e]=false;};if(n.disableLocalStorage)this.getSourceTypeFromLocalStorageByUrl=function(){},this.handleReceivedSourceTypeForUrl=function(){};else {try{t=JSON.parse(localStorage.getItem("fslightbox-types"));}catch(e){}t||(t={},this.getSourceTypeFromLocalStorageByUrl=r);}}function A(e,t,n,o){var i=e.data,r=e.elements.sources,s=n/o,a=0;this.adjustSize=function(){if((a=i.maxSourceWidth/s)<i.maxSourceHeight)return n<i.maxSourceWidth&&(a=o),c();a=o>i.maxSourceHeight?i.maxSourceHeight:o,c();};var c=function(){r[t].style.width=a*s+"px",r[t].style.height=a+"px";};}function C(e,t){var n=this,o=e.collections.sourceSizers,i=e.elements,r=i.sourceAnimationWrappers,s=i.sources,a=e.isl,c=e.resolve;function l(e,n){o[t]=c(A,[t,e,n]),o[t].adjustSize();}this.runActions=function(e,o){a[t]=true,s[t].classList.add(x),r[t].classList.add(g),r[t].removeChild(r[t].firstChild),l(e,o),n.runActions=l;};}function E(e,t){var n,o=this,i=e.elements.sources,r=e.props,s=(0, e.resolve)(C,[t]);this.handleImageLoad=function(e){var t=e.target,n=t.naturalWidth,o=t.naturalHeight;s.runActions(n,o);},this.handleVideoLoad=function(e){var t=e.target,o=t.videoWidth,i=t.videoHeight;n=true,s.runActions(o,i);},this.handleNotMetaDatedVideoLoad=function(){n||o.handleYoutubeLoad();},this.handleYoutubeLoad=function(){var e=1920,t=1080;r.maxYoutubeDimensions&&(e=r.maxYoutubeDimensions.width,t=r.maxYoutubeDimensions.height),s.runActions(e,t);},this.handleCustomLoad=function(){var e=i[t],n=e.offsetWidth,r=e.offsetHeight;n&&r?s.runActions(n,r):setTimeout(o.handleCustomLoad);};}function F(e,t,n){var o=e.elements.sources,i=e.props.customClasses,r=i[t]?i[t]:"";o[t].className=n+" "+r;}function I(e,t){var n=e.elements.sources,o=e.props.customAttributes;for(var i in o[t])n[t].setAttribute(i,o[t][i]);}function T(e,t){var n=e.collections.sourceLoadHandlers,o=e.elements,i=o.sources,r=o.sourceAnimationWrappers,s=e.props.sources;i[t]=document.createElement("img"),F(e,t,y),i[t].src=s[t],i[t].onload=n[t].handleImageLoad,I(e,t),r[t].appendChild(i[t]);}function N(e,t){var n=e.collections.sourceLoadHandlers,o=e.elements,i=o.sources,r=o.sourceAnimationWrappers,s=e.props,a=s.sources,c=s.videosPosters;i[t]=document.createElement("video"),F(e,t,y),i[t].src=a[t],i[t].onloadedmetadata=function(e){n[t].handleVideoLoad(e);},i[t].controls=true,I(e,t),c[t]&&(i[t].poster=c[t]);var l=document.createElement("source");l.src=a[t],i[t].appendChild(l),setTimeout(n[t].handleNotMetaDatedVideoLoad,3e3),r[t].appendChild(i[t]);}function z(e,t){var n=e.collections.sourceLoadHandlers,o=e.elements,r=o.sources,s=o.sourceAnimationWrappers,a=e.props.sources;r[t]=document.createElement("iframe"),F(e,t,"".concat(y," ").concat(i,"youtube-iframe"));var c=a[t],l=c.split("?")[1];r[t].src="https://www.youtube.com/embed/".concat(c.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/)[2],"?").concat(l||""),r[t].allowFullscreen=true,I(e,t),s[t].appendChild(r[t]),n[t].handleYoutubeLoad();}function P(e,t){var n=e.collections.sourceLoadHandlers,o=e.elements,i=o.sources,r=o.sourceAnimationWrappers,s=e.props.sources;i[t]=s[t],F(e,t,"".concat(i[t].className," ").concat(y)),r[t].appendChild(i[t]),n[t].handleCustomLoad();}function k(e,t){var n=e.elements,o=n.sources,r=n.sourceAnimationWrappers;e.props.sources;o[t]=document.createElement("div"),o[t].className="".concat(i,"invalid-file-wrapper ").concat(c),o[t].innerHTML="Invalid source",r[t].classList.add(g),r[t].removeChild(r[t].firstChild),r[t].appendChild(o[t]);}function H(e){var t=e.collections,n=t.sourceLoadHandlers,o=t.sourcesRenderFunctions,i=e.core.sourceDisplayFacade,r=e.resolve;this.runActionsForSourceTypeAndIndex=function(t,s){var a;switch("invalid"!==t&&(n[s]=r(E,[s])),t){case "image":a=T;break;case "video":a=N;break;case "youtube":a=z;break;case "custom":a=P;break;default:a=k;}o[s]=function(){return a(e,s)},i.displaySourcesWhichShouldBeDisplayed();};}function W(){var e,t,n,o={isUrlYoutubeOne:function(e){var t=document.createElement("a");return t.href=e,"www.youtube.com"===t.hostname||"youtu.be"===t.hostname},getTypeFromResponseContentType:function(e){return e.slice(0,e.indexOf("/"))}};function i(){if(4!==n.readyState){if(2===n.readyState){var e;switch(o.getTypeFromResponseContentType(n.getResponseHeader("content-type"))){case "image":e="image";break;case "video":e="video";break;default:e="invalid";}n.onreadystatechange=null,n.abort(),t(e);}}else t("invalid");}this.setUrlToCheck=function(t){e=t;},this.getSourceType=function(r){if(o.isUrlYoutubeOne(e))return r("youtube");t=r,(n=new XMLHttpRequest).onreadystatechange=i,n.open("GET",e,true),n.send();};}function R(e,t,n){var o=e.props,i=o.types,r=o.type,s=o.sources,a=e.resolve;this.getTypeSetByClientForIndex=function(e){var t;return i&&i[e]?t=i[e]:r&&(t=r),t},this.retrieveTypeWithXhrForIndex=function(e){var o=a(W);o.setUrlToCheck(s[e]),o.getSourceType((function(o){t.handleReceivedSourceTypeForUrl(o,s[e]),n.runActionsForSourceTypeAndIndex(o,e);}));};}function D(e,t){var n=e.core.stageManager,o=e.elements,i=o.smw,r=o.sourceWrappersContainer,s=e.props,l=0,f=document.createElement("div");function p(e){f.style.transform="translateX(".concat(e+l,"px)"),l=0;}function h(){return (1+s.slideDistance)*innerWidth}f.className="".concat(d," ").concat(a," ").concat(c),f.s=function(){f.style.display="flex";},f.h=function(){f.style.display="none";},f.a=function(){f.classList.add(u);},f.d=function(){f.classList.remove(u);},f.n=function(){f.style.removeProperty("transform");},f.v=function(e){return l=e,f},f.ne=function(){p(-h());},f.z=function(){p(0);},f.p=function(){p(h());},n.i(t)||f.h(),i[t]=f,r.appendChild(f),function(e,t){var n=e.elements,o=n.smw,i=n.sourceAnimationWrappers,r=document.createElement("div"),s=document.createElement("div");s.className="fslightboxl";for(var a=0;a<3;a++){var c=document.createElement("div");s.appendChild(c);}r.appendChild(s),o[t].appendChild(r),i[t]=r;}(e,t);}function O(e,t,n,o){var r=document.createElementNS("http://www.w3.org/2000/svg","svg");r.setAttributeNS(null,"width",t),r.setAttributeNS(null,"height",t),r.setAttributeNS(null,"viewBox",n);var s=document.createElementNS("http://www.w3.org/2000/svg","path");return s.setAttributeNS(null,"class","".concat(i,"svg-path")),s.setAttributeNS(null,"d",o),r.appendChild(s),e.appendChild(r),r}function M(e,t){var n=document.createElement("div");return n.className="".concat(i,"toolbar-button ").concat(c),n.title=t,e.appendChild(n),n}function j(e,t){var n=document.createElement("div");n.className="".concat(i,"toolbar"),t.appendChild(n),function(e,t){var n=e.componentsServices,o=e.data,i=e.fs,r="M4.5 11H3v4h4v-1.5H4.5V11zM3 7h1.5V4.5H7V3H3v4zm10.5 6.5H11V15h4v-4h-1.5v2.5zM11 3v1.5h2.5V7H15V3h-4z",s=M(t);s.title="Enter fullscreen";var a=O(s,"20px","0 0 18 18",r);n.ofs=function(){o.ifs=true,s.title="Exit fullscreen",a.setAttributeNS(null,"width","24px"),a.setAttributeNS(null,"height","24px"),a.setAttributeNS(null,"viewBox","0 0 950 1024"),a.firstChild.setAttributeNS(null,"d","M682 342h128v84h-212v-212h84v128zM598 810v-212h212v84h-128v128h-84zM342 342v-128h84v212h-212v-84h128zM214 682v-84h212v212h-84v-128h-128z");},n.xfs=function(){o.ifs=false,s.title="Enter fullscreen",a.setAttributeNS(null,"width","20px"),a.setAttributeNS(null,"height","20px"),a.setAttributeNS(null,"viewBox","0 0 18 18"),a.firstChild.setAttributeNS(null,"d",r);},s.onclick=i.t;}(e,n),function(e,t){var n=M(t,"Close");n.onclick=e.core.lightboxCloser.closeLightbox,O(n,"20px","0 0 24 24","M 4.7070312 3.2929688 L 3.2929688 4.7070312 L 10.585938 12 L 3.2929688 19.292969 L 4.7070312 20.707031 L 12 13.414062 L 19.292969 20.707031 L 20.707031 19.292969 L 13.414062 12 L 20.707031 4.7070312 L 19.292969 3.2929688 L 12 10.585938 L 4.7070312 3.2929688 z");}(e,n);}function X(e){var t=e.props.sources,n=e.elements.container,o=document.createElement("div");o.className="".concat(i,"nav"),n.appendChild(o),j(e,o),t.length>1&&function(e,t){var n=e.componentsServices,o=e.props.sources,r=(e.stageIndexes,document.createElement("div"));r.className="".concat(i,"slide-number-container");var s=document.createElement("div");s.className=c;var a=document.createElement("span");n.setSlideNumber=function(e){return a.innerHTML=e};var l=document.createElement("span");l.className="".concat(i,"slash");var u=document.createElement("div");u.innerHTML=o.length,r.appendChild(s),s.appendChild(a),s.appendChild(l),s.appendChild(u),t.appendChild(r),setTimeout((function(){s.offsetWidth>55&&(r.style.justifyContent="flex-start");}));}(e,o);}function B(e,t,n,o){var i=e.elements.container,r=n.charAt(0).toUpperCase()+n.slice(1),s=document.createElement("div");s.className="".concat(p," ").concat(p,"-").concat(n),s.title="".concat(r," slide"),s.onclick=t,function(e,t){var n=document.createElement("div");n.className="".concat(f," ").concat(c),O(n,"20px","0 0 20 20",t),e.appendChild(n);}(s,o),i.appendChild(s);}function U(e){var t=e.core,n=t.lightboxCloser,o=t.slideChangeFacade,i=e.fs;this.listener=function(e){switch(e.key){case "Escape":n.closeLightbox();break;case "ArrowLeft":o.changeToPrevious();break;case "ArrowRight":o.changeToNext();break;case "F11":e.preventDefault(),i.t();}};}function q(e){var t=e.elements,n=e.sourcePointerProps,o=e.stageIndexes;function i(e,o){t.smw[e].v(n.swipedX)[o]();}this.runActionsForEvent=function(e){var r,a,c;t.container.contains(t.slideSwipingHoverer)||t.container.appendChild(t.slideSwipingHoverer),r=t.container,a=s,(c=r.classList).contains(a)||c.add(a),n.swipedX=e.screenX-n.downScreenX;var l=o.previous,u=o.next;i(o.current,"z"),void 0!==l&&n.swipedX>0?i(l,"ne"):void 0!==u&&n.swipedX<0&&i(u,"p");};}function V(e){var t=e.props.sources,n=e.resolve,o=e.sourcePointerProps,i=n(q);1===t.length?this.listener=function(){o.swipedX=1;}:this.listener=function(e){o.isPointering&&i.runActionsForEvent(e);};}function _(e){var t=e.core.slideIndexChanger,n=e.elements.smw,o=e.stageIndexes,i=e.sws;function r(e){var t=n[o.current];t.a(),t[e]();}function s(e,t){ void 0!==e&&(n[e].s(),n[e][t]());}this.runPositiveSwipedXActions=function(){var e=o.previous;if(void 0===e)r("z");else {r("p");var n=o.next;t.changeTo(e);var a=o.previous;i.d(a),i.b(n),r("z"),s(a,"ne");}},this.runNegativeSwipedXActions=function(){var e=o.next;if(void 0===e)r("z");else {r("ne");var n=o.previous;t.changeTo(e);var a=o.next;i.d(a),i.b(n),r("z"),s(a,"p");}};}function Y(e,t){e.contains(t)&&e.removeChild(t);}function J(e){var t=e.core.lightboxCloser,n=e.elements,o=e.resolve,i=e.sourcePointerProps,r=o(_);this.runNoSwipeActions=function(){Y(n.container,n.slideSwipingHoverer),i.isSourceDownEventTarget||t.closeLightbox(),i.isPointering=false;},this.runActions=function(){i.swipedX>0?r.runPositiveSwipedXActions():r.runNegativeSwipedXActions(),Y(n.container,n.slideSwipingHoverer),n.container.classList.remove(s),i.isPointering=false;};}function G(e){var t=e.resolve,n=e.sourcePointerProps,o=t(J);this.listener=function(){n.isPointering&&(n.swipedX?o.runActions():o.runNoSwipeActions());};}function $(e){var t=this,n=e.core,o=n.eventsDispatcher,i=n.globalEventsController,r=n.scrollbarRecompensor,s=e.data,a=e.elements,c=e.fs,u=e.props,d=e.sourcePointerProps;this.isLightboxFadingOut=false,this.runActions=function(){t.isLightboxFadingOut=true,a.container.classList.add(v),i.removeListeners(),u.exitFullscreenOnClose&&s.ifs&&c.x(),setTimeout((function(){t.isLightboxFadingOut=false,d.isPointering=false,a.container.classList.remove(v),document.documentElement.classList.remove(l),r.removeRecompense(),document.body.removeChild(a.container),o.dispatch("onClose");}),270);};}function K(e,t){var n=e.classList;n.contains(t)&&n.remove(t);}function Q(e){var t,n,o;n=(t=e).core.eventsDispatcher,o=t.props,n.dispatch=function(e){o[e]&&o[e]();},function(e){var t=e.componentsServices,n=e.data,o=e.fs,i=["fullscreenchange","webkitfullscreenchange","mozfullscreenchange","MSFullscreenChange"];function r(e){for(var t=0;t<i.length;t++)document[e](i[t],s);}function s(){document.fullscreenElement||document.webkitIsFullScreen||document.mozFullScreen||document.msFullscreenElement?t.ofs():t.xfs();}o.o=function(){t.ofs();var e=document.documentElement;e.requestFullscreen?e.requestFullscreen():e.mozRequestFullScreen?e.mozRequestFullScreen():e.webkitRequestFullscreen?e.webkitRequestFullscreen():e.msRequestFullscreen&&e.msRequestFullscreen();},o.x=function(){t.xfs(),document.exitFullscreen?document.exitFullscreen():document.mozCancelFullScreen?document.mozCancelFullScreen():document.webkitExitFullscreen?document.webkitExitFullscreen():document.msExitFullscreen&&document.msExitFullscreen();},o.t=function(){n.ifs?o.x():o.o();},o.l=function(){r("addEventListener");},o.q=function(){r("removeEventListener");};}(e),function(e){var t=e.core,n=t.globalEventsController,o=t.windowResizeActioner,i=e.fs,r=e.resolve,s=r(U),a=r(V),c=r(G);n.attachListeners=function(){document.addEventListener("pointermove",a.listener),document.addEventListener("pointerup",c.listener),addEventListener("resize",o.runActions),document.addEventListener("keydown",s.listener),i.l();},n.removeListeners=function(){document.removeEventListener("pointermove",a.listener),document.removeEventListener("pointerup",c.listener),removeEventListener("resize",o.runActions),document.removeEventListener("keydown",s.listener),i.q();};}(e),function(e){var t=e.core.lightboxCloser,n=(0, e.resolve)($);t.closeLightbox=function(){n.isLightboxFadingOut||n.runActions();};}(e),function(e){var t=e.data,n=e.core.scrollbarRecompensor;function o(){document.body.offsetHeight>innerHeight&&(document.body.style.marginRight=t.scrollbarWidth+"px");}n.addRecompense=function(){"complete"===document.readyState?o():addEventListener("load",(function(){o(),n.addRecompense=o;}));},n.removeRecompense=function(){document.body.style.removeProperty("margin-right");};}(e),function(e){var t=e.core,n=t.slideChangeFacade,o=t.slideIndexChanger,i=t.stageManager;e.props.sources.length>1?(n.changeToPrevious=function(){o.jumpTo(i.getPreviousSlideIndex());},n.changeToNext=function(){o.jumpTo(i.getNextSlideIndex());}):(n.changeToPrevious=function(){},n.changeToNext=function(){});}(e),function(e){var t=e.componentsServices,n=e.core,o=n.slideIndexChanger,i=n.sourceDisplayFacade,r=n.stageManager,s=e.elements,a=s.smw,c=s.sourceAnimationWrappers,l=e.isl,u=e.stageIndexes,d=e.sws;o.changeTo=function(e){u.current=e,r.updateStageIndexes(),t.setSlideNumber(e+1),i.displaySourcesWhichShouldBeDisplayed();},o.jumpTo=function(e){var t=u.previous,n=u.current,i=u.next,s=l[n],f=l[e];o.changeTo(e);for(var p=0;p<a.length;p++)a[p].d();d.d(n),d.c(),requestAnimationFrame((function(){requestAnimationFrame((function(){var e=u.previous,o=u.next;function p(){r.i(n)?n===u.previous?a[n].ne():n===u.next&&a[n].p():(a[n].h(),a[n].n());}s&&c[n].classList.add(m),f&&c[u.current].classList.add(h),d.a(),void 0!==e&&e!==n&&a[e].ne(),a[u.current].n(),void 0!==o&&o!==n&&a[o].p(),d.b(t),d.b(i),l[n]?setTimeout(p,260):p();}));}));};}(e),function(e){var t=e.core.sourcesPointerDown,n=e.elements,o=n.smw,i=n.sources,r=e.sourcePointerProps,s=e.stageIndexes;t.listener=function(e){"VIDEO"!==e.target.tagName&&e.preventDefault(),r.isPointering=true,r.downScreenX=e.screenX,r.swipedX=0;var t=i[s.current];t&&t.contains(e.target)?r.isSourceDownEventTarget=true:r.isSourceDownEventTarget=false;for(var n=0;n<o.length;n++)o[n].d();};}(e),function(e){var t=e.collections.sourcesRenderFunctions,n=e.core.sourceDisplayFacade,o=e.props,i=e.stageIndexes;function r(e){t[e]&&(t[e](),delete t[e]);}n.displaySourcesWhichShouldBeDisplayed=function(){if(o.loadOnlyCurrentSource)r(i.current);else for(var e in i)r(i[e]);};}(e),function(e){var t=e.core.stageManager,n=e.elements,o=n.smw,i=n.sourceAnimationWrappers,r=e.isl,s=e.stageIndexes,a=e.sws;a.a=function(){for(var e in s)o[s[e]].s();},a.b=function(e){ void 0===e||t.i(e)||(o[e].h(),o[e].n());},a.c=function(){for(var e in s)a.d(s[e]);},a.d=function(e){if(r[e]){var t=i[e];K(t,g),K(t,h),K(t,m);}};}(e),function(e){var t=e.collections.sourceSizers,n=e.core.windowResizeActioner,o=e.data,i=e.elements.smw,r=e.stageIndexes;n.runActions=function(){innerWidth<992?o.maxSourceWidth=innerWidth:o.maxSourceWidth=.9*innerWidth,o.maxSourceHeight=.9*innerHeight;for(var e=0;e<i.length;e++)i[e].d(),t[e]&&t[e].adjustSize();var n=r.previous,s=r.next;void 0!==n&&i[n].ne(),void 0!==s&&i[s].p();};}(e);}function Z(e){var t=e.componentsServices,n=e.core,o=n.eventsDispatcher,r=n.globalEventsController,s=n.scrollbarRecompensor,c=n.sourceDisplayFacade,u=n.stageManager,f=n.windowResizeActioner,p=e.data,h=e.elements,m=(e.props,e.stageIndexes),v=e.sws;function b(){var t,n;p.i=true,p.scrollbarWidth=function(){var e=document.createElement("div"),t=e.style,n=document.createElement("div");t.visibility="hidden",t.width="100px",t.msOverflowStyle="scrollbar",t.overflow="scroll",n.style.width="100%",document.body.appendChild(e);var o=e.offsetWidth;e.appendChild(n);var i=n.offsetWidth;return document.body.removeChild(e),o-i}(),Q(e),h.container=document.createElement("div"),h.container.className="".concat(i,"container ").concat(a," ").concat(g),function(e){var t=e.elements;t.slideSwipingHoverer=document.createElement("div"),t.slideSwipingHoverer.className="".concat(i,"slide-swiping-hoverer ").concat(a," ").concat(d);}(e),X(e),function(e){var t=e.core.sourcesPointerDown,n=e.elements,o=e.props.sources,i=document.createElement("div");i.className="".concat(d," ").concat(a),n.container.appendChild(i),i.addEventListener("pointerdown",t.listener),n.sourceWrappersContainer=i;for(var r=0;r<o.length;r++)D(e,r);}(e),e.props.sources.length>1&&(n=(t=e).core.slideChangeFacade,B(t,n.changeToPrevious,"previous","M18.271,9.212H3.615l4.184-4.184c0.306-0.306,0.306-0.801,0-1.107c-0.306-0.306-0.801-0.306-1.107,0L1.21,9.403C1.194,9.417,1.174,9.421,1.158,9.437c-0.181,0.181-0.242,0.425-0.209,0.66c0.005,0.038,0.012,0.071,0.022,0.109c0.028,0.098,0.075,0.188,0.142,0.271c0.021,0.026,0.021,0.061,0.045,0.085c0.015,0.016,0.034,0.02,0.05,0.033l5.484,5.483c0.306,0.307,0.801,0.307,1.107,0c0.306-0.305,0.306-0.801,0-1.105l-4.184-4.185h14.656c0.436,0,0.788-0.353,0.788-0.788S18.707,9.212,18.271,9.212z"),B(t,n.changeToNext,"next","M1.729,9.212h14.656l-4.184-4.184c-0.307-0.306-0.307-0.801,0-1.107c0.305-0.306,0.801-0.306,1.106,0l5.481,5.482c0.018,0.014,0.037,0.019,0.053,0.034c0.181,0.181,0.242,0.425,0.209,0.66c-0.004,0.038-0.012,0.071-0.021,0.109c-0.028,0.098-0.075,0.188-0.143,0.271c-0.021,0.026-0.021,0.061-0.045,0.085c-0.015,0.016-0.034,0.02-0.051,0.033l-5.483,5.483c-0.306,0.307-0.802,0.307-1.106,0c-0.307-0.305-0.307-0.801,0-1.105l4.184-4.185H1.729c-0.436,0-0.788-0.353-0.788-0.788S1.293,9.212,1.729,9.212z")),function(e){for(var t=e.props.sources,n=e.resolve,o=n(L),i=n(H),r=n(R,[o,i]),s=0;s<t.length;s++)if("string"==typeof t[s]){var a=r.getTypeSetByClientForIndex(s);if(a)i.runActionsForSourceTypeAndIndex(a,s);else {var c=o.getSourceTypeFromLocalStorageByUrl(t[s]);c?i.runActionsForSourceTypeAndIndex(c,s):r.retrieveTypeWithXhrForIndex(s);}}else i.runActionsForSourceTypeAndIndex("custom",s);}(e),o.dispatch("onInit");}e.open=function(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,i=m.previous,a=m.current,d=m.next;m.current=n,p.i||S(e),u.updateStageIndexes(),p.i?(v.c(),v.a(),v.b(i),v.b(a),v.b(d),o.dispatch("onShow")):b(),c.displaySourcesWhichShouldBeDisplayed(),t.setSlideNumber(n+1),document.body.appendChild(h.container),document.documentElement.classList.add(l),s.addRecompense(),r.attachListeners(),f.runActions(),h.smw[m.current].n(),o.dispatch("onOpen");};}function ee(e,t,n){return (ee=te()?Reflect.construct.bind():function(e,t,n){var o=[null];o.push.apply(o,t);var i=new(Function.bind.apply(e,o));return n&&ne(i,n.prototype),i}).apply(null,arguments)}function te(){if("undefined"==typeof Reflect||!Reflect.construct)return  false;if(Reflect.construct.sham)return  false;if("function"==typeof Proxy)return  true;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return  false}}function ne(e,t){return (ne=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(e,t){return e.__proto__=t,e})(e,t)}function oe(e){return function(e){if(Array.isArray(e))return ie(e)}(e)||function(e){if("undefined"!=typeof Symbol&&null!=e[Symbol.iterator]||null!=e["@@iterator"])return Array.from(e)}(e)||function(e,t){if(!e)return;if("string"==typeof e)return ie(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);"Object"===n&&e.constructor&&(n=e.constructor.name);if("Map"===n||"Set"===n)return Array.from(e);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return ie(e,t)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function ie(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,o=new Array(t);n<t;n++)o[n]=e[n];return o}function re(){for(var e=document.getElementsByTagName("a"),t=function(t){if(!e[t].hasAttribute("data-fslightbox"))return "continue";var n=e[t].hasAttribute("data-href")?e[t].getAttribute("data-href"):e[t].getAttribute("href");if(!n)return console.warn('The "data-fslightbox" attribute was set without the "href" attribute.'),"continue";var o=e[t].getAttribute("data-fslightbox");fsLightboxInstances[o]||(fsLightboxInstances[o]=new FsLightbox);var i=null;"#"===n.charAt(0)?(i=document.getElementById(n.substring(1)).cloneNode(true)).removeAttribute("id"):i=n,fsLightboxInstances[o].props.sources.push(i),fsLightboxInstances[o].elements.a.push(e[t]);var r=fsLightboxInstances[o].props.sources.length-1;e[t].onclick=function(e){e.preventDefault(),fsLightboxInstances[o].open(r);},d("types","data-type"),d("videosPosters","data-video-poster"),d("customClasses","data-class"),d("customClasses","data-custom-class");for(var s=["href","data-fslightbox","data-href","data-type","data-video-poster","data-class","data-custom-class"],a=e[t].attributes,c=fsLightboxInstances[o].props.customAttributes,l=0;l<a.length;l++)if(-1===s.indexOf(a[l].name)&&"data-"===a[l].name.substr(0,5)){c[r]||(c[r]={});var u=a[l].name.substr(5);c[r][u]=a[l].value;}function d(n,i){e[t].hasAttribute(i)&&(fsLightboxInstances[o].props[n][r]=e[t].getAttribute(i));}},n=0;n<e.length;n++)t(n);var o=Object.keys(fsLightboxInstances);window.fsLightbox=fsLightboxInstances[o[o.length-1]];}window.FsLightbox=function(){var e=this;this.props={sources:[],customAttributes:[],customClasses:[],types:[],videosPosters:[],slideDistance:.3},this.data={isFullscreenOpen:false,maxSourceWidth:0,maxSourceHeight:0,scrollbarWidth:0},this.isl=[],this.sourcePointerProps={downScreenX:null,isPointering:false,isSourceDownEventTarget:false,swipedX:0},this.stageIndexes={},this.elements={a:[],container:null,slideSwipingHoverer:null,smw:[],sourceWrappersContainer:null,sources:[],sourceAnimationWrappers:[]},this.componentsServices={setSlideNumber:function(){}},this.resolve=function(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[];return n.unshift(e),ee(t,oe(n))},this.collections={sourceLoadHandlers:[],sourcesRenderFunctions:[],sourceSizers:[]},this.core={eventsDispatcher:{},globalEventsController:{},lightboxCloser:{},lightboxUpdater:{},scrollbarRecompensor:{},slideChangeFacade:{},slideIndexChanger:{},sourcesPointerDown:{},sourceDisplayFacade:{},stageManager:{},windowResizeActioner:{}},this.fs={},this.sws={},Z(this),this.close=function(){return e.core.lightboxCloser.closeLightbox()};},window.fsLightboxInstances={},re(),window.refreshFsLightbox=function(){for(var e in fsLightboxInstances){var t=fsLightboxInstances[e].props;fsLightboxInstances[e]=new FsLightbox,fsLightboxInstances[e].props=t,fsLightboxInstances[e].props.sources=[],fsLightboxInstances[e].elements.a=[];}re();};}])}));

    /*! name: vanilla-calendar-pro v2.9.10 | url: https://github.com/uvarov-frontend/vanilla-calendar-pro */
    !function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self).VanillaCalendar=t();}(undefined,(function(){var e=Object.defineProperty,t=Object.getOwnPropertySymbols,n=Object.prototype.hasOwnProperty,a=Object.prototype.propertyIsEnumerable,s=(t,n,a)=>n in t?e(t,n,{enumerable:true,configurable:true,writable:true,value:a}):t[n]=a,l=(e,l)=>{for(var i in l||(l={}))n.call(l,i)&&s(e,i,l[i]);if(t)for(var i of t(l))a.call(l,i)&&s(e,i,l[i]);return e},i=(e,t,n)=>(s(e,"symbol"!=typeof t?t+"":t,n),n);const r={calendar:"vanilla-calendar",calendarDefault:"vanilla-calendar_default",calendarMultiple:"vanilla-calendar_multiple",calendarMonth:"vanilla-calendar_month",calendarYear:"vanilla-calendar_year",calendarHidden:"vanilla-calendar_hidden",calendarToInput:"vanilla-calendar_to-input",calendarToInputTop:"vanilla-calendar_to-input_top",calendarToInputBottom:"vanilla-calendar_to-input_bottom",controls:"vanilla-calendar-controls",grid:"vanilla-calendar-grid",gridDisabled:"vanilla-calendar-grid_disabled",column:"vanilla-calendar-column",columnMonth:"vanilla-calendar-column_month",columnYear:"vanilla-calendar-column_year",header:"vanilla-calendar-header",headerContent:"vanilla-calendar-header__content",month:"vanilla-calendar-month",monthDisabled:"vanilla-calendar-month_disabled",year:"vanilla-calendar-year",yearDisabled:"vanilla-calendar-year_disabled",arrow:"vanilla-calendar-arrow",arrowPrev:"vanilla-calendar-arrow_prev",arrowNext:"vanilla-calendar-arrow_next",wrapper:"vanilla-calendar-wrapper",content:"vanilla-calendar-content",week:"vanilla-calendar-week",weekDay:"vanilla-calendar-week__day",weekDayWeekend:"vanilla-calendar-week__day_weekend",days:"vanilla-calendar-days",daysSelecting:"vanilla-calendar-days_selecting",months:"vanilla-calendar-months",monthsSelecting:"vanilla-calendar-months_selecting",monthsMonth:"vanilla-calendar-months__month",monthsMonthSelected:"vanilla-calendar-months__month_selected",monthsMonthDisabled:"vanilla-calendar-months__month_disabled",years:"vanilla-calendar-years",yearsSelecting:"vanilla-calendar-years_selecting",yearsYear:"vanilla-calendar-years__year",yearsYearSelected:"vanilla-calendar-years__year_selected",yearsYearDisabled:"vanilla-calendar-years__year_disabled",time:"vanilla-calendar-time",timeContent:"vanilla-calendar-time__content",timeHours:"vanilla-calendar-time__hours",timeMinutes:"vanilla-calendar-time__minutes",timeKeeping:"vanilla-calendar-time__keeping",timeRanges:"vanilla-calendar-time__ranges",timeRange:"vanilla-calendar-time__range",day:"vanilla-calendar-day",dayHoverFirst:"vanilla-calendar-day_hover-first",dayHoverLast:"vanilla-calendar-day_hover-last",dayHoverIntermediate:"vanilla-calendar-day_hover-intermediate",daySelectedFirst:"vanilla-calendar-day_selected-first",daySelectedLast:"vanilla-calendar-day_selected-last",daySelectedIntermediate:"vanilla-calendar-day_selected-intermediate",dayPopup:"vanilla-calendar-day__popup",dayBtn:"vanilla-calendar-day__btn",dayBtnPrev:"vanilla-calendar-day__btn_prev",dayBtnNext:"vanilla-calendar-day__btn_next",dayBtnToday:"vanilla-calendar-day__btn_today",dayBtnSelected:"vanilla-calendar-day__btn_selected",dayBtnHover:"vanilla-calendar-day__btn_hover",dayBtnDisabled:"vanilla-calendar-day__btn_disabled",dayBtnWeekend:"vanilla-calendar-day__btn_weekend",dayBtnHoliday:"vanilla-calendar-day__btn_holiday",weekNumbers:"vanilla-calendar-week-numbers",weekNumbersTitle:"vanilla-calendar-week-numbers__title",weekNumbersContent:"vanilla-calendar-week-numbers__content",weekNumber:"vanilla-calendar-week-number",isFocus:"vanilla-calendar-is-focus"},d=e=>`<div class="${e.controls}"><#ArrowPrev /><#ArrowNext /></div><div class="${e.grid}"><#Multiple><div class="${e.column}"><div class="${e.header}"><div class="${e.headerContent}"><#Month /><#Year /></div></div><div class="${e.wrapper}"><#WeekNumbers /><div class="${e.content}"><#Week /><#Days /></div></div></div><#/Multiple></div><#ControlTime />`,o=e=>`<div class="${e.header}"><div class="${e.headerContent}"><#Month /><#Year /></div></div><div class="${e.wrapper}"><div class="${e.content}"><#Months /></div></div>`,c=e=>`<div class="${e.header}"><#ArrowPrev /><div class="${e.headerContent}"><#Month /><#Year /></div><#ArrowNext /></div><div class="${e.wrapper}"><div class="${e.content}"><#Years /></div></div>`;class u{constructor(){var e;i(this,"isInit",false),i(this,"isInputInit",false),i(this,"input",false),i(this,"type","default"),i(this,"months",2),i(this,"jumpMonths",1),i(this,"jumpToSelectedDate",false),i(this,"toggleSelected",true),i(this,"date",{min:"1970-01-01",max:"2470-12-31",today:new Date}),i(this,"settings",{lang:"en",iso8601:true,range:{min:void 0,max:void 0,disablePast:false,disableGaps:false,edgesOnly:false,disableAllDays:false,disableWeekday:void 0,disabled:void 0,enabled:void 0},selection:{day:"single",month:true,year:true,time:false,controlTime:"all",stepHours:1,stepMinutes:1,cancelableDay:true},selected:{dates:void 0,month:void 0,year:void 0,holidays:void 0,time:void 0},visibility:{theme:"system",themeDetect:"html[data-theme]",monthShort:true,weekNumbers:false,weekend:true,today:true,disabled:false,daysOutside:true,positionToInput:"left"}}),i(this,"locale",{months:[],weekday:[]}),i(this,"sanitizer",(e=>e)),i(this,"actions",{clickDay:null,clickWeekNumber:null,clickMonth:null,clickYear:null,clickArrow:null,changeTime:null,changeToInput:null,getDays:null,getMonths:null,getYears:null,initCalendar:null,updateCalendar:null,destroyCalendar:null,showCalendar:null,hideCalendar:null}),i(this,"popups",{}),i(this,"CSSClasses",l({},r)),i(this,"DOMTemplates",{default:(e=this.CSSClasses,`<div class="${e.header}"><#ArrowPrev /><div class="${e.headerContent}"><#Month /><#Year /></div><#ArrowNext /></div><div class="${e.wrapper}"><#WeekNumbers /><div class="${e.content}"><#Week /><#Days /></div></div><#ControlTime />`),multiple:d(this.CSSClasses),month:o(this.CSSClasses),year:c(this.CSSClasses)}),i(this,"HTMLElement"),i(this,"HTMLOriginalElement"),i(this,"HTMLInputElement"),i(this,"rangeMin"),i(this,"rangeMax"),i(this,"rangeDisabled"),i(this,"rangeEnabled"),i(this,"selectedDates"),i(this,"selectedHolidays"),i(this,"selectedMonth"),i(this,"selectedYear"),i(this,"selectedHours"),i(this,"selectedMinutes"),i(this,"selectedKeeping"),i(this,"selectedTime"),i(this,"currentType"),i(this,"correctMonths"),i(this,"viewYear"),i(this,"dateMin"),i(this,"dateMax");}}const m=e=>`${e.getFullYear()}-${String(e.getMonth()+1).padStart(2,"0")}-${String(e.getDate()).padStart(2,"0")}`,g=e=>new Date(`${e}T00:00:00`),h=e=>e.reduce(((e,t)=>{if(t instanceof Date||"number"==typeof t){const n=t instanceof Date?t:new Date(t);e.push(n.toISOString().substring(0,10));}else t.match(/^(\d{4}-\d{2}-\d{2})$/g)?e.push(t):t.replace(/(\d{4}-\d{2}-\d{2}).*?(\d{4}-\d{2}-\d{2})/g,((t,n,a)=>{const s=g(n),l=g(a),i=new Date(s.getTime());for(;i<=l;i.setDate(i.getDate()+1))e.push(m(i));return t}));return e}),[]),y=()=>{const e=new Date;return new Date(e.getTime()-6e4*e.getTimezoneOffset()).toISOString().substring(0,10)},v=e=>e?{0:"12",13:"01",14:"02",15:"03",16:"04",17:"05",18:"06",19:"07",20:"08",21:"09",22:"10",23:"11"}[Number(e)]||String(e):"",p=e=>`${e} is not found, check the first argument passed to new VanillaCalendar.`,S='The calendar has not been initialized, please initialize it using the "init()" method first.',M='You specified "define" for "settings.lang" but did not provide the required values for "locale.weekday" or "locale.months".',C='Incorrect name of theme in "settings.visibility.theme".',b="The value of the time property can be: false, true, 12 or 24.",f=e=>{e.currentType=e.type,(e=>{var t;if(e.jumpToSelectedDate&&(null==(t=e.settings.selected.dates)?void 0:t.length)&&void 0===e.settings.selected.month&&void 0===e.settings.selected.year){const t=g(h(e.settings.selected.dates)[0]);e.settings.selected.month=t.getMonth(),e.settings.selected.year=t.getFullYear();}const n=void 0!==e.settings.selected.month&&Number(e.settings.selected.month)>=0&&Number(e.settings.selected.month)<12,a=void 0!==e.settings.selected.year&&Number(e.settings.selected.year)>=0&&Number(e.settings.selected.year)<=9999;e.selectedMonth=n?Number(e.settings.selected.month):e.date.today.getMonth(),e.selectedYear=a?Number(e.settings.selected.year):e.date.today.getFullYear(),e.viewYear=e.selectedYear;})(e),(e=>{var t,n,a;"today"===e.date.min&&(e.date.min=y()),"today"===e.date.max&&(e.date.max=y()),"today"===e.settings.range.min&&(e.settings.range.min=y()),"today"===e.settings.range.max&&(e.settings.range.max=y()),e.settings.range.min=e.settings.range.min?g(e.date.min)>=g(e.settings.range.min)?e.date.min:e.settings.range.min:e.date.min,e.settings.range.max=e.settings.range.max?g(e.date.max)<=g(e.settings.range.max)?e.date.max:e.settings.range.max:e.date.max;const s=e.settings.range.disablePast&&!e.settings.range.disableAllDays&&g(e.settings.range.min)<e.date.today;e.rangeMin=s||e.settings.range.disableAllDays?m(e.date.today):e.settings.range.min,e.rangeMax=e.settings.range.disableAllDays?m(e.date.today):e.settings.range.max,e.rangeDisabled=e.settings.range.disabled&&!e.settings.range.disableAllDays?h(e.settings.range.disabled):e.settings.range.disableAllDays?[e.rangeMin]:[],e.rangeDisabled.length>1&&e.rangeDisabled.sort(((e,t)=>+new Date(e)-+new Date(t))),e.rangeEnabled=e.settings.range.enabled?h(e.settings.range.enabled):[],(null==(t=e.rangeEnabled)?void 0:t[0])&&(null==(n=e.rangeDisabled)?void 0:n[0])&&(e.rangeDisabled=e.rangeDisabled.filter((t=>!e.rangeEnabled.includes(t)))),e.rangeEnabled.length>1&&e.rangeEnabled.sort(((e,t)=>+new Date(e)-+new Date(t))),(null==(a=e.rangeEnabled)?void 0:a[0])&&e.settings.range.disableAllDays&&(e.rangeMin=e.rangeEnabled[0],e.rangeMax=e.rangeEnabled[e.rangeEnabled.length-1]);})(e),(e=>{var t,n;e.selectedDates=(null==(t=e.settings.selected.dates)?void 0:t[0])?h(e.settings.selected.dates):[],e.selectedHolidays=(null==(n=e.settings.selected.holidays)?void 0:n[0])?h(e.settings.selected.holidays):[];})(e),(e=>{e.dateMin=e.settings.visibility.disabled?g(e.date.min):g(e.rangeMin),e.dateMax=e.settings.visibility.disabled?g(e.date.max):g(e.rangeMax);})(e),(e=>{const t=true===e.settings.selection.time||12===e.settings.selection.time;if(t||24===e.settings.selection.time){let n=false;if("string"==typeof e.settings.selected.time){const a=t?/^([0-9]|0[1-9]|1[0-2]):([0-5][0-9])|(AM|PM)/g:/^([0-1]?[0-9]|2[0-3]):([0-5][0-9])/g;e.settings.selected.time.replace(a,((a,s,l,i)=>(s&&l&&(n=true,e.selectedHours=s,e.selectedMinutes=l),i&&t?e.selectedKeeping=i:t&&(e.selectedKeeping="AM"),"")));}!n&&t?(e.selectedHours=v(String(e.date.today.getHours())),e.selectedMinutes=String(e.date.today.getMinutes()),e.selectedKeeping=Number(e.date.today.getHours())>=12?"PM":"AM"):n||(e.selectedHours=String(e.date.today.getHours()),e.selectedMinutes=String(e.date.today.getMinutes())),e.selectedHours=Number(e.selectedHours)<10?`0${Number(e.selectedHours)}`:`${e.selectedHours}`,e.selectedMinutes=Number(e.selectedMinutes)<10?`0${Number(e.selectedMinutes)}`:`${e.selectedMinutes}`,e.selectedTime=`${e.selectedHours}:${e.selectedMinutes}${e.selectedKeeping?` ${e.selectedKeeping}`:""}`;}else if(e.settings.selection.time)throw new Error(b)})(e),(e=>{e.correctMonths="multiple"===e.type?1===e.months?2:e.months>12?12:e.months:1;})(e);},w=({arrowPrev:e,arrowNext:t,isPrevHidden:n,isNextHidden:a})=>{e.style.visibility=n?"hidden":"",t.style.visibility=a?"hidden":"";},D=e=>{var t,n;if("month"===e.currentType)return;const a=null==(t=e.HTMLElement)?void 0:t.querySelector(`.${e.CSSClasses.arrowPrev}`),s=null==(n=e.HTMLElement)?void 0:n.querySelector(`.${e.CSSClasses.arrowNext}`);if(!a||!s)return;({default:()=>{const t=g(m(new Date(e.selectedYear,e.selectedMonth,1))),n=new Date(t.getTime()),l=new Date(t.getTime());n.setMonth(n.getMonth()-e.jumpMonths),l.setMonth(l.getMonth()+e.jumpMonths),e.settings.selection.year||(e.dateMin.setFullYear(t.getFullYear()),e.dateMax.setFullYear(t.getFullYear()));const i=!e.settings.selection.month||n.getFullYear()<e.dateMin.getFullYear()||n.getFullYear()===e.dateMin.getFullYear()&&n.getMonth()<e.dateMin.getMonth(),r=!e.settings.selection.month||l.getFullYear()>e.dateMax.getFullYear()||l.getFullYear()===e.dateMax.getFullYear()&&l.getMonth()>e.dateMax.getMonth();w({arrowPrev:a,arrowNext:s,isPrevHidden:i,isNextHidden:r});},year:()=>{w({arrowPrev:a,arrowNext:s,isPrevHidden:e.dateMin.getFullYear()&&e.viewYear-7<=e.dateMin.getFullYear(),isNextHidden:e.dateMax.getFullYear()&&e.viewYear+7>=e.dateMax.getFullYear()});}})["multiple"===e.currentType?"default":e.currentType]();},T=(e,t)=>{if(!e)return null;const n=g(e),a=t?n.getDay()||7:n.getDay();n.setDate(n.getDate()+4-a);const s=new Date(n.getFullYear(),0,1),l=Math.ceil(((+n-+s)/864e5+1)/7);return {year:n.getFullYear(),week:l}};function L(e){if(!e||!e.getBoundingClientRect)return {top:0,bottom:0,left:0,right:0};const t=e.getBoundingClientRect(),n=document.documentElement;return {bottom:t.bottom,right:t.right,top:t.top+window.scrollY-n.clientTop,left:t.left+window.scrollX-n.clientLeft}}function E(){return {vw:Math.max(document.documentElement.clientWidth||0,window.innerWidth||0),vh:Math.max(document.documentElement.clientHeight||0,window.innerHeight||0)}}function $(e){const{top:t,left:n}={left:window.scrollX||document.documentElement.scrollLeft||0,top:window.scrollY||document.documentElement.scrollTop||0},{top:a,left:s}=L(e),{vh:l,vw:i}=E(),r=a-t,d=s-n;return {top:r,bottom:l-(r+e.clientHeight),left:d,right:i-(d+e.clientWidth)}}function H(e,t,n=5){const a={top:true,bottom:true,left:true,right:true},s=[];if(!t||!e)return {canShow:a,parentPositions:s};const{bottom:l,top:i}=$(e),{top:r,left:d}=L(e),{height:o,width:c}=t.getBoundingClientRect(),{vh:u,vw:m}=E(),g=m/2,h=u/2;return [{condition:r<h,position:"top"},{condition:r>h,position:"bottom"},{condition:d<g,position:"left"},{condition:d>g,position:"right"}].forEach((({condition:e,position:t})=>{e&&s.push(t);})),Object.assign(a,{top:o<=i-n,bottom:o<=l-n,left:c<=d,right:c<=m-d}),{canShow:a,parentPositions:s}}const k=(e,t,n,a)=>{if(e){const s="auto"===n?function(e,t){const n="left";if(!t||!e)return n;const{canShow:a,parentPositions:s}=H(e,t),l=a.left&&a.right;return (l&&a.bottom?"center":l&&a.top?["top","center"]:Array.isArray(s)?["bottom"===s[0]?"top":"bottom",...s.slice(1)]:s)||n}(e,t):n,l={top:-t.offsetHeight,bottom:e.offsetHeight,left:0,center:e.offsetWidth/2-t.offsetWidth/2,right:e.offsetWidth-t.offsetWidth},i=Array.isArray(s)?s[0]:"bottom",r=Array.isArray(s)?s[1]:s;"bottom"===i?(t.classList.remove(a.calendarToInputTop),t.classList.add(a.calendarToInputBottom)):(t.classList.remove(a.calendarToInputBottom),t.classList.add(a.calendarToInputTop));const{top:d,left:o}=L(e),c=d+l[i];let u=o+l[r];const{vw:m}=E();if(u+t.clientWidth>m){const e=window.innerWidth-document.body.clientWidth;u=m-t.clientWidth-e;}else u<0&&(u=0);Object.assign(t.style,{left:`${u}px`,top:`${c}px`});}},x=(e,t)=>{var n;e.popups&&(null==(n=Object.entries(e.popups))||n.forEach((([n,a])=>((e,t,n,a)=>{const s=e.CSSClasses.dayPopup,l=a.querySelector(`[data-calendar-day="${t}"]`);if(l&&((null==n?void 0:n.modifier)&&l.classList.add(...n.modifier.trim().split(" ")),null==n?void 0:n.html)){const t=l.parentElement,a=document.createElement("div");a.className=s,a.innerHTML=e.sanitizer(n.html),t.appendChild(a),setTimeout((()=>{if(a){const{canShow:e}=H(t,a),n=5;let s=t.offsetHeight,l=0;e.bottom||(s=-a.offsetHeight-n),e.left&&!e.right&&(l=t.offsetWidth-a.offsetWidth/2),!e.left&&e.right&&(l=a.offsetWidth/2),Object.assign(a.style,{left:`${l}px`,top:`${s}px`});}}));}})(e,n,a,t))));},Y=(e,t,n,a,s)=>{const l=t[n].querySelector(`.${e.CSSClasses.dayBtn}`),i=T(null==l?void 0:l.dataset.calendarDay,e.settings.iso8601);if(!i)return;const r=a.cloneNode(true);r.innerText=String(i.week),r.dataset.calendarYearWeek=String(i.year),s.appendChild(r);},_=(e,t,n,a,s,l,i,r)=>{const d=document.createElement("div");d.className=e.CSSClasses.day;const o=document.createElement("button");o.className=`${e.CSSClasses.dayBtn}${r?` ${r}`:""}`,o.type="button",o.innerText=String(a),o.dataset.calendarDay=l;e.settings.visibility.weekNumbers&&(()=>{const t=T(l,e.settings.iso8601);t&&(o.dataset.calendarWeekNumber=String(t.week));})(),i?e.settings.visibility.daysOutside&&d.appendChild(o):d.appendChild(o),((e,t,n)=>{var a,s,l,i,r;const d=null==(a=e.settings.range.disableWeekday)?void 0:a.includes(n),o=e.settings.range.disableAllDays&&!!(null==(s=e.rangeEnabled)?void 0:s[0]);!d&&!o||(null==(l=e.rangeEnabled)?void 0:l.includes(t))||(null==(i=e.rangeDisabled)?void 0:i.includes(t))||(e.rangeDisabled.push(t),null==(r=e.rangeDisabled)||r.sort(((e,t)=>+new Date(e)-+new Date(t))));})(e,l,s),((e,t,n,a,s,l,i)=>{var r,d,o;if((g(e.rangeMin)>g(l)||g(e.rangeMax)<g(l)||(null==(r=e.rangeDisabled)?void 0:r.includes(l))||!e.settings.selection.month&&i||!e.settings.selection.year&&g(l).getFullYear()!==t)&&(a.classList.add(e.CSSClasses.dayBtnDisabled),a.tabIndex=-1),e.settings.visibility.today&&m(e.date.today)===l&&a.classList.add(e.CSSClasses.dayBtnToday),!e.settings.visibility.weekend||0!==s&&6!==s||a.classList.add(e.CSSClasses.dayBtnWeekend),(null==(d=e.selectedHolidays)?void 0:d.includes(l))&&a.classList.add(e.CSSClasses.dayBtnHoliday),(null==(o=e.selectedDates)?void 0:o.includes(l))&&(a.classList.add(e.CSSClasses.dayBtnSelected),e.selectedDates.length>1&&"multiple-ranged"===e.settings.selection.day&&(e.selectedDates[0]===l&&n.classList.add(e.CSSClasses.daySelectedFirst),e.selectedDates[e.selectedDates.length-1]===l&&n.classList.add(e.CSSClasses.daySelectedLast),e.selectedDates[0]!==l&&e.selectedDates[e.selectedDates.length-1]!==l&&n.classList.add(e.CSSClasses.daySelectedIntermediate))),e.settings.range.edgesOnly&&e.selectedDates.length>1&&"multiple-ranged"===e.settings.selection.day){const t=+new Date(e.selectedDates[0]),s=+new Date(e.selectedDates[e.selectedDates.length-1]),i=+new Date(l);i>t&&i<s&&(a.classList.add(e.CSSClasses.dayBtnSelected),n.classList.add(e.CSSClasses.daySelectedIntermediate));}})(e,t,d,o,s,l,i),n.appendChild(d),e.actions.getDays&&e.actions.getDays(a,l,d,o,e);},N=e=>{const t=e.HTMLElement.querySelectorAll(`.${e.CSSClasses.days}`),n=e.HTMLElement.querySelectorAll(`.${e.CSSClasses.weekNumbers}`),a=new Date(e.selectedYear,e.selectedMonth,1);t.forEach(((t,s)=>{const l=new Date(a);l.setMonth(l.getMonth()+s);const i=l.getMonth(),r=l.getFullYear(),d=new Date(r,i,1),o=new Date(r,i+1,0).getDate(),c=e.settings.iso8601?(0!==d.getDay()?d.getDay():7)-1:d.getDay();e.settings.selection.day&&t.classList.add(e.CSSClasses.daysSelecting),t.textContent="",((e,t,n,a,s)=>{let l=new Date(n,a,0).getDate()-(s-1);const i=0===a?n-1:n,r=0===a?12:a<10?`0${a}`:a;for(let a=s;a>0;a--,l++){const a=`${i}-${r}-${l}`,s=g(a).getDay();_(e,n,t,l,s,a,true,e.CSSClasses.dayBtnPrev);}})(e,t,r,i,c),((e,t,n,a,s)=>{for(let l=1;l<=n;l++){const n=new Date(a,s,l),i=m(n),r=n.getDay();_(e,a,t,l,r,i,false,null);}})(e,t,o,r,i),((e,t,n,a,s,l)=>{const i=l+n,r=7*Math.ceil(i/7)-i,d=s+1===12?a+1:a,o=s+1===12?"01":s+2<10?`0${s+2}`:s+2;for(let n=1;n<=r;n++){const s=`${d}-${o}-${n<10?`0${n}`:String(n)}`,l=g(s).getDay();_(e,a,t,n,l,s,true,e.CSSClasses.dayBtnNext);}})(e,t,o,r,i,c),((e,t,n,a,s)=>{if(!e.settings.visibility.weekNumbers)return;a.textContent="";const l=document.createElement("b");l.className=e.CSSClasses.weekNumbersTitle,l.innerText="#",a.appendChild(l);const i=document.createElement("div");i.className=e.CSSClasses.weekNumbersContent,a.appendChild(i);const r=document.createElement("button");r.type="button",r.className=e.CSSClasses.weekNumber;const d=s.querySelectorAll(`.${e.CSSClasses.day}`),o=Math.ceil((t+n)/7);for(let t=0;t<o;t++)Y(e,d,0===t?6:7*t,r,i);})(e,c,o,n[s],t),x(e,t);}));},A=e=>{var t,n;const a=null==(t=e.HTMLElement)?void 0:t.querySelectorAll("[data-calendar-selected-month]"),s=null==(n=e.HTMLElement)?void 0:n.querySelectorAll("[data-calendar-selected-year]");if(!(null==a?void 0:a[0])&&(null==s?void 0:s[0]))return;const l=new Date(e.selectedYear,e.selectedMonth,1);null==a||a.forEach(((t,n)=>((e,t,n,a)=>{const s=new Date(a.setMonth(e.selectedMonth+n)).getMonth(),l=false===e.settings.selection.month||"only-arrows"===e.settings.selection.month;t.tabIndex=l?-1:0,t.classList.toggle(e.CSSClasses.monthDisabled,l),t.setAttribute("data-calendar-selected-month",String(s)),t.innerText=e.locale.months[s];})(e,t,n,l))),null==s||s.forEach(((t,n)=>((e,t,n,a)=>{const s=new Date(a.setFullYear(e.selectedYear,e.selectedMonth+n)).getFullYear(),l=false===e.settings.selection.year||"only-arrows"===e.settings.selection.year;t.tabIndex=l?-1:0,t.classList.toggle(e.CSSClasses.yearDisabled,l),t.setAttribute("data-calendar-selected-year",String(s)),t.innerText=String(s);})(e,t,n,l)));},I=(e,t)=>{const n=g(m(new Date(e.selectedYear,e.selectedMonth,1)));(({prev:()=>n.setMonth(n.getMonth()-e.jumpMonths),next:()=>n.setMonth(n.getMonth()+e.jumpMonths)}))[t](),[e.selectedMonth,e.selectedYear]=[n.getMonth(),n.getFullYear()],A(e),D(e),N(e);},P=Object.freeze(Object.defineProperty({__proto__:null,ArrowNext:e=>`<button type="button"class="${e.CSSClasses.arrow} ${e.CSSClasses.arrowNext}"data-calendar-arrow="next"></button>`,ArrowPrev:e=>`<button type="button"class="${e.CSSClasses.arrow} ${e.CSSClasses.arrowPrev}"data-calendar-arrow="prev"></button>`,ControlTime:e=>e.settings.selection.time?`<div class="${e.CSSClasses.time}"></div>`:"",Days:e=>`<div class="${e.CSSClasses.days}"></div>`,Month:e=>`<button type="button"class="${e.CSSClasses.month}"data-calendar-selected-month></button>`,Months:e=>`<div class="${e.CSSClasses.months}"></div>`,Week:e=>`<div class="${e.CSSClasses.week}"></div>`,WeekNumbers:e=>e.settings.visibility.weekNumbers?`<div class="${e.CSSClasses.weekNumbers}"></div>`:"",Year:e=>`<button type="button"class="${e.CSSClasses.year}"data-calendar-selected-year></button>`,Years:e=>`<div class="${e.CSSClasses.years}"></div>`},Symbol.toStringTag,{value:"Module"})),F=(e,t)=>t.replace(/[\n\t]/g,"").replace(/<#(?!\/?Multiple)(.*?)>/g,((t,n)=>{const a=(s=n.replace(/[/\s\n\t]/g,""),P[s]);var s;const l=a?a(e):"";return e.sanitizer(l)})).replace(/[\n\t]/g,""),W=(e,t)=>{const{HTMLElement:n,CSSClasses:a,DOMTemplates:s,type:l,currentType:i,correctMonths:r}=e,d=(s,l)=>{if(!t)return;const i=n.querySelector(`.${a.controls}`);i&&n.removeChild(i);n.querySelector(`.${a.grid}`).classList.add(a.gridDisabled);const r=t.closest(`.${a.column}`);r.classList.add(s),r.innerHTML=F(e,l);},o={default:()=>{n.classList.add(a.calendarDefault),n.classList.remove(a.calendarMonth,a.calendarYear),n.innerHTML=F(e,s.default);},multiple:()=>{r&&(n.classList.add(a.calendarMultiple),n.classList.remove(a.calendarMonth,a.calendarYear),n.innerHTML=((e,t)=>t.replace(/<#Multiple>(.*?)<#\/Multiple>/g,((t,n)=>{let a="";for(let t=0;t<e.correctMonths;t++)a+=n;return e.sanitizer(a)})).replace(/[\n\t]/g,""))(e,F(e,s.multiple)));},month:()=>{"multiple"!==l?(n.classList.add(a.calendarMonth),n.classList.remove(a.calendarDefault,a.calendarYear),n.innerHTML=F(e,s.month)):d(a.columnMonth,s.month);},year:()=>{"multiple"!==l?(n.classList.add(a.calendarYear),n.classList.remove(a.calendarDefault,a.calendarMonth),n.innerHTML=F(e,s.year)):d(a.columnYear,s.year);}};n.classList.add(a.calendar),o[i]();},q=(e,t,n,a,s)=>{const l=t.cloneNode(false);return l.className=`${e.CSSClasses.yearsYear}${n===s?` ${e.CSSClasses.yearsYearSelected}`:a?` ${e.CSSClasses.yearsYearDisabled}`:""}`,l.dataset.calendarYear=String(s),l.title=String(s),l.innerText=String(s),a&&(l.tabIndex=-1),l},B=(e,t)=>{const n=(null==t?void 0:t.dataset.calendarSelectedYear)?Number(null==t?void 0:t.dataset.calendarSelectedYear):e.selectedYear;e.currentType="year",W(e,t),A(e),D(e);const a=e.HTMLElement.querySelector(`.${e.CSSClasses.years}`);if(!e.settings.selection.year||!a)return;a.classList.add(e.CSSClasses.yearsSelecting);const s="multiple"!==e.type||e.selectedYear===n?0:1,l=document.createElement("button");l.type="button";for(let t=e.viewYear-7;t<e.viewYear+8;t++){const i=t<e.dateMin.getFullYear()+s||t>e.dateMax.getFullYear(),r=q(e,l,n,i,t);a.appendChild(r),e.actions.getYears&&e.actions.getYears(t,r,e);}},O=e=>`${e.charAt(0).toUpperCase()}${e.substring(1,e.length)}`.replace(/\./,""),j=(e,t)=>{const n=new Date(`1978-01-0${t+1}T00:00:00.000Z`).toLocaleString(e.settings.lang,{weekday:"short",timeZone:"UTC"});e.locale.weekday.push(O(n));},K=(e,t)=>{const n=new Date(`1978-${t+1<=9?`0${t+1}`:t+1}-01T00:00:00.000Z`).toLocaleString(e.settings.lang,{month:"long",timeZone:"UTC"});e.locale.months.push(O(n));},z=e=>{if("multiple"!==e.type)return 0;const t=e.HTMLElement.querySelectorAll(`.${e.CSSClasses.column}`),n=Array.from(t).findIndex((t=>t.classList.contains(`${e.CSSClasses.columnMonth}`)));return n>0?n:0},R=(e,t,n,a,s,l)=>{const i=t.cloneNode(false);return i.className=`${e.CSSClasses.monthsMonth}${n===l?` ${e.CSSClasses.monthsMonthSelected}`:s?` ${e.CSSClasses.monthsMonthDisabled}`:""}`,i.title=a,i.innerText=`${e.settings.visibility.monthShort?a.substring(0,3):a}`,i.dataset.calendarMonth=String(l),s&&(i.tabIndex=-1),i},G=(e,t)=>{var n,a;const s=(null==t?void 0:t.dataset.calendarSelectedMonth)?Number(t.dataset.calendarSelectedMonth):e.selectedMonth,l=null==(n=null==t?void 0:t.closest(`.${e.CSSClasses.column}`))?void 0:n.querySelector(`.${e.CSSClasses.year}`),i=l?Number(l.dataset.calendarSelectedYear):e.selectedYear;e.currentType="month",W(e,t),A(e);const r=null==(a=e.HTMLElement)?void 0:a.querySelector(`.${e.CSSClasses.months}`);if(!e.settings.selection.month||!r)return;r.classList.add(e.CSSClasses.monthsSelecting);const d=e.jumpMonths>1?e.locale.months.map(((t,n)=>s-e.jumpMonths*n)).concat(e.locale.months.map(((t,n)=>s+e.jumpMonths*n))).filter((e=>e>=0&&e<=12)):Array.from(Array(12).keys()),o=document.createElement("button");o.type="button";for(let t=0;t<12;t++){const n=e.locale.months[t],a=t<e.dateMin.getMonth()+z(e)&&i<=e.dateMin.getFullYear()||t>e.dateMax.getMonth()+z(e)&&i>=e.dateMax.getFullYear()||t!==s&&!d.includes(t),l=R(e,o,s,n,a,t);r.appendChild(l),e.actions.getMonths&&e.actions.getMonths(t,l,e);}},Z=(e,t)=>e&&t?{0:{AM:"00",PM:"12"},1:{AM:"01",PM:"13"},2:{AM:"02",PM:"14"},3:{AM:"03",PM:"15"},4:{AM:"04",PM:"16"},5:{AM:"05",PM:"17"},6:{AM:"06",PM:"18"},7:{AM:"07",PM:"19"},8:{AM:"08",PM:"20"},9:{AM:"09",PM:"21"},10:{AM:"10",PM:"22"},11:{AM:"11",PM:"23"},12:{AM:"12",PM:"12"}}[Number(e)][t]:"",U=(e,t,n)=>e.querySelector(`.${t}${n?` input[name="${n}"]`:""}`),V=(e,t,n)=>{e.addEventListener("mouseover",(()=>t.classList.add(n))),e.addEventListener("mouseout",(()=>t.classList.remove(n)));},X=(e,t,n,a)=>{(({hours:()=>{e.selectedHours=n;},minutes:()=>{e.selectedMinutes=n;}}))[a](),e.selectedTime=`${e.selectedHours}:${e.selectedMinutes}${e.selectedKeeping?` ${e.selectedKeeping}`:""}`,e.actions.changeTime&&e.actions.changeTime(t,e),e.input&&e.HTMLInputElement&&e.actions.changeToInput&&e.actions.changeToInput(t,e);},J=(e,t,n,a,s,l)=>{t.addEventListener("input",(t=>{const i=t.target,r=Number(i.value),d=r<10?`0${r}`:`${r}`;if("hours"!==s||12!==l)return n.value=d,void X(e,t,d,s);r<l&&r>0?(n.value=d,e.selectedKeeping="AM",a.innerText=e.selectedKeeping,X(e,t,d,s)):(0===r?(e.selectedKeeping="AM",a.innerText="AM"):(e.selectedKeeping="PM",a.innerText="PM"),n.value=v(i.value),X(e,t,v(i.value),s));}));},Q=(e,t,n,a,s,l)=>{n.addEventListener("change",(n=>{const i=n.target,r=Number(i.value),d=r<10?`0${r}`:`${r}`;"hours"===s&&12===l?i.value&&r<=l&&r>0?(i.value=d,t.value=Z(d,e.selectedKeeping),X(e,n,d,s)):i.value&&r<24&&(r>l||0===r)?(0===r?(e.selectedKeeping="AM",a.innerText="AM"):(e.selectedKeeping="PM",a.innerText="PM"),i.value=v(i.value),t.value=d,X(e,n,v(i.value),s)):i.value=e.selectedHours:i.value&&r<=l&&r>=0?(i.value=d,t.value=d,X(e,n,d,s)):"hours"===s?i.value=e.selectedHours:"minutes"===s&&(i.value=e.selectedMinutes);}));},ee=(e,t,n)=>{const a=24===n?23:n||12,s=U(t,e.CSSClasses.timeRange,"hours"),l=U(t,e.CSSClasses.timeRange,"minutes"),i=U(t,e.CSSClasses.timeHours,"hours"),r=U(t,e.CSSClasses.timeMinutes,"minutes"),d=t.querySelector(`.${e.CSSClasses.timeKeeping}`);V(s,i,e.CSSClasses.isFocus),V(l,r,e.CSSClasses.isFocus),J(e,s,i,d,"hours",a),J(e,l,r,d,"minutes",0),Q(e,s,i,d,"hours",a),Q(e,l,r,d,"minutes",59),d&&((e,t,n)=>{t.addEventListener("click",(a=>{e.selectedKeeping=t.innerText.includes("AM")?"PM":"AM",t.innerText=e.selectedKeeping,n.value=Z(e.selectedHours,e.selectedKeeping),X(e,a,e.selectedHours,"hours");}));})(e,d,s);},te=(e,t,n,a)=>`<label class="${t}"><input type="text"name="${e}"maxlength="2"value="${n}"${a?"disabled":""}></label>`,ne=(e,t,n,a,s,l)=>`<label class="${t}"><input type="range"name="${e}"min="${n}"max="${a}"step="${s}"value="${l}"></label>`,ae=e=>{const t=[...e.locale.weekday];if(!t[0])return;e.settings.iso8601&&t.push(t.shift());e.HTMLElement.querySelectorAll(`.${e.CSSClasses.week}`).forEach((n=>((e,t,n)=>{const a=document.createElement("b");t.textContent="";for(let s=0;s<n.length;s++){const l=n[s],i=a.cloneNode(true);i.className=`${e.CSSClasses.weekDay}`,i.className=`${e.CSSClasses.weekDay}${e.settings.visibility.weekend&&e.settings.iso8601?5===s||6===s?` ${e.CSSClasses.weekDayWeekend}`:"":!e.settings.visibility.weekend||e.settings.iso8601||0!==s&&6!==s?"":` ${e.CSSClasses.weekDayWeekend}`}`,i.innerText=`${l}`,t.appendChild(i);}})(e,n,t)));},se=["light","dark","system"],le={value:false,set:()=>{le.value=true;},check:()=>le.value},ie=(e,t)=>se.find((n=>{var a;return "system"!==n&&(null==(a=e.getAttribute(t))?void 0:a.includes(n))})),re=(e,t)=>{e.dataset.calendarTheme=t;},de=(e,t)=>{var n;if(n=t,re(e.HTMLElement,n.matches?"dark":"light"),"system"!==e.settings.visibility.theme||le.check())return;const a=t=>{const n=document.querySelectorAll(`.${e.CSSClasses.calendar}`);null==n||n.forEach((e=>re(e,t.matches?"dark":"light")));};t.addEventListener?t.addEventListener("change",a):t.addListener(a),le.set();},oe=(e,t)=>{const n=e.settings.visibility.themeDetect?document.querySelector(e.settings.visibility.themeDetect):null;if(!n)return void de(e,t);const a=e.settings.visibility.themeDetect.replace(/^.*\[(.+)\]/g,((e,t)=>t)),s=ie(n,a);s?(re(e.HTMLElement,s),((e,t,n)=>{new MutationObserver((a=>{for(let s=0;s<a.length;s++)if(a[s].attributeName===n){const a=ie(t,n);a&&re(e.HTMLElement,a);break}})).observe(t,{attributes:true});})(e,n,a)):de(e,t);},ce=e=>{const t={default:()=>{ae(e),N(e);},multiple:()=>{ae(e),N(e);},month:()=>G(e),year:()=>B(e)};(e=>{if(!se.includes(e.settings.visibility.theme))throw new Error(C);if("not all"===window.matchMedia("(prefers-color-scheme)").media)return void re(e.HTMLElement,"light");({light:()=>re(e.HTMLElement,"light"),dark:()=>re(e.HTMLElement,"dark"),system:()=>oe(e,window.matchMedia("(prefers-color-scheme: dark)"))})[e.settings.visibility.theme]();})(e),(e=>{if("define"!==e.settings.lang||!e.locale.weekday[6]||!e.locale.months[11]){if("define"===e.settings.lang)throw new Error(M);e.locale.weekday=[],e.locale.months=[];for(let t=0;t<7;t++)j(e,t);for(let t=0;t<12;t++)K(e,t);}})(e),W(e),A(e),D(e),(e=>{const t=e.HTMLElement.querySelector(`.${e.CSSClasses.time}`);if(!t)return;const n=true===e.settings.selection.time?12:e.settings.selection.time,a="range"===e.settings.selection.controlTime,[s,l]=[0,23],[i,r]=[0,59];t.innerHTML=e.sanitizer(`<div class="${e.CSSClasses.timeContent}">${te("hours",e.CSSClasses.timeHours,e.selectedHours,a)}${te("minutes",e.CSSClasses.timeMinutes,e.selectedMinutes,a)}${12===n?`<button type="button" class="${e.CSSClasses.timeKeeping}"${a?"disabled":""}>${e.selectedKeeping}</button>`:""}</div><div class="${e.CSSClasses.timeRanges}">${ne("hours",e.CSSClasses.timeRange,s,l,e.settings.selection.stepHours,e.selectedKeeping?Z(e.selectedHours,e.selectedKeeping):e.selectedHours)}${ne("minutes",e.CSSClasses.timeRange,i,r,e.settings.selection.stepMinutes,e.selectedMinutes)}</div>`),ee(e,t,n);})(e),t[e.currentType]();},ue={self:null,rangeMin:void 0,rangeMax:void 0},me=()=>{var e;if(!(null==(e=ue.self)?void 0:e.HTMLElement))return;const{CSSClasses:t}=ue.self;ue.self.HTMLElement.querySelectorAll(`.${ue.self.CSSClasses.dayBtnHover}`).forEach((e=>{var n;e.classList.remove(ue.self.CSSClasses.dayBtnHover),null==(n=e.parentElement)||n.classList.remove(t.dayHoverIntermediate,t.dayHoverFirst,t.dayHoverLast);}));},ge=(e,t,n)=>{var a,s,l;if(!(null==(a=ue.self)?void 0:a.selectedDates))return;const i=m(e),{CSSClasses:r}=ue.self;if(null==(s=ue.self.rangeDisabled)?void 0:s.includes(i))return;const d=null==(l=ue.self.HTMLElement)?void 0:l.querySelectorAll(`[data-calendar-day="${i}"]`);null==d||d.forEach((e=>{var t;e.classList.add(r.dayBtnHover),null==(t=e.parentElement)||t.classList.add(r.dayHoverIntermediate);})),null==t||t.forEach((e=>{var t;return null==(t=e.parentElement)?void 0:t.classList.add(r.dayHoverFirst)})),null==n||n.forEach((e=>{var t;return null==(t=e.parentElement)?void 0:t.classList.add(r.dayHoverLast)}));},he=e=>{var t;if(!e.target||!(null==(t=ue.self)?void 0:t.selectedDates))return;if(!e.target.closest(`.${ue.self.CSSClasses.days}`))return void me();const n=e.target.closest("[data-calendar-day]");if(!n)return;const a=n.dataset.calendarDay,s=g(ue.self.selectedDates[0]),l=g(a),i=ue.self.HTMLElement.querySelectorAll(`[data-calendar-day="${ue.self.selectedDates[0]}"]`),r=ue.self.HTMLElement.querySelectorAll(`[data-calendar-day="${a}"]`),[d,o]=s<l?[i,r]:[r,i],[c,u]=s<l?[s,l]:[l,s];me();for(let e=new Date(c);e<=u;e.setDate(e.getDate()+1))ge(e,d,o);},ye=e=>{ue.self&&"Escape"===e.key&&(ue.self.selectedDates=[],ue.self.HTMLElement.removeEventListener("mousemove",he),document.removeEventListener("keydown",ye),ce(ue.self));},ve=(e,t)=>{var n;if(t){const a=1===e.selectedDates.length&&e.selectedDates[0].includes(t);e.selectedDates=a&&!e.settings.selection.cancelableDay?[t,t]:a&&e.settings.selection.cancelableDay?[]:e.selectedDates.length>1?[t]:[...e.selectedDates,t],null==(n=e.selectedDates)||n.sort(((e,t)=>+new Date(e)-+new Date(t)));}e.settings.range.disableGaps&&(ue.rangeMin=ue.rangeMin?ue.rangeMin:e.rangeMin,ue.rangeMax=ue.rangeMax?ue.rangeMax:e.rangeMax),ue.self=e;const a={set:()=>{e.HTMLElement.addEventListener("mousemove",he),document.addEventListener("keydown",ye),e.settings.range.disableGaps&&(()=>{var e,t,n;if(!(null==(t=null==(e=ue.self)?void 0:e.selectedDates)?void 0:t[0])||!(null==(n=ue.self.rangeDisabled)?void 0:n[0]))return;const a=g(ue.self.selectedDates[0]),[s,l]=ue.self.rangeDisabled.map((e=>g(e))).reduce((([e,t],n)=>[a>=n?n:e,a<n&&null===t?n:t]),[null,null]);s&&(ue.self.rangeMin=m(new Date(s.setDate(s.getDate()+1)))),l&&(ue.self.rangeMax=m(new Date(l.setDate(l.getDate()-1))));})();},reset:()=>{const[t,n]=[e.selectedDates[0],e.selectedDates[e.selectedDates.length-1]];e.selectedDates=e.selectedDates[0]!==e.selectedDates[e.selectedDates.length-1]?e.settings.range.edgesOnly?[t,n]:h([`${t}:${n}`]):[e.selectedDates[0],e.selectedDates[0]],e.HTMLElement.removeEventListener("mousemove",he),document.removeEventListener("keydown",ye),e.settings.range.disableGaps&&ue.self&&(ue.self.rangeMin=ue.rangeMin,ue.self.rangeMax=ue.rangeMax);}};a[1===e.selectedDates.length?"set":"reset"]();},pe=(e,t,n)=>{if(!t.dataset.calendarDay)return;const a=t.dataset.calendarDay,s=t.classList.contains(e.CSSClasses.dayBtnSelected);if(s&&!e.settings.selection.cancelableDay)return;let l=true;void 0!==e.toggleSelected&&(l="function"==typeof e.toggleSelected?e.toggleSelected(e):e.toggleSelected),s&&!l||(e.selectedDates=s?e.selectedDates.filter((e=>e!==a)):n?[...e.selectedDates,a]:[a]);},Se=(e,t,n,a,s)=>{const l=e.HTMLElement.querySelectorAll(`.${e.CSSClasses.column}`),i=Array.from(l).findIndex((e=>e.classList.contains(t))),r=Number(l[i].querySelector(`.${n}`).getAttribute(s));return "month"===e.currentType&&i>=0?a-i:"year"===e.currentType&&e.selectedYear!==r?a-1:a},Me=(e,t,n,a)=>{if(!e.settings.selection[n])return;const s=t.target,l=e=>s.closest(`.${e}`),i=l(a.header),r=l(a.item),d=l(e.CSSClasses.grid),o=l(e.CSSClasses.column);if(e.currentType!==n&&i){({year:()=>B(e,s),month:()=>G(e,s)})[n]();}else r?((e,t,n,a,s)=>{const l={year:()=>{var n,a;return null==(a=(n=e.actions).clickYear)?void 0:a.call(n,t,e)},month:()=>{var n,a;return null==(a=(n=e.actions).clickMonth)?void 0:a.call(n,t,e)}};(({year:()=>{if("multiple"===e.type){const t=Se(e,e.CSSClasses.columnYear,e.CSSClasses.year,Number(s.dataset.calendarYear),"data-calendar-selected-year"),n=e.selectedMonth<e.dateMin.getMonth()&&t<=e.dateMin.getFullYear(),a=e.selectedMonth>e.dateMax.getMonth()&&t>=e.dateMax.getFullYear(),l=t<e.dateMin.getFullYear(),i=t>e.dateMax.getFullYear();n||l?(e.selectedYear=e.dateMin.getFullYear(),e.selectedMonth=e.dateMin.getMonth()):a||i?(e.selectedYear=e.dateMax.getFullYear(),e.selectedMonth=e.dateMax.getMonth()):e.selectedYear=t;}else e.selectedYear=Number(s.dataset.calendarYear);},month:()=>{if("multiple"===e.type){const t=Se(e,e.CSSClasses.columnMonth,e.CSSClasses.month,Number(s.dataset.calendarMonth),"data-calendar-selected-month"),n=s.closest(`.${a.column}`).querySelector(`.${e.CSSClasses.year}`);e.selectedYear=Number(n.dataset.calendarSelectedYear);const l=t<e.dateMin.getMonth()&&e.selectedYear<=e.dateMin.getFullYear(),i=t>e.dateMax.getMonth()&&e.selectedYear>=e.dateMax.getFullYear();e.selectedMonth=l?e.dateMin.getMonth():i?e.dateMax.getMonth():t;}else e.selectedMonth=Number(s.dataset.calendarMonth);}}))[n](),l[n](),e.currentType=e.type,ce(e);})(e,t,n,a,r):(e.currentType===n&&i||"multiple"===e.type&&e.currentType===n&&d&&!o)&&(e.currentType=e.type,ce(e));},Ce=e=>{const t=t=>{((e,t)=>{const n=t.target.closest(`.${e.CSSClasses.arrow}`);n&&(["default","multiple"].includes(e.currentType)?I(e,n.dataset.calendarArrow):"year"===e.currentType&&void 0!==e.viewYear&&(e.viewYear+={prev:-15,next:15}[n.dataset.calendarArrow],B(e,t.target)),e.actions.clickArrow&&e.actions.clickArrow(t,e));})(e,t),((e,t)=>{var n;if(!e.settings.visibility.weekNumbers||!e.actions.clickWeekNumber)return;const a=t.target.closest(`.${e.CSSClasses.weekNumber}`),s=null==(n=e.HTMLElement)?void 0:n.querySelectorAll("[data-calendar-week-number]");if(!a||!s)return;const l=Number(a.innerText),i=Number(a.dataset.calendarYearWeek),r=Array.from(s).filter((e=>Number(e.dataset.calendarWeekNumber)===l));e.actions.clickWeekNumber(t,l,r,i,e);})(e,t),((e,t)=>{var n;const a=t.target,s=e=>a.closest(`.${e}`),l=s(e.CSSClasses.dayBtn);if(!e.settings.selection.day||!["single","multiple","multiple-ranged"].includes(e.settings.selection.day)||!l)return;(({single:()=>pe(e,l,false),multiple:()=>pe(e,l,true),"multiple-ranged":()=>ve(e,l.dataset.calendarDay)}))[e.settings.selection.day](),null==(n=e.selectedDates)||n.sort(((e,t)=>+new Date(e)-+new Date(t))),e.actions.clickDay&&e.actions.clickDay(t,e),e.input&&e.HTMLInputElement&&e.HTMLElement&&e.actions.changeToInput&&e.actions.changeToInput(t,e);const i=s(e.CSSClasses.dayBtnPrev),r=s(e.CSSClasses.dayBtnNext);({prev:()=>I(e,"prev"),next:()=>I(e,"next"),default:()=>N(e)})[i?"prev":r?"next":"default"]();})(e,t),Me(e,t,"month",{header:e.CSSClasses.month,item:e.CSSClasses.monthsMonth,column:e.CSSClasses.columnMonth}),Me(e,t,"year",{header:e.CSSClasses.year,item:e.CSSClasses.yearsYear,column:e.CSSClasses.columnYear});};return e.HTMLElement.addEventListener("click",t),()=>e.HTMLElement.removeEventListener("click",t)},be=(e,{year:t,month:n,dates:a,holidays:s,time:i}={})=>{var r;const d=l({},e.settings.selected);e.settings.selected.year=t?d.year:e.selectedYear,e.settings.selected.month=n?d.month:e.selectedMonth,e.settings.selected.holidays=s?d.holidays:e.selectedHolidays,e.settings.selected.time=i?d.time:e.selectedTime,e.settings.selected.dates="only-first"===a&&(null==(r=e.selectedDates)?void 0:r[0])?[e.selectedDates[0]]:true===a?d.dates:e.selectedDates,f(e),ce(e),e.settings.selected=d,"multiple-ranged"===e.settings.selection.day&&a&&ve(e);},fe=(e,t=true)=>{e.isInputInit=true;const n=document.createElement("div");return n.className=`${e.CSSClasses.calendar} ${e.CSSClasses.calendarToInput} ${e.CSSClasses.calendarHidden}`,e.HTMLElement=n,document.body.appendChild(e.HTMLElement),e.HTMLElement.style.visibility="hidden",t&&queueMicrotask((()=>{k(e.HTMLInputElement,n,e.settings.visibility.positionToInput,e.CSSClasses),e.HTMLElement.style.visibility="visible",e.show();})),be(e,{year:true,month:true,dates:true,holidays:true,time:true}),e.actions.initCalendar&&e.actions.initCalendar(e),Ce(e)},we=e=>(e.HTMLOriginalElement=e.HTMLElement.cloneNode(true),e.isInit=true,e.input?(e=>{const t=[];e.HTMLInputElement=e.HTMLElement;const n=()=>k(e.HTMLInputElement,e.HTMLElement,e.settings.visibility.positionToInput,e.CSSClasses),a=t=>{"Escape"===t.key&&((null==e?void 0:e.HTMLInputElement)&&(null==e?void 0:e.HTMLElement)&&e.hide(),document.removeEventListener("keydown",a));},s=t=>{var a;e&&t.target!==e.HTMLInputElement&&!(null==(a=e.HTMLElement)?void 0:a.contains(t.target))&&(e.HTMLInputElement&&e.HTMLElement&&e.hide(),window.removeEventListener("resize",n),document.removeEventListener("click",s,{capture:true}));},l=()=>{e.isInputInit?(k(e.HTMLInputElement,e.HTMLElement,e.settings.visibility.positionToInput,e.CSSClasses),e.HTMLElement.style.visibility="visible",e.show()):t.push(fe(e)),window.addEventListener("resize",n),document.addEventListener("click",s,{capture:true}),document.addEventListener("keydown",a);};return e.HTMLInputElement.addEventListener("click",l),e.HTMLInputElement.addEventListener("focus",l),()=>{t.forEach((e=>e()));}})(e):(f(e),ce(e),e.actions.initCalendar&&e.actions.initCalendar(e),Ce(e)));return class extends u{constructor(e,t){if(super(),i(this,"init",(()=>we(this))),i(this,"update",(e=>((e,{year:t,month:n,dates:a,holidays:s,time:l}={})=>{if(!e.isInit)throw new Error(S);e.input&&!e.isInputInit&&fe(e,false),be(e,{year:t,month:n,dates:a,holidays:s,time:l}),e.actions.updateCalendar&&e.actions.updateCalendar(e);})(this,e))),i(this,"destroy",(()=>(e=>{var t,n,a,s,l,i;if(!e.isInit)throw new Error(S);e.input?(null==(n=null==(t=e.HTMLElement)?void 0:t.parentElement)||n.removeChild(e.HTMLElement),null==(s=null==(a=e.HTMLInputElement)?void 0:a.replaceWith)||s.call(a,e.HTMLOriginalElement),e.HTMLInputElement=void 0):null==(i=null==(l=e.HTMLElement)?void 0:l.replaceWith)||i.call(l,e.HTMLOriginalElement),e.HTMLElement=e.HTMLOriginalElement,e.actions.destroyCalendar&&e.actions.destroyCalendar(e);})(this))),i(this,"show",(()=>{var e;(e=this).currentType?(e.HTMLElement.classList.remove(e.CSSClasses.calendarHidden),e.actions.showCalendar&&e.actions.showCalendar(e)):e.HTMLElement.click();})),i(this,"hide",(()=>{var e;(e=this).currentType&&(e.HTMLElement.classList.add(e.CSSClasses.calendarHidden),e.actions.hideCalendar&&e.actions.hideCalendar(e));})),this.HTMLElement="string"==typeof e?document.querySelector(e):e,!this.HTMLElement)throw new Error(p(e));if(!t)return;const n=(e,t)=>{Object.keys(t).forEach((a=>{"object"!=typeof e[a]||"object"!=typeof t[a]||t[a]instanceof Date?e[a]=t[a]:n(e[a],t[a]);}));};n(this,t);}}}));

    // import spriteUrl from '/resources/images/sprites/sprite.svg';
    class afLightbox {
        constructor(options) {

            this.modal = '';
            this.instanseIndex = null;
            if (options) {
                this.mobileBottom = (options.mobileInBottom ? options.mobileInBottom : false);
                this.classes = (options.classes ? options.classes : null);
            }

            this.init();
        }

        init() {

            if (typeof window.afLightbox == 'undefined') {
                window.afLightbox = {
                    items: [],
                    close: null,
                    closeAll: null
                };
            }

            window.afLightbox.items.push(this);
            this.instanseIndex = (window.afLightbox.items.length - 1);

            window.afLightbox.closeAll = () => {
                window.afLightbox.items.forEach(el => el.close());
                window.afLightbox.items = [];
            };

            window.afLightbox.close = () => {
                window.afLightbox.items[(window.afLightbox.items.length - 1)].close();
            };

        }

        createTemplate() {
            let template = document.createElement('div');
            template.innerHTML = `<div class="af-popup ${this.classes} "> <div class="af-popup__bg"></div><div class="af-popup__wrp"><div class="af-popup__container"><div class="af-popup__close btn"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M20 20L4 4m16 0L4 20"></path></svg></div><div class="af-popup__content"></div></div></div></div>`;
            document.body.append(template);
            this.instanse = template;
            return template;
        }

        open(content, afterShow) {

            let _this = this;
            this.modal = this.createTemplate();

            if (window.innerWidth <= 480 && this.mobileBottom) {
                this.modal.querySelector(".af-popup").classList.add("af-popup--mobile");
            }

            document.body.classList.add('page-hidden');

            this.modal.querySelector('.af-popup__content').innerHTML = content;
            this.modal.querySelector('.af-popup__close').addEventListener('click', function () {
                _this.close();
            });

            if (this.modal.querySelector('[data-af-popup="close"]')) {
                this.modal.querySelector('[data-af-popup="close"]').addEventListener('click', function (e) {
                    _this.close();
                });
            }

            if (afterShow) afterShow(this.modal);

            setTimeout(() => {
                this.modal.querySelector(".af-popup").classList.add("af-popup--visible");
            }, 10);

            this.createEvent();

        }

        changeContent(content) {
            this.modal.querySelector('.af-popup__content').innerHTML = content;
        }

        replaceContent(content) {
            this.modal.querySelector('.af-popup__content').replaceChildren(content);
        }

        createEvent() {

            let _this = this;

            this.instanse.querySelector('.af-popup').addEventListener('click', function (e) {
                if (!e.target.closest('.af-popup__container')) {
                    _this.close();
                }
            });

        }

        close() {

            this.instanse.querySelector('.af-popup').classList.remove('af-popup--visible');

            setTimeout(() => {
                this.instanse.remove();
                window.afLightbox.items.splice(this.instanseIndex, 1);

                if (!window.afLightbox.items.length) {
                    document.body.classList.toggle('page-hidden', false);
                }

            }, 300);


        }
    }

    function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

    function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

    /*!
     * Splide.js
     * Version  : 4.1.4
     * License  : MIT
     * Copyright: 2022 Naotoshi Fujita
     */
    var MEDIA_PREFERS_REDUCED_MOTION = "(prefers-reduced-motion: reduce)";
    var CREATED = 1;
    var MOUNTED = 2;
    var IDLE = 3;
    var MOVING = 4;
    var SCROLLING = 5;
    var DRAGGING = 6;
    var DESTROYED = 7;
    var STATES = {
      CREATED: CREATED,
      MOUNTED: MOUNTED,
      IDLE: IDLE,
      MOVING: MOVING,
      SCROLLING: SCROLLING,
      DRAGGING: DRAGGING,
      DESTROYED: DESTROYED
    };

    function empty(array) {
      array.length = 0;
    }

    function slice(arrayLike, start, end) {
      return Array.prototype.slice.call(arrayLike, start, end);
    }

    function apply(func) {
      return func.bind.apply(func, [null].concat(slice(arguments, 1)));
    }

    var nextTick = setTimeout;

    var noop = function noop() {};

    function raf(func) {
      return requestAnimationFrame(func);
    }

    function typeOf(type, subject) {
      return typeof subject === type;
    }

    function isObject(subject) {
      return !isNull(subject) && typeOf("object", subject);
    }

    var isArray = Array.isArray;
    var isFunction = apply(typeOf, "function");
    var isString = apply(typeOf, "string");
    var isUndefined = apply(typeOf, "undefined");

    function isNull(subject) {
      return subject === null;
    }

    function isHTMLElement(subject) {
      try {
        return subject instanceof (subject.ownerDocument.defaultView || window).HTMLElement;
      } catch (e) {
        return false;
      }
    }

    function toArray(value) {
      return isArray(value) ? value : [value];
    }

    function forEach(values, iteratee) {
      toArray(values).forEach(iteratee);
    }

    function includes(array, value) {
      return array.indexOf(value) > -1;
    }

    function push(array, items) {
      array.push.apply(array, toArray(items));
      return array;
    }

    function toggleClass(elm, classes, add) {
      if (elm) {
        forEach(classes, function (name) {
          if (name) {
            elm.classList[add ? "add" : "remove"](name);
          }
        });
      }
    }

    function addClass(elm, classes) {
      toggleClass(elm, isString(classes) ? classes.split(" ") : classes, true);
    }

    function append(parent, children) {
      forEach(children, parent.appendChild.bind(parent));
    }

    function before(nodes, ref) {
      forEach(nodes, function (node) {
        var parent = (ref || node).parentNode;

        if (parent) {
          parent.insertBefore(node, ref);
        }
      });
    }

    function matches(elm, selector) {
      return isHTMLElement(elm) && (elm["msMatchesSelector"] || elm.matches).call(elm, selector);
    }

    function children(parent, selector) {
      var children2 = parent ? slice(parent.children) : [];
      return selector ? children2.filter(function (child) {
        return matches(child, selector);
      }) : children2;
    }

    function child(parent, selector) {
      return selector ? children(parent, selector)[0] : parent.firstElementChild;
    }

    var ownKeys = Object.keys;

    function forOwn(object, iteratee, right) {
      if (object) {
        (right ? ownKeys(object).reverse() : ownKeys(object)).forEach(function (key) {
          key !== "__proto__" && iteratee(object[key], key);
        });
      }

      return object;
    }

    function assign(object) {
      slice(arguments, 1).forEach(function (source) {
        forOwn(source, function (value, key) {
          object[key] = source[key];
        });
      });
      return object;
    }

    function merge(object) {
      slice(arguments, 1).forEach(function (source) {
        forOwn(source, function (value, key) {
          if (isArray(value)) {
            object[key] = value.slice();
          } else if (isObject(value)) {
            object[key] = merge({}, isObject(object[key]) ? object[key] : {}, value);
          } else {
            object[key] = value;
          }
        });
      });
      return object;
    }

    function omit(object, keys) {
      forEach(keys || ownKeys(object), function (key) {
        delete object[key];
      });
    }

    function removeAttribute(elms, attrs) {
      forEach(elms, function (elm) {
        forEach(attrs, function (attr) {
          elm && elm.removeAttribute(attr);
        });
      });
    }

    function setAttribute(elms, attrs, value) {
      if (isObject(attrs)) {
        forOwn(attrs, function (value2, name) {
          setAttribute(elms, name, value2);
        });
      } else {
        forEach(elms, function (elm) {
          isNull(value) || value === "" ? removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
        });
      }
    }

    function create(tag, attrs, parent) {
      var elm = document.createElement(tag);

      if (attrs) {
        isString(attrs) ? addClass(elm, attrs) : setAttribute(elm, attrs);
      }

      parent && append(parent, elm);
      return elm;
    }

    function style(elm, prop, value) {
      if (isUndefined(value)) {
        return getComputedStyle(elm)[prop];
      }

      if (!isNull(value)) {
        elm.style[prop] = "" + value;
      }
    }

    function display(elm, display2) {
      style(elm, "display", display2);
    }

    function focus(elm) {
      elm["setActive"] && elm["setActive"]() || elm.focus({
        preventScroll: true
      });
    }

    function getAttribute(elm, attr) {
      return elm.getAttribute(attr);
    }

    function hasClass(elm, className) {
      return elm && elm.classList.contains(className);
    }

    function rect(target) {
      return target.getBoundingClientRect();
    }

    function remove(nodes) {
      forEach(nodes, function (node) {
        if (node && node.parentNode) {
          node.parentNode.removeChild(node);
        }
      });
    }

    function parseHtml(html) {
      return child(new DOMParser().parseFromString(html, "text/html").body);
    }

    function prevent(e, stopPropagation) {
      e.preventDefault();

      if (stopPropagation) {
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
    }

    function query(parent, selector) {
      return parent && parent.querySelector(selector);
    }

    function queryAll(parent, selector) {
      return selector ? slice(parent.querySelectorAll(selector)) : [];
    }

    function removeClass(elm, classes) {
      toggleClass(elm, classes, false);
    }

    function timeOf(e) {
      return e.timeStamp;
    }

    function unit(value) {
      return isString(value) ? value : value ? value + "px" : "";
    }

    var PROJECT_CODE = "splide";
    var DATA_ATTRIBUTE = "data-" + PROJECT_CODE;

    function assert(condition, message) {
      if (!condition) {
        throw new Error("[" + PROJECT_CODE + "] " + (message || ""));
      }
    }

    var min = Math.min,
        max = Math.max,
        floor = Math.floor,
        ceil = Math.ceil,
        abs = Math.abs;

    function approximatelyEqual(x, y, epsilon) {
      return abs(x - y) < epsilon;
    }

    function between(number, x, y, exclusive) {
      var minimum = min(x, y);
      var maximum = max(x, y);
      return exclusive ? minimum < number && number < maximum : minimum <= number && number <= maximum;
    }

    function clamp(number, x, y) {
      var minimum = min(x, y);
      var maximum = max(x, y);
      return min(max(minimum, number), maximum);
    }

    function sign(x) {
      return +(x > 0) - +(x < 0);
    }

    function format(string, replacements) {
      forEach(replacements, function (replacement) {
        string = string.replace("%s", "" + replacement);
      });
      return string;
    }

    function pad(number) {
      return number < 10 ? "0" + number : "" + number;
    }

    var ids = {};

    function uniqueId(prefix) {
      return "" + prefix + pad(ids[prefix] = (ids[prefix] || 0) + 1);
    }

    function EventBinder() {
      var listeners = [];

      function bind(targets, events, callback, options) {
        forEachEvent(targets, events, function (target, event, namespace) {
          var isEventTarget = ("addEventListener" in target);
          var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target["removeListener"].bind(target, callback);
          isEventTarget ? target.addEventListener(event, callback, options) : target["addListener"](callback);
          listeners.push([target, event, namespace, callback, remover]);
        });
      }

      function unbind(targets, events, callback) {
        forEachEvent(targets, events, function (target, event, namespace) {
          listeners = listeners.filter(function (listener) {
            if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
              listener[4]();
              return false;
            }

            return true;
          });
        });
      }

      function dispatch(target, type, detail) {
        var e;
        var bubbles = true;

        if (typeof CustomEvent === "function") {
          e = new CustomEvent(type, {
            bubbles: bubbles,
            detail: detail
          });
        } else {
          e = document.createEvent("CustomEvent");
          e.initCustomEvent(type, bubbles, false, detail);
        }

        target.dispatchEvent(e);
        return e;
      }

      function forEachEvent(targets, events, iteratee) {
        forEach(targets, function (target) {
          target && forEach(events, function (events2) {
            events2.split(" ").forEach(function (eventNS) {
              var fragment = eventNS.split(".");
              iteratee(target, fragment[0], fragment[1]);
            });
          });
        });
      }

      function destroy() {
        listeners.forEach(function (data) {
          data[4]();
        });
        empty(listeners);
      }

      return {
        bind: bind,
        unbind: unbind,
        dispatch: dispatch,
        destroy: destroy
      };
    }

    var EVENT_MOUNTED = "mounted";
    var EVENT_READY = "ready";
    var EVENT_MOVE = "move";
    var EVENT_MOVED = "moved";
    var EVENT_CLICK = "click";
    var EVENT_ACTIVE = "active";
    var EVENT_INACTIVE = "inactive";
    var EVENT_VISIBLE = "visible";
    var EVENT_HIDDEN = "hidden";
    var EVENT_REFRESH = "refresh";
    var EVENT_UPDATED = "updated";
    var EVENT_RESIZE = "resize";
    var EVENT_RESIZED = "resized";
    var EVENT_DRAG = "drag";
    var EVENT_DRAGGING = "dragging";
    var EVENT_DRAGGED = "dragged";
    var EVENT_SCROLL = "scroll";
    var EVENT_SCROLLED = "scrolled";
    var EVENT_OVERFLOW = "overflow";
    var EVENT_DESTROY = "destroy";
    var EVENT_ARROWS_MOUNTED = "arrows:mounted";
    var EVENT_ARROWS_UPDATED = "arrows:updated";
    var EVENT_PAGINATION_MOUNTED = "pagination:mounted";
    var EVENT_PAGINATION_UPDATED = "pagination:updated";
    var EVENT_NAVIGATION_MOUNTED = "navigation:mounted";
    var EVENT_AUTOPLAY_PLAY = "autoplay:play";
    var EVENT_AUTOPLAY_PLAYING = "autoplay:playing";
    var EVENT_AUTOPLAY_PAUSE = "autoplay:pause";
    var EVENT_LAZYLOAD_LOADED = "lazyload:loaded";
    var EVENT_SLIDE_KEYDOWN = "sk";
    var EVENT_SHIFTED = "sh";
    var EVENT_END_INDEX_CHANGED = "ei";

    function EventInterface(Splide2) {
      var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
      var binder = EventBinder();

      function on(events, callback) {
        binder.bind(bus, toArray(events).join(" "), function (e) {
          callback.apply(callback, isArray(e.detail) ? e.detail : []);
        });
      }

      function emit(event) {
        binder.dispatch(bus, event, slice(arguments, 1));
      }

      if (Splide2) {
        Splide2.event.on(EVENT_DESTROY, binder.destroy);
      }

      return assign(binder, {
        bus: bus,
        on: on,
        off: apply(binder.unbind, bus),
        emit: emit
      });
    }

    function RequestInterval(interval, onInterval, onUpdate, limit) {
      var now = Date.now;
      var startTime;
      var rate = 0;
      var id;
      var paused = true;
      var count = 0;

      function update() {
        if (!paused) {
          rate = interval ? min((now() - startTime) / interval, 1) : 1;
          onUpdate && onUpdate(rate);

          if (rate >= 1) {
            onInterval();
            startTime = now();

            if (limit && ++count >= limit) {
              return pause();
            }
          }

          id = raf(update);
        }
      }

      function start(resume) {
        resume || cancel();
        startTime = now() - (resume ? rate * interval : 0);
        paused = false;
        id = raf(update);
      }

      function pause() {
        paused = true;
      }

      function rewind() {
        startTime = now();
        rate = 0;

        if (onUpdate) {
          onUpdate(rate);
        }
      }

      function cancel() {
        id && cancelAnimationFrame(id);
        rate = 0;
        id = 0;
        paused = true;
      }

      function set(time) {
        interval = time;
      }

      function isPaused() {
        return paused;
      }

      return {
        start: start,
        rewind: rewind,
        pause: pause,
        cancel: cancel,
        set: set,
        isPaused: isPaused
      };
    }

    function State(initialState) {
      var state = initialState;

      function set(value) {
        state = value;
      }

      function is(states) {
        return includes(toArray(states), state);
      }

      return {
        set: set,
        is: is
      };
    }

    function Throttle(func, duration) {
      var interval = RequestInterval(0, func, null, 1);
      return function () {
        interval.isPaused() && interval.start();
      };
    }

    function Media(Splide2, Components2, options) {
      var state = Splide2.state;
      var breakpoints = options.breakpoints || {};
      var reducedMotion = options.reducedMotion || {};
      var binder = EventBinder();
      var queries = [];

      function setup() {
        var isMin = options.mediaQuery === "min";
        ownKeys(breakpoints).sort(function (n, m) {
          return isMin ? +n - +m : +m - +n;
        }).forEach(function (key) {
          register(breakpoints[key], "(" + (isMin ? "min" : "max") + "-width:" + key + "px)");
        });
        register(reducedMotion, MEDIA_PREFERS_REDUCED_MOTION);
        update();
      }

      function destroy(completely) {
        if (completely) {
          binder.destroy();
        }
      }

      function register(options2, query) {
        var queryList = matchMedia(query);
        binder.bind(queryList, "change", update);
        queries.push([options2, queryList]);
      }

      function update() {
        var destroyed = state.is(DESTROYED);
        var direction = options.direction;
        var merged = queries.reduce(function (merged2, entry) {
          return merge(merged2, entry[1].matches ? entry[0] : {});
        }, {});
        omit(options);
        set(merged);

        if (options.destroy) {
          Splide2.destroy(options.destroy === "completely");
        } else if (destroyed) {
          destroy(true);
          Splide2.mount();
        } else {
          direction !== options.direction && Splide2.refresh();
        }
      }

      function reduce(enable) {
        if (matchMedia(MEDIA_PREFERS_REDUCED_MOTION).matches) {
          enable ? merge(options, reducedMotion) : omit(options, ownKeys(reducedMotion));
        }
      }

      function set(opts, base, notify) {
        merge(options, opts);
        base && merge(Object.getPrototypeOf(options), opts);

        if (notify || !state.is(CREATED)) {
          Splide2.emit(EVENT_UPDATED, options);
        }
      }

      return {
        setup: setup,
        destroy: destroy,
        reduce: reduce,
        set: set
      };
    }

    var ARROW = "Arrow";
    var ARROW_LEFT = ARROW + "Left";
    var ARROW_RIGHT = ARROW + "Right";
    var ARROW_UP = ARROW + "Up";
    var ARROW_DOWN = ARROW + "Down";
    var RTL = "rtl";
    var TTB = "ttb";
    var ORIENTATION_MAP = {
      width: ["height"],
      left: ["top", "right"],
      right: ["bottom", "left"],
      x: ["y"],
      X: ["Y"],
      Y: ["X"],
      ArrowLeft: [ARROW_UP, ARROW_RIGHT],
      ArrowRight: [ARROW_DOWN, ARROW_LEFT]
    };

    function Direction(Splide2, Components2, options) {
      function resolve(prop, axisOnly, direction) {
        direction = direction || options.direction;
        var index = direction === RTL && !axisOnly ? 1 : direction === TTB ? 0 : -1;
        return ORIENTATION_MAP[prop] && ORIENTATION_MAP[prop][index] || prop.replace(/width|left|right/i, function (match, offset) {
          var replacement = ORIENTATION_MAP[match.toLowerCase()][index] || match;
          return offset > 0 ? replacement.charAt(0).toUpperCase() + replacement.slice(1) : replacement;
        });
      }

      function orient(value) {
        return value * (options.direction === RTL ? 1 : -1);
      }

      return {
        resolve: resolve,
        orient: orient
      };
    }

    var ROLE = "role";
    var TAB_INDEX = "tabindex";
    var DISABLED = "disabled";
    var ARIA_PREFIX = "aria-";
    var ARIA_CONTROLS = ARIA_PREFIX + "controls";
    var ARIA_CURRENT = ARIA_PREFIX + "current";
    var ARIA_SELECTED = ARIA_PREFIX + "selected";
    var ARIA_LABEL = ARIA_PREFIX + "label";
    var ARIA_LABELLEDBY = ARIA_PREFIX + "labelledby";
    var ARIA_HIDDEN = ARIA_PREFIX + "hidden";
    var ARIA_ORIENTATION = ARIA_PREFIX + "orientation";
    var ARIA_ROLEDESCRIPTION = ARIA_PREFIX + "roledescription";
    var ARIA_LIVE = ARIA_PREFIX + "live";
    var ARIA_BUSY = ARIA_PREFIX + "busy";
    var ARIA_ATOMIC = ARIA_PREFIX + "atomic";
    var ALL_ATTRIBUTES = [ROLE, TAB_INDEX, DISABLED, ARIA_CONTROLS, ARIA_CURRENT, ARIA_LABEL, ARIA_LABELLEDBY, ARIA_HIDDEN, ARIA_ORIENTATION, ARIA_ROLEDESCRIPTION];
    var CLASS_PREFIX = PROJECT_CODE + "__";
    var STATUS_CLASS_PREFIX = "is-";
    var CLASS_ROOT = PROJECT_CODE;
    var CLASS_TRACK = CLASS_PREFIX + "track";
    var CLASS_LIST = CLASS_PREFIX + "list";
    var CLASS_SLIDE = CLASS_PREFIX + "slide";
    var CLASS_CLONE = CLASS_SLIDE + "--clone";
    var CLASS_CONTAINER = CLASS_SLIDE + "__container";
    var CLASS_ARROWS = CLASS_PREFIX + "arrows";
    var CLASS_ARROW = CLASS_PREFIX + "arrow";
    var CLASS_ARROW_PREV = CLASS_ARROW + "--prev";
    var CLASS_ARROW_NEXT = CLASS_ARROW + "--next";
    var CLASS_PAGINATION = CLASS_PREFIX + "pagination";
    var CLASS_PAGINATION_PAGE = CLASS_PAGINATION + "__page";
    var CLASS_PROGRESS = CLASS_PREFIX + "progress";
    var CLASS_PROGRESS_BAR = CLASS_PROGRESS + "__bar";
    var CLASS_TOGGLE = CLASS_PREFIX + "toggle";
    var CLASS_SPINNER = CLASS_PREFIX + "spinner";
    var CLASS_SR = CLASS_PREFIX + "sr";
    var CLASS_INITIALIZED = STATUS_CLASS_PREFIX + "initialized";
    var CLASS_ACTIVE = STATUS_CLASS_PREFIX + "active";
    var CLASS_PREV = STATUS_CLASS_PREFIX + "prev";
    var CLASS_NEXT = STATUS_CLASS_PREFIX + "next";
    var CLASS_VISIBLE = STATUS_CLASS_PREFIX + "visible";
    var CLASS_LOADING = STATUS_CLASS_PREFIX + "loading";
    var CLASS_FOCUS_IN = STATUS_CLASS_PREFIX + "focus-in";
    var CLASS_OVERFLOW = STATUS_CLASS_PREFIX + "overflow";
    var STATUS_CLASSES = [CLASS_ACTIVE, CLASS_VISIBLE, CLASS_PREV, CLASS_NEXT, CLASS_LOADING, CLASS_FOCUS_IN, CLASS_OVERFLOW];
    var CLASSES = {
      slide: CLASS_SLIDE,
      clone: CLASS_CLONE,
      arrows: CLASS_ARROWS,
      arrow: CLASS_ARROW,
      prev: CLASS_ARROW_PREV,
      next: CLASS_ARROW_NEXT,
      pagination: CLASS_PAGINATION,
      page: CLASS_PAGINATION_PAGE,
      spinner: CLASS_SPINNER
    };

    function closest(from, selector) {
      if (isFunction(from.closest)) {
        return from.closest(selector);
      }

      var elm = from;

      while (elm && elm.nodeType === 1) {
        if (matches(elm, selector)) {
          break;
        }

        elm = elm.parentElement;
      }

      return elm;
    }

    var FRICTION = 5;
    var LOG_INTERVAL = 200;
    var POINTER_DOWN_EVENTS = "touchstart mousedown";
    var POINTER_MOVE_EVENTS = "touchmove mousemove";
    var POINTER_UP_EVENTS = "touchend touchcancel mouseup click";

    function Elements(Splide2, Components2, options) {
      var _EventInterface = EventInterface(Splide2),
          on = _EventInterface.on,
          bind = _EventInterface.bind;

      var root = Splide2.root;
      var i18n = options.i18n;
      var elements = {};
      var slides = [];
      var rootClasses = [];
      var trackClasses = [];
      var track;
      var list;
      var isUsingKey;

      function setup() {
        collect();
        init();
        update();
      }

      function mount() {
        on(EVENT_REFRESH, destroy);
        on(EVENT_REFRESH, setup);
        on(EVENT_UPDATED, update);
        bind(document, POINTER_DOWN_EVENTS + " keydown", function (e) {
          isUsingKey = e.type === "keydown";
        }, {
          capture: true
        });
        bind(root, "focusin", function () {
          toggleClass(root, CLASS_FOCUS_IN, !!isUsingKey);
        });
      }

      function destroy(completely) {
        var attrs = ALL_ATTRIBUTES.concat("style");
        empty(slides);
        removeClass(root, rootClasses);
        removeClass(track, trackClasses);
        removeAttribute([track, list], attrs);
        removeAttribute(root, completely ? attrs : ["style", ARIA_ROLEDESCRIPTION]);
      }

      function update() {
        removeClass(root, rootClasses);
        removeClass(track, trackClasses);
        rootClasses = getClasses(CLASS_ROOT);
        trackClasses = getClasses(CLASS_TRACK);
        addClass(root, rootClasses);
        addClass(track, trackClasses);
        setAttribute(root, ARIA_LABEL, options.label);
        setAttribute(root, ARIA_LABELLEDBY, options.labelledby);
      }

      function collect() {
        track = find("." + CLASS_TRACK);
        list = child(track, "." + CLASS_LIST);
        assert(track && list, "A track/list element is missing.");
        push(slides, children(list, "." + CLASS_SLIDE + ":not(." + CLASS_CLONE + ")"));
        forOwn({
          arrows: CLASS_ARROWS,
          pagination: CLASS_PAGINATION,
          prev: CLASS_ARROW_PREV,
          next: CLASS_ARROW_NEXT,
          bar: CLASS_PROGRESS_BAR,
          toggle: CLASS_TOGGLE
        }, function (className, key) {
          elements[key] = find("." + className);
        });
        assign(elements, {
          root: root,
          track: track,
          list: list,
          slides: slides
        });
      }

      function init() {
        var id = root.id || uniqueId(PROJECT_CODE);
        var role = options.role;
        root.id = id;
        track.id = track.id || id + "-track";
        list.id = list.id || id + "-list";

        if (!getAttribute(root, ROLE) && root.tagName !== "SECTION" && role) {
          setAttribute(root, ROLE, role);
        }

        setAttribute(root, ARIA_ROLEDESCRIPTION, i18n.carousel);
        setAttribute(list, ROLE, "presentation");
      }

      function find(selector) {
        var elm = query(root, selector);
        return elm && closest(elm, "." + CLASS_ROOT) === root ? elm : void 0;
      }

      function getClasses(base) {
        return [base + "--" + options.type, base + "--" + options.direction, options.drag && base + "--draggable", options.isNavigation && base + "--nav", base === CLASS_ROOT && CLASS_ACTIVE];
      }

      return assign(elements, {
        setup: setup,
        mount: mount,
        destroy: destroy
      });
    }

    var SLIDE = "slide";
    var LOOP = "loop";
    var FADE = "fade";

    function Slide$1(Splide2, index, slideIndex, slide) {
      var event = EventInterface(Splide2);
      var on = event.on,
          emit = event.emit,
          bind = event.bind;
      var Components = Splide2.Components,
          root = Splide2.root,
          options = Splide2.options;
      var isNavigation = options.isNavigation,
          updateOnMove = options.updateOnMove,
          i18n = options.i18n,
          pagination = options.pagination,
          slideFocus = options.slideFocus;
      var resolve = Components.Direction.resolve;
      var styles = getAttribute(slide, "style");
      var label = getAttribute(slide, ARIA_LABEL);
      var isClone = slideIndex > -1;
      var container = child(slide, "." + CLASS_CONTAINER);
      var destroyed;

      function mount() {
        if (!isClone) {
          slide.id = root.id + "-slide" + pad(index + 1);
          setAttribute(slide, ROLE, pagination ? "tabpanel" : "group");
          setAttribute(slide, ARIA_ROLEDESCRIPTION, i18n.slide);
          setAttribute(slide, ARIA_LABEL, label || format(i18n.slideLabel, [index + 1, Splide2.length]));
        }

        listen();
      }

      function listen() {
        bind(slide, "click", apply(emit, EVENT_CLICK, self));
        bind(slide, "keydown", apply(emit, EVENT_SLIDE_KEYDOWN, self));
        on([EVENT_MOVED, EVENT_SHIFTED, EVENT_SCROLLED], update);
        on(EVENT_NAVIGATION_MOUNTED, initNavigation);

        if (updateOnMove) {
          on(EVENT_MOVE, onMove);
        }
      }

      function destroy() {
        destroyed = true;
        event.destroy();
        removeClass(slide, STATUS_CLASSES);
        removeAttribute(slide, ALL_ATTRIBUTES);
        setAttribute(slide, "style", styles);
        setAttribute(slide, ARIA_LABEL, label || "");
      }

      function initNavigation() {
        var controls = Splide2.splides.map(function (target) {
          var Slide2 = target.splide.Components.Slides.getAt(index);
          return Slide2 ? Slide2.slide.id : "";
        }).join(" ");
        setAttribute(slide, ARIA_LABEL, format(i18n.slideX, (isClone ? slideIndex : index) + 1));
        setAttribute(slide, ARIA_CONTROLS, controls);
        setAttribute(slide, ROLE, slideFocus ? "button" : "");
        slideFocus && removeAttribute(slide, ARIA_ROLEDESCRIPTION);
      }

      function onMove() {
        if (!destroyed) {
          update();
        }
      }

      function update() {
        if (!destroyed) {
          var curr = Splide2.index;
          updateActivity();
          updateVisibility();
          toggleClass(slide, CLASS_PREV, index === curr - 1);
          toggleClass(slide, CLASS_NEXT, index === curr + 1);
        }
      }

      function updateActivity() {
        var active = isActive();

        if (active !== hasClass(slide, CLASS_ACTIVE)) {
          toggleClass(slide, CLASS_ACTIVE, active);
          setAttribute(slide, ARIA_CURRENT, isNavigation && active || "");
          emit(active ? EVENT_ACTIVE : EVENT_INACTIVE, self);
        }
      }

      function updateVisibility() {
        var visible = isVisible();
        var hidden = !visible && (!isActive() || isClone);

        if (!Splide2.state.is([MOVING, SCROLLING])) {
          setAttribute(slide, ARIA_HIDDEN, hidden || "");
        }

        setAttribute(queryAll(slide, options.focusableNodes || ""), TAB_INDEX, hidden ? -1 : "");

        if (slideFocus) {
          setAttribute(slide, TAB_INDEX, hidden ? -1 : 0);
        }

        if (visible !== hasClass(slide, CLASS_VISIBLE)) {
          toggleClass(slide, CLASS_VISIBLE, visible);
          emit(visible ? EVENT_VISIBLE : EVENT_HIDDEN, self);
        }

        if (!visible && document.activeElement === slide) {
          var Slide2 = Components.Slides.getAt(Splide2.index);
          Slide2 && focus(Slide2.slide);
        }
      }

      function style$1(prop, value, useContainer) {
        style(useContainer && container || slide, prop, value);
      }

      function isActive() {
        var curr = Splide2.index;
        return curr === index || options.cloneStatus && curr === slideIndex;
      }

      function isVisible() {
        if (Splide2.is(FADE)) {
          return isActive();
        }

        var trackRect = rect(Components.Elements.track);
        var slideRect = rect(slide);
        var left = resolve("left", true);
        var right = resolve("right", true);
        return floor(trackRect[left]) <= ceil(slideRect[left]) && floor(slideRect[right]) <= ceil(trackRect[right]);
      }

      function isWithin(from, distance) {
        var diff = abs(from - index);

        if (!isClone && (options.rewind || Splide2.is(LOOP))) {
          diff = min(diff, Splide2.length - diff);
        }

        return diff <= distance;
      }

      var self = {
        index: index,
        slideIndex: slideIndex,
        slide: slide,
        container: container,
        isClone: isClone,
        mount: mount,
        destroy: destroy,
        update: update,
        style: style$1,
        isWithin: isWithin
      };
      return self;
    }

    function Slides(Splide2, Components2, options) {
      var _EventInterface2 = EventInterface(Splide2),
          on = _EventInterface2.on,
          emit = _EventInterface2.emit,
          bind = _EventInterface2.bind;

      var _Components2$Elements = Components2.Elements,
          slides = _Components2$Elements.slides,
          list = _Components2$Elements.list;
      var Slides2 = [];

      function mount() {
        init();
        on(EVENT_REFRESH, destroy);
        on(EVENT_REFRESH, init);
      }

      function init() {
        slides.forEach(function (slide, index) {
          register(slide, index, -1);
        });
      }

      function destroy() {
        forEach$1(function (Slide2) {
          Slide2.destroy();
        });
        empty(Slides2);
      }

      function update() {
        forEach$1(function (Slide2) {
          Slide2.update();
        });
      }

      function register(slide, index, slideIndex) {
        var object = Slide$1(Splide2, index, slideIndex, slide);
        object.mount();
        Slides2.push(object);
        Slides2.sort(function (Slide1, Slide2) {
          return Slide1.index - Slide2.index;
        });
      }

      function get(excludeClones) {
        return excludeClones ? filter(function (Slide2) {
          return !Slide2.isClone;
        }) : Slides2;
      }

      function getIn(page) {
        var Controller = Components2.Controller;
        var index = Controller.toIndex(page);
        var max = Controller.hasFocus() ? 1 : options.perPage;
        return filter(function (Slide2) {
          return between(Slide2.index, index, index + max - 1);
        });
      }

      function getAt(index) {
        return filter(index)[0];
      }

      function add(items, index) {
        forEach(items, function (slide) {
          if (isString(slide)) {
            slide = parseHtml(slide);
          }

          if (isHTMLElement(slide)) {
            var ref = slides[index];
            ref ? before(slide, ref) : append(list, slide);
            addClass(slide, options.classes.slide);
            observeImages(slide, apply(emit, EVENT_RESIZE));
          }
        });
        emit(EVENT_REFRESH);
      }

      function remove$1(matcher) {
        remove(filter(matcher).map(function (Slide2) {
          return Slide2.slide;
        }));
        emit(EVENT_REFRESH);
      }

      function forEach$1(iteratee, excludeClones) {
        get(excludeClones).forEach(iteratee);
      }

      function filter(matcher) {
        return Slides2.filter(isFunction(matcher) ? matcher : function (Slide2) {
          return isString(matcher) ? matches(Slide2.slide, matcher) : includes(toArray(matcher), Slide2.index);
        });
      }

      function style(prop, value, useContainer) {
        forEach$1(function (Slide2) {
          Slide2.style(prop, value, useContainer);
        });
      }

      function observeImages(elm, callback) {
        var images = queryAll(elm, "img");
        var length = images.length;

        if (length) {
          images.forEach(function (img) {
            bind(img, "load error", function () {
              if (! --length) {
                callback();
              }
            });
          });
        } else {
          callback();
        }
      }

      function getLength(excludeClones) {
        return excludeClones ? slides.length : Slides2.length;
      }

      function isEnough() {
        return Slides2.length > options.perPage;
      }

      return {
        mount: mount,
        destroy: destroy,
        update: update,
        register: register,
        get: get,
        getIn: getIn,
        getAt: getAt,
        add: add,
        remove: remove$1,
        forEach: forEach$1,
        filter: filter,
        style: style,
        getLength: getLength,
        isEnough: isEnough
      };
    }

    function Layout(Splide2, Components2, options) {
      var _EventInterface3 = EventInterface(Splide2),
          on = _EventInterface3.on,
          bind = _EventInterface3.bind,
          emit = _EventInterface3.emit;

      var Slides = Components2.Slides;
      var resolve = Components2.Direction.resolve;
      var _Components2$Elements2 = Components2.Elements,
          root = _Components2$Elements2.root,
          track = _Components2$Elements2.track,
          list = _Components2$Elements2.list;
      var getAt = Slides.getAt,
          styleSlides = Slides.style;
      var vertical;
      var rootRect;
      var overflow;

      function mount() {
        init();
        bind(window, "resize load", Throttle(apply(emit, EVENT_RESIZE)));
        on([EVENT_UPDATED, EVENT_REFRESH], init);
        on(EVENT_RESIZE, resize);
      }

      function init() {
        vertical = options.direction === TTB;
        style(root, "maxWidth", unit(options.width));
        style(track, resolve("paddingLeft"), cssPadding(false));
        style(track, resolve("paddingRight"), cssPadding(true));
        resize(true);
      }

      function resize(force) {
        var newRect = rect(root);

        if (force || rootRect.width !== newRect.width || rootRect.height !== newRect.height) {
          style(track, "height", cssTrackHeight());
          styleSlides(resolve("marginRight"), unit(options.gap));
          styleSlides("width", cssSlideWidth());
          styleSlides("height", cssSlideHeight(), true);
          rootRect = newRect;
          emit(EVENT_RESIZED);

          if (overflow !== (overflow = isOverflow())) {
            toggleClass(root, CLASS_OVERFLOW, overflow);
            emit(EVENT_OVERFLOW, overflow);
          }
        }
      }

      function cssPadding(right) {
        var padding = options.padding;
        var prop = resolve(right ? "right" : "left");
        return padding && unit(padding[prop] || (isObject(padding) ? 0 : padding)) || "0px";
      }

      function cssTrackHeight() {
        var height = "";

        if (vertical) {
          height = cssHeight();
          assert(height, "height or heightRatio is missing.");
          height = "calc(" + height + " - " + cssPadding(false) + " - " + cssPadding(true) + ")";
        }

        return height;
      }

      function cssHeight() {
        return unit(options.height || rect(list).width * options.heightRatio);
      }

      function cssSlideWidth() {
        return options.autoWidth ? null : unit(options.fixedWidth) || (vertical ? "" : cssSlideSize());
      }

      function cssSlideHeight() {
        return unit(options.fixedHeight) || (vertical ? options.autoHeight ? null : cssSlideSize() : cssHeight());
      }

      function cssSlideSize() {
        var gap = unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
      }

      function listSize() {
        return rect(list)[resolve("width")];
      }

      function slideSize(index, withoutGap) {
        var Slide = getAt(index || 0);
        return Slide ? rect(Slide.slide)[resolve("width")] + (withoutGap ? 0 : getGap()) : 0;
      }

      function totalSize(index, withoutGap) {
        var Slide = getAt(index);

        if (Slide) {
          var right = rect(Slide.slide)[resolve("right")];
          var left = rect(list)[resolve("left")];
          return abs(right - left) + (withoutGap ? 0 : getGap());
        }

        return 0;
      }

      function sliderSize(withoutGap) {
        return totalSize(Splide2.length - 1) - totalSize(0) + slideSize(0, withoutGap);
      }

      function getGap() {
        var Slide = getAt(0);
        return Slide && parseFloat(style(Slide.slide, resolve("marginRight"))) || 0;
      }

      function getPadding(right) {
        return parseFloat(style(track, resolve("padding" + (right ? "Right" : "Left")))) || 0;
      }

      function isOverflow() {
        return Splide2.is(FADE) || sliderSize(true) > listSize();
      }

      return {
        mount: mount,
        resize: resize,
        listSize: listSize,
        slideSize: slideSize,
        sliderSize: sliderSize,
        totalSize: totalSize,
        getPadding: getPadding,
        isOverflow: isOverflow
      };
    }

    var MULTIPLIER = 2;

    function Clones(Splide2, Components2, options) {
      var event = EventInterface(Splide2);
      var on = event.on;
      var Elements = Components2.Elements,
          Slides = Components2.Slides;
      var resolve = Components2.Direction.resolve;
      var clones = [];
      var cloneCount;

      function mount() {
        on(EVENT_REFRESH, remount);
        on([EVENT_UPDATED, EVENT_RESIZE], observe);

        if (cloneCount = computeCloneCount()) {
          generate(cloneCount);
          Components2.Layout.resize(true);
        }
      }

      function remount() {
        destroy();
        mount();
      }

      function destroy() {
        remove(clones);
        empty(clones);
        event.destroy();
      }

      function observe() {
        var count = computeCloneCount();

        if (cloneCount !== count) {
          if (cloneCount < count || !count) {
            event.emit(EVENT_REFRESH);
          }
        }
      }

      function generate(count) {
        var slides = Slides.get().slice();
        var length = slides.length;

        if (length) {
          while (slides.length < count) {
            push(slides, slides);
          }

          push(slides.slice(-count), slides.slice(0, count)).forEach(function (Slide, index) {
            var isHead = index < count;
            var clone = cloneDeep(Slide.slide, index);
            isHead ? before(clone, slides[0].slide) : append(Elements.list, clone);
            push(clones, clone);
            Slides.register(clone, index - count + (isHead ? 0 : length), Slide.index);
          });
        }
      }

      function cloneDeep(elm, index) {
        var clone = elm.cloneNode(true);
        addClass(clone, options.classes.clone);
        clone.id = Splide2.root.id + "-clone" + pad(index + 1);
        return clone;
      }

      function computeCloneCount() {
        var clones2 = options.clones;

        if (!Splide2.is(LOOP)) {
          clones2 = 0;
        } else if (isUndefined(clones2)) {
          var fixedSize = options[resolve("fixedWidth")] && Components2.Layout.slideSize(0);
          var fixedCount = fixedSize && ceil(rect(Elements.track)[resolve("width")] / fixedSize);
          clones2 = fixedCount || options[resolve("autoWidth")] && Splide2.length || options.perPage * MULTIPLIER;
        }

        return clones2;
      }

      return {
        mount: mount,
        destroy: destroy
      };
    }

    function Move(Splide2, Components2, options) {
      var _EventInterface4 = EventInterface(Splide2),
          on = _EventInterface4.on,
          emit = _EventInterface4.emit;

      var set = Splide2.state.set;
      var _Components2$Layout = Components2.Layout,
          slideSize = _Components2$Layout.slideSize,
          getPadding = _Components2$Layout.getPadding,
          totalSize = _Components2$Layout.totalSize,
          listSize = _Components2$Layout.listSize,
          sliderSize = _Components2$Layout.sliderSize;
      var _Components2$Directio = Components2.Direction,
          resolve = _Components2$Directio.resolve,
          orient = _Components2$Directio.orient;
      var _Components2$Elements3 = Components2.Elements,
          list = _Components2$Elements3.list,
          track = _Components2$Elements3.track;
      var Transition;

      function mount() {
        Transition = Components2.Transition;
        on([EVENT_MOUNTED, EVENT_RESIZED, EVENT_UPDATED, EVENT_REFRESH], reposition);
      }

      function reposition() {
        if (!Components2.Controller.isBusy()) {
          Components2.Scroll.cancel();
          jump(Splide2.index);
          Components2.Slides.update();
        }
      }

      function move(dest, index, prev, callback) {
        if (dest !== index && canShift(dest > prev)) {
          cancel();
          translate(shift(getPosition(), dest > prev), true);
        }

        set(MOVING);
        emit(EVENT_MOVE, index, prev, dest);
        Transition.start(index, function () {
          set(IDLE);
          emit(EVENT_MOVED, index, prev, dest);
          callback && callback();
        });
      }

      function jump(index) {
        translate(toPosition(index, true));
      }

      function translate(position, preventLoop) {
        if (!Splide2.is(FADE)) {
          var destination = preventLoop ? position : loop(position);
          style(list, "transform", "translate" + resolve("X") + "(" + destination + "px)");
          position !== destination && emit(EVENT_SHIFTED);
        }
      }

      function loop(position) {
        if (Splide2.is(LOOP)) {
          var index = toIndex(position);
          var exceededMax = index > Components2.Controller.getEnd();
          var exceededMin = index < 0;

          if (exceededMin || exceededMax) {
            position = shift(position, exceededMax);
          }
        }

        return position;
      }

      function shift(position, backwards) {
        var excess = position - getLimit(backwards);
        var size = sliderSize();
        position -= orient(size * (ceil(abs(excess) / size) || 1)) * (backwards ? 1 : -1);
        return position;
      }

      function cancel() {
        translate(getPosition(), true);
        Transition.cancel();
      }

      function toIndex(position) {
        var Slides = Components2.Slides.get();
        var index = 0;
        var minDistance = Infinity;

        for (var i = 0; i < Slides.length; i++) {
          var slideIndex = Slides[i].index;
          var distance = abs(toPosition(slideIndex, true) - position);

          if (distance <= minDistance) {
            minDistance = distance;
            index = slideIndex;
          } else {
            break;
          }
        }

        return index;
      }

      function toPosition(index, trimming) {
        var position = orient(totalSize(index - 1) - offset(index));
        return trimming ? trim(position) : position;
      }

      function getPosition() {
        var left = resolve("left");
        return rect(list)[left] - rect(track)[left] + orient(getPadding(false));
      }

      function trim(position) {
        if (options.trimSpace && Splide2.is(SLIDE)) {
          position = clamp(position, 0, orient(sliderSize(true) - listSize()));
        }

        return position;
      }

      function offset(index) {
        var focus = options.focus;
        return focus === "center" ? (listSize() - slideSize(index, true)) / 2 : +focus * slideSize(index) || 0;
      }

      function getLimit(max) {
        return toPosition(max ? Components2.Controller.getEnd() : 0, !!options.trimSpace);
      }

      function canShift(backwards) {
        var shifted = orient(shift(getPosition(), backwards));
        return backwards ? shifted >= 0 : shifted <= list[resolve("scrollWidth")] - rect(track)[resolve("width")];
      }

      function exceededLimit(max, position) {
        position = isUndefined(position) ? getPosition() : position;
        var exceededMin = max !== true && orient(position) < orient(getLimit(false));
        var exceededMax = max !== false && orient(position) > orient(getLimit(true));
        return exceededMin || exceededMax;
      }

      return {
        mount: mount,
        move: move,
        jump: jump,
        translate: translate,
        shift: shift,
        cancel: cancel,
        toIndex: toIndex,
        toPosition: toPosition,
        getPosition: getPosition,
        getLimit: getLimit,
        exceededLimit: exceededLimit,
        reposition: reposition
      };
    }

    function Controller(Splide2, Components2, options) {
      var _EventInterface5 = EventInterface(Splide2),
          on = _EventInterface5.on,
          emit = _EventInterface5.emit;

      var Move = Components2.Move;
      var getPosition = Move.getPosition,
          getLimit = Move.getLimit,
          toPosition = Move.toPosition;
      var _Components2$Slides = Components2.Slides,
          isEnough = _Components2$Slides.isEnough,
          getLength = _Components2$Slides.getLength;
      var omitEnd = options.omitEnd;
      var isLoop = Splide2.is(LOOP);
      var isSlide = Splide2.is(SLIDE);
      var getNext = apply(getAdjacent, false);
      var getPrev = apply(getAdjacent, true);
      var currIndex = options.start || 0;
      var endIndex;
      var prevIndex = currIndex;
      var slideCount;
      var perMove;
      var perPage;

      function mount() {
        init();
        on([EVENT_UPDATED, EVENT_REFRESH, EVENT_END_INDEX_CHANGED], init);
        on(EVENT_RESIZED, onResized);
      }

      function init() {
        slideCount = getLength(true);
        perMove = options.perMove;
        perPage = options.perPage;
        endIndex = getEnd();
        var index = clamp(currIndex, 0, omitEnd ? endIndex : slideCount - 1);

        if (index !== currIndex) {
          currIndex = index;
          Move.reposition();
        }
      }

      function onResized() {
        if (endIndex !== getEnd()) {
          emit(EVENT_END_INDEX_CHANGED);
        }
      }

      function go(control, allowSameIndex, callback) {
        if (!isBusy()) {
          var dest = parse(control);
          var index = loop(dest);

          if (index > -1 && (allowSameIndex || index !== currIndex)) {
            setIndex(index);
            Move.move(dest, index, prevIndex, callback);
          }
        }
      }

      function scroll(destination, duration, snap, callback) {
        Components2.Scroll.scroll(destination, duration, snap, function () {
          var index = loop(Move.toIndex(getPosition()));
          setIndex(omitEnd ? min(index, endIndex) : index);
          callback && callback();
        });
      }

      function parse(control) {
        var index = currIndex;

        if (isString(control)) {
          var _ref = control.match(/([+\-<>])(\d+)?/) || [],
              indicator = _ref[1],
              number = _ref[2];

          if (indicator === "+" || indicator === "-") {
            index = computeDestIndex(currIndex + +("" + indicator + (+number || 1)), currIndex);
          } else if (indicator === ">") {
            index = number ? toIndex(+number) : getNext(true);
          } else if (indicator === "<") {
            index = getPrev(true);
          }
        } else {
          index = isLoop ? control : clamp(control, 0, endIndex);
        }

        return index;
      }

      function getAdjacent(prev, destination) {
        var number = perMove || (hasFocus() ? 1 : perPage);
        var dest = computeDestIndex(currIndex + number * (prev ? -1 : 1), currIndex, !(perMove || hasFocus()));

        if (dest === -1 && isSlide) {
          if (!approximatelyEqual(getPosition(), getLimit(!prev), 1)) {
            return prev ? 0 : endIndex;
          }
        }

        return destination ? dest : loop(dest);
      }

      function computeDestIndex(dest, from, snapPage) {
        if (isEnough() || hasFocus()) {
          var index = computeMovableDestIndex(dest);

          if (index !== dest) {
            from = dest;
            dest = index;
            snapPage = false;
          }

          if (dest < 0 || dest > endIndex) {
            if (!perMove && (between(0, dest, from, true) || between(endIndex, from, dest, true))) {
              dest = toIndex(toPage(dest));
            } else {
              if (isLoop) {
                dest = snapPage ? dest < 0 ? -(slideCount % perPage || perPage) : slideCount : dest;
              } else if (options.rewind) {
                dest = dest < 0 ? endIndex : 0;
              } else {
                dest = -1;
              }
            }
          } else {
            if (snapPage && dest !== from) {
              dest = toIndex(toPage(from) + (dest < from ? -1 : 1));
            }
          }
        } else {
          dest = -1;
        }

        return dest;
      }

      function computeMovableDestIndex(dest) {
        if (isSlide && options.trimSpace === "move" && dest !== currIndex) {
          var position = getPosition();

          while (position === toPosition(dest, true) && between(dest, 0, Splide2.length - 1, !options.rewind)) {
            dest < currIndex ? --dest : ++dest;
          }
        }

        return dest;
      }

      function loop(index) {
        return isLoop ? (index + slideCount) % slideCount || 0 : index;
      }

      function getEnd() {
        var end = slideCount - (hasFocus() || isLoop && perMove ? 1 : perPage);

        while (omitEnd && end-- > 0) {
          if (toPosition(slideCount - 1, true) !== toPosition(end, true)) {
            end++;
            break;
          }
        }

        return clamp(end, 0, slideCount - 1);
      }

      function toIndex(page) {
        return clamp(hasFocus() ? page : perPage * page, 0, endIndex);
      }

      function toPage(index) {
        return hasFocus() ? min(index, endIndex) : floor((index >= endIndex ? slideCount - 1 : index) / perPage);
      }

      function toDest(destination) {
        var closest = Move.toIndex(destination);
        return isSlide ? clamp(closest, 0, endIndex) : closest;
      }

      function setIndex(index) {
        if (index !== currIndex) {
          prevIndex = currIndex;
          currIndex = index;
        }
      }

      function getIndex(prev) {
        return prev ? prevIndex : currIndex;
      }

      function hasFocus() {
        return !isUndefined(options.focus) || options.isNavigation;
      }

      function isBusy() {
        return Splide2.state.is([MOVING, SCROLLING]) && !!options.waitForTransition;
      }

      return {
        mount: mount,
        go: go,
        scroll: scroll,
        getNext: getNext,
        getPrev: getPrev,
        getAdjacent: getAdjacent,
        getEnd: getEnd,
        setIndex: setIndex,
        getIndex: getIndex,
        toIndex: toIndex,
        toPage: toPage,
        toDest: toDest,
        hasFocus: hasFocus,
        isBusy: isBusy
      };
    }

    var XML_NAME_SPACE = "http://www.w3.org/2000/svg";
    var PATH = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z";
    var SIZE = 40;

    function Arrows(Splide2, Components2, options) {
      var event = EventInterface(Splide2);
      var on = event.on,
          bind = event.bind,
          emit = event.emit;
      var classes = options.classes,
          i18n = options.i18n;
      var Elements = Components2.Elements,
          Controller = Components2.Controller;
      var placeholder = Elements.arrows,
          track = Elements.track;
      var wrapper = placeholder;
      var prev = Elements.prev;
      var next = Elements.next;
      var created;
      var wrapperClasses;
      var arrows = {};

      function mount() {
        init();
        on(EVENT_UPDATED, remount);
      }

      function remount() {
        destroy();
        mount();
      }

      function init() {
        var enabled = options.arrows;

        if (enabled && !(prev && next)) {
          createArrows();
        }

        if (prev && next) {
          assign(arrows, {
            prev: prev,
            next: next
          });
          display(wrapper, enabled ? "" : "none");
          addClass(wrapper, wrapperClasses = CLASS_ARROWS + "--" + options.direction);

          if (enabled) {
            listen();
            update();
            setAttribute([prev, next], ARIA_CONTROLS, track.id);
            emit(EVENT_ARROWS_MOUNTED, prev, next);
          }
        }
      }

      function destroy() {
        event.destroy();
        removeClass(wrapper, wrapperClasses);

        if (created) {
          remove(placeholder ? [prev, next] : wrapper);
          prev = next = null;
        } else {
          removeAttribute([prev, next], ALL_ATTRIBUTES);
        }
      }

      function listen() {
        on([EVENT_MOUNTED, EVENT_MOVED, EVENT_REFRESH, EVENT_SCROLLED, EVENT_END_INDEX_CHANGED], update);
        bind(next, "click", apply(go, ">"));
        bind(prev, "click", apply(go, "<"));
      }

      function go(control) {
        Controller.go(control, true);
      }

      function createArrows() {
        wrapper = placeholder || create("div", classes.arrows);
        prev = createArrow(true);
        next = createArrow(false);
        created = true;
        append(wrapper, [prev, next]);
        !placeholder && before(wrapper, track);
      }

      function createArrow(prev2) {
        var arrow = "<button class=\"" + classes.arrow + " " + (prev2 ? classes.prev : classes.next) + "\" type=\"button\"><svg xmlns=\"" + XML_NAME_SPACE + "\" viewBox=\"0 0 " + SIZE + " " + SIZE + "\" width=\"" + SIZE + "\" height=\"" + SIZE + "\" focusable=\"false\"><path d=\"" + (options.arrowPath || PATH) + "\" />";
        return parseHtml(arrow);
      }

      function update() {
        if (prev && next) {
          var index = Splide2.index;
          var prevIndex = Controller.getPrev();
          var nextIndex = Controller.getNext();
          var prevLabel = prevIndex > -1 && index < prevIndex ? i18n.last : i18n.prev;
          var nextLabel = nextIndex > -1 && index > nextIndex ? i18n.first : i18n.next;
          prev.disabled = prevIndex < 0;
          next.disabled = nextIndex < 0;
          setAttribute(prev, ARIA_LABEL, prevLabel);
          setAttribute(next, ARIA_LABEL, nextLabel);
          emit(EVENT_ARROWS_UPDATED, prev, next, prevIndex, nextIndex);
        }
      }

      return {
        arrows: arrows,
        mount: mount,
        destroy: destroy,
        update: update
      };
    }

    var INTERVAL_DATA_ATTRIBUTE = DATA_ATTRIBUTE + "-interval";

    function Autoplay(Splide2, Components2, options) {
      var _EventInterface6 = EventInterface(Splide2),
          on = _EventInterface6.on,
          bind = _EventInterface6.bind,
          emit = _EventInterface6.emit;

      var interval = RequestInterval(options.interval, Splide2.go.bind(Splide2, ">"), onAnimationFrame);
      var isPaused = interval.isPaused;
      var Elements = Components2.Elements,
          _Components2$Elements4 = Components2.Elements,
          root = _Components2$Elements4.root,
          toggle = _Components2$Elements4.toggle;
      var autoplay = options.autoplay;
      var hovered;
      var focused;
      var stopped = autoplay === "pause";

      function mount() {
        if (autoplay) {
          listen();
          toggle && setAttribute(toggle, ARIA_CONTROLS, Elements.track.id);
          stopped || play();
          update();
        }
      }

      function listen() {
        if (options.pauseOnHover) {
          bind(root, "mouseenter mouseleave", function (e) {
            hovered = e.type === "mouseenter";
            autoToggle();
          });
        }

        if (options.pauseOnFocus) {
          bind(root, "focusin focusout", function (e) {
            focused = e.type === "focusin";
            autoToggle();
          });
        }

        if (toggle) {
          bind(toggle, "click", function () {
            stopped ? play() : pause(true);
          });
        }

        on([EVENT_MOVE, EVENT_SCROLL, EVENT_REFRESH], interval.rewind);
        on(EVENT_MOVE, onMove);
      }

      function play() {
        if (isPaused() && Components2.Slides.isEnough()) {
          interval.start(!options.resetProgress);
          focused = hovered = stopped = false;
          update();
          emit(EVENT_AUTOPLAY_PLAY);
        }
      }

      function pause(stop) {
        if (stop === void 0) {
          stop = true;
        }

        stopped = !!stop;
        update();

        if (!isPaused()) {
          interval.pause();
          emit(EVENT_AUTOPLAY_PAUSE);
        }
      }

      function autoToggle() {
        if (!stopped) {
          hovered || focused ? pause(false) : play();
        }
      }

      function update() {
        if (toggle) {
          toggleClass(toggle, CLASS_ACTIVE, !stopped);
          setAttribute(toggle, ARIA_LABEL, options.i18n[stopped ? "play" : "pause"]);
        }
      }

      function onAnimationFrame(rate) {
        var bar = Elements.bar;
        bar && style(bar, "width", rate * 100 + "%");
        emit(EVENT_AUTOPLAY_PLAYING, rate);
      }

      function onMove(index) {
        var Slide = Components2.Slides.getAt(index);
        interval.set(Slide && +getAttribute(Slide.slide, INTERVAL_DATA_ATTRIBUTE) || options.interval);
      }

      return {
        mount: mount,
        destroy: interval.cancel,
        play: play,
        pause: pause,
        isPaused: isPaused
      };
    }

    function Cover(Splide2, Components2, options) {
      var _EventInterface7 = EventInterface(Splide2),
          on = _EventInterface7.on;

      function mount() {
        if (options.cover) {
          on(EVENT_LAZYLOAD_LOADED, apply(toggle, true));
          on([EVENT_MOUNTED, EVENT_UPDATED, EVENT_REFRESH], apply(cover, true));
        }
      }

      function cover(cover2) {
        Components2.Slides.forEach(function (Slide) {
          var img = child(Slide.container || Slide.slide, "img");

          if (img && img.src) {
            toggle(cover2, img, Slide);
          }
        });
      }

      function toggle(cover2, img, Slide) {
        Slide.style("background", cover2 ? "center/cover no-repeat url(\"" + img.src + "\")" : "", true);
        display(img, cover2 ? "none" : "");
      }

      return {
        mount: mount,
        destroy: apply(cover, false)
      };
    }

    var BOUNCE_DIFF_THRESHOLD = 10;
    var BOUNCE_DURATION = 600;
    var FRICTION_FACTOR = 0.6;
    var BASE_VELOCITY = 1.5;
    var MIN_DURATION = 800;

    function Scroll(Splide2, Components2, options) {
      var _EventInterface8 = EventInterface(Splide2),
          on = _EventInterface8.on,
          emit = _EventInterface8.emit;

      var set = Splide2.state.set;
      var Move = Components2.Move;
      var getPosition = Move.getPosition,
          getLimit = Move.getLimit,
          exceededLimit = Move.exceededLimit,
          translate = Move.translate;
      var isSlide = Splide2.is(SLIDE);
      var interval;
      var callback;
      var friction = 1;

      function mount() {
        on(EVENT_MOVE, clear);
        on([EVENT_UPDATED, EVENT_REFRESH], cancel);
      }

      function scroll(destination, duration, snap, onScrolled, noConstrain) {
        var from = getPosition();
        clear();

        if (snap && (!isSlide || !exceededLimit())) {
          var size = Components2.Layout.sliderSize();
          var offset = sign(destination) * size * floor(abs(destination) / size) || 0;
          destination = Move.toPosition(Components2.Controller.toDest(destination % size)) + offset;
        }

        var noDistance = approximatelyEqual(from, destination, 1);
        friction = 1;
        duration = noDistance ? 0 : duration || max(abs(destination - from) / BASE_VELOCITY, MIN_DURATION);
        callback = onScrolled;
        interval = RequestInterval(duration, onEnd, apply(update, from, destination, noConstrain), 1);
        set(SCROLLING);
        emit(EVENT_SCROLL);
        interval.start();
      }

      function onEnd() {
        set(IDLE);
        callback && callback();
        emit(EVENT_SCROLLED);
      }

      function update(from, to, noConstrain, rate) {
        var position = getPosition();
        var target = from + (to - from) * easing(rate);
        var diff = (target - position) * friction;
        translate(position + diff);

        if (isSlide && !noConstrain && exceededLimit()) {
          friction *= FRICTION_FACTOR;

          if (abs(diff) < BOUNCE_DIFF_THRESHOLD) {
            scroll(getLimit(exceededLimit(true)), BOUNCE_DURATION, false, callback, true);
          }
        }
      }

      function clear() {
        if (interval) {
          interval.cancel();
        }
      }

      function cancel() {
        if (interval && !interval.isPaused()) {
          clear();
          onEnd();
        }
      }

      function easing(t) {
        var easingFunc = options.easingFunc;
        return easingFunc ? easingFunc(t) : 1 - Math.pow(1 - t, 4);
      }

      return {
        mount: mount,
        destroy: clear,
        scroll: scroll,
        cancel: cancel
      };
    }

    var SCROLL_LISTENER_OPTIONS = {
      passive: false,
      capture: true
    };

    function Drag(Splide2, Components2, options) {
      var _EventInterface9 = EventInterface(Splide2),
          on = _EventInterface9.on,
          emit = _EventInterface9.emit,
          bind = _EventInterface9.bind,
          unbind = _EventInterface9.unbind;

      var state = Splide2.state;
      var Move = Components2.Move,
          Scroll = Components2.Scroll,
          Controller = Components2.Controller,
          track = Components2.Elements.track,
          reduce = Components2.Media.reduce;
      var _Components2$Directio2 = Components2.Direction,
          resolve = _Components2$Directio2.resolve,
          orient = _Components2$Directio2.orient;
      var getPosition = Move.getPosition,
          exceededLimit = Move.exceededLimit;
      var basePosition;
      var baseEvent;
      var prevBaseEvent;
      var isFree;
      var dragging;
      var exceeded = false;
      var clickPrevented;
      var disabled;
      var target;

      function mount() {
        bind(track, POINTER_MOVE_EVENTS, noop, SCROLL_LISTENER_OPTIONS);
        bind(track, POINTER_UP_EVENTS, noop, SCROLL_LISTENER_OPTIONS);
        bind(track, POINTER_DOWN_EVENTS, onPointerDown, SCROLL_LISTENER_OPTIONS);
        bind(track, "click", onClick, {
          capture: true
        });
        bind(track, "dragstart", prevent);
        on([EVENT_MOUNTED, EVENT_UPDATED], init);
      }

      function init() {
        var drag = options.drag;
        disable(!drag);
        isFree = drag === "free";
      }

      function onPointerDown(e) {
        clickPrevented = false;

        if (!disabled) {
          var isTouch = isTouchEvent(e);

          if (isDraggable(e.target) && (isTouch || !e.button)) {
            if (!Controller.isBusy()) {
              target = isTouch ? track : window;
              dragging = state.is([MOVING, SCROLLING]);
              prevBaseEvent = null;
              bind(target, POINTER_MOVE_EVENTS, onPointerMove, SCROLL_LISTENER_OPTIONS);
              bind(target, POINTER_UP_EVENTS, onPointerUp, SCROLL_LISTENER_OPTIONS);
              Move.cancel();
              Scroll.cancel();
              save(e);
            } else {
              prevent(e, true);
            }
          }
        }
      }

      function onPointerMove(e) {
        if (!state.is(DRAGGING)) {
          state.set(DRAGGING);
          emit(EVENT_DRAG);
        }

        if (e.cancelable) {
          if (dragging) {
            Move.translate(basePosition + constrain(diffCoord(e)));
            var expired = diffTime(e) > LOG_INTERVAL;
            var hasExceeded = exceeded !== (exceeded = exceededLimit());

            if (expired || hasExceeded) {
              save(e);
            }

            clickPrevented = true;
            emit(EVENT_DRAGGING);
            prevent(e);
          } else if (isSliderDirection(e)) {
            dragging = shouldStart(e);
            prevent(e);
          }
        }
      }

      function onPointerUp(e) {
        if (state.is(DRAGGING)) {
          state.set(IDLE);
          emit(EVENT_DRAGGED);
        }

        if (dragging) {
          move(e);
          prevent(e);
        }

        unbind(target, POINTER_MOVE_EVENTS, onPointerMove);
        unbind(target, POINTER_UP_EVENTS, onPointerUp);
        dragging = false;
      }

      function onClick(e) {
        if (!disabled && clickPrevented) {
          prevent(e, true);
        }
      }

      function save(e) {
        prevBaseEvent = baseEvent;
        baseEvent = e;
        basePosition = getPosition();
      }

      function move(e) {
        var velocity = computeVelocity(e);
        var destination = computeDestination(velocity);
        var rewind = options.rewind && options.rewindByDrag;
        reduce(false);

        if (isFree) {
          Controller.scroll(destination, 0, options.snap);
        } else if (Splide2.is(FADE)) {
          Controller.go(orient(sign(velocity)) < 0 ? rewind ? "<" : "-" : rewind ? ">" : "+");
        } else if (Splide2.is(SLIDE) && exceeded && rewind) {
          Controller.go(exceededLimit(true) ? ">" : "<");
        } else {
          Controller.go(Controller.toDest(destination), true);
        }

        reduce(true);
      }

      function shouldStart(e) {
        var thresholds = options.dragMinThreshold;
        var isObj = isObject(thresholds);
        var mouse = isObj && thresholds.mouse || 0;
        var touch = (isObj ? thresholds.touch : +thresholds) || 10;
        return abs(diffCoord(e)) > (isTouchEvent(e) ? touch : mouse);
      }

      function isSliderDirection(e) {
        return abs(diffCoord(e)) > abs(diffCoord(e, true));
      }

      function computeVelocity(e) {
        if (Splide2.is(LOOP) || !exceeded) {
          var time = diffTime(e);

          if (time && time < LOG_INTERVAL) {
            return diffCoord(e) / time;
          }
        }

        return 0;
      }

      function computeDestination(velocity) {
        return getPosition() + sign(velocity) * min(abs(velocity) * (options.flickPower || 600), isFree ? Infinity : Components2.Layout.listSize() * (options.flickMaxPages || 1));
      }

      function diffCoord(e, orthogonal) {
        return coordOf(e, orthogonal) - coordOf(getBaseEvent(e), orthogonal);
      }

      function diffTime(e) {
        return timeOf(e) - timeOf(getBaseEvent(e));
      }

      function getBaseEvent(e) {
        return baseEvent === e && prevBaseEvent || baseEvent;
      }

      function coordOf(e, orthogonal) {
        return (isTouchEvent(e) ? e.changedTouches[0] : e)["page" + resolve(orthogonal ? "Y" : "X")];
      }

      function constrain(diff) {
        return diff / (exceeded && Splide2.is(SLIDE) ? FRICTION : 1);
      }

      function isDraggable(target2) {
        var noDrag = options.noDrag;
        return !matches(target2, "." + CLASS_PAGINATION_PAGE + ", ." + CLASS_ARROW) && (!noDrag || !matches(target2, noDrag));
      }

      function isTouchEvent(e) {
        return typeof TouchEvent !== "undefined" && e instanceof TouchEvent;
      }

      function isDragging() {
        return dragging;
      }

      function disable(value) {
        disabled = value;
      }

      return {
        mount: mount,
        disable: disable,
        isDragging: isDragging
      };
    }

    var NORMALIZATION_MAP = {
      Spacebar: " ",
      Right: ARROW_RIGHT,
      Left: ARROW_LEFT,
      Up: ARROW_UP,
      Down: ARROW_DOWN
    };

    function normalizeKey(key) {
      key = isString(key) ? key : key.key;
      return NORMALIZATION_MAP[key] || key;
    }

    var KEYBOARD_EVENT = "keydown";

    function Keyboard(Splide2, Components2, options) {
      var _EventInterface10 = EventInterface(Splide2),
          on = _EventInterface10.on,
          bind = _EventInterface10.bind,
          unbind = _EventInterface10.unbind;

      var root = Splide2.root;
      var resolve = Components2.Direction.resolve;
      var target;
      var disabled;

      function mount() {
        init();
        on(EVENT_UPDATED, destroy);
        on(EVENT_UPDATED, init);
        on(EVENT_MOVE, onMove);
      }

      function init() {
        var keyboard = options.keyboard;

        if (keyboard) {
          target = keyboard === "global" ? window : root;
          bind(target, KEYBOARD_EVENT, onKeydown);
        }
      }

      function destroy() {
        unbind(target, KEYBOARD_EVENT);
      }

      function disable(value) {
        disabled = value;
      }

      function onMove() {
        var _disabled = disabled;
        disabled = true;
        nextTick(function () {
          disabled = _disabled;
        });
      }

      function onKeydown(e) {
        if (!disabled) {
          var key = normalizeKey(e);

          if (key === resolve(ARROW_LEFT)) {
            Splide2.go("<");
          } else if (key === resolve(ARROW_RIGHT)) {
            Splide2.go(">");
          }
        }
      }

      return {
        mount: mount,
        destroy: destroy,
        disable: disable
      };
    }

    var SRC_DATA_ATTRIBUTE = DATA_ATTRIBUTE + "-lazy";
    var SRCSET_DATA_ATTRIBUTE = SRC_DATA_ATTRIBUTE + "-srcset";
    var IMAGE_SELECTOR = "[" + SRC_DATA_ATTRIBUTE + "], [" + SRCSET_DATA_ATTRIBUTE + "]";

    function LazyLoad(Splide2, Components2, options) {
      var _EventInterface11 = EventInterface(Splide2),
          on = _EventInterface11.on,
          off = _EventInterface11.off,
          bind = _EventInterface11.bind,
          emit = _EventInterface11.emit;

      var isSequential = options.lazyLoad === "sequential";
      var events = [EVENT_MOVED, EVENT_SCROLLED];
      var entries = [];

      function mount() {
        if (options.lazyLoad) {
          init();
          on(EVENT_REFRESH, init);
        }
      }

      function init() {
        empty(entries);
        register();

        if (isSequential) {
          loadNext();
        } else {
          off(events);
          on(events, check);
          check();
        }
      }

      function register() {
        Components2.Slides.forEach(function (Slide) {
          queryAll(Slide.slide, IMAGE_SELECTOR).forEach(function (img) {
            var src = getAttribute(img, SRC_DATA_ATTRIBUTE);
            var srcset = getAttribute(img, SRCSET_DATA_ATTRIBUTE);

            if (src !== img.src || srcset !== img.srcset) {
              var className = options.classes.spinner;
              var parent = img.parentElement;
              var spinner = child(parent, "." + className) || create("span", className, parent);
              entries.push([img, Slide, spinner]);
              img.src || display(img, "none");
            }
          });
        });
      }

      function check() {
        entries = entries.filter(function (data) {
          var distance = options.perPage * ((options.preloadPages || 1) + 1) - 1;
          return data[1].isWithin(Splide2.index, distance) ? load(data) : true;
        });
        entries.length || off(events);
      }

      function load(data) {
        var img = data[0];
        addClass(data[1].slide, CLASS_LOADING);
        bind(img, "load error", apply(onLoad, data));
        setAttribute(img, "src", getAttribute(img, SRC_DATA_ATTRIBUTE));
        setAttribute(img, "srcset", getAttribute(img, SRCSET_DATA_ATTRIBUTE));
        removeAttribute(img, SRC_DATA_ATTRIBUTE);
        removeAttribute(img, SRCSET_DATA_ATTRIBUTE);
      }

      function onLoad(data, e) {
        var img = data[0],
            Slide = data[1];
        removeClass(Slide.slide, CLASS_LOADING);

        if (e.type !== "error") {
          remove(data[2]);
          display(img, "");
          emit(EVENT_LAZYLOAD_LOADED, img, Slide);
          emit(EVENT_RESIZE);
        }

        isSequential && loadNext();
      }

      function loadNext() {
        entries.length && load(entries.shift());
      }

      return {
        mount: mount,
        destroy: apply(empty, entries),
        check: check
      };
    }

    function Pagination(Splide2, Components2, options) {
      var event = EventInterface(Splide2);
      var on = event.on,
          emit = event.emit,
          bind = event.bind;
      var Slides = Components2.Slides,
          Elements = Components2.Elements,
          Controller = Components2.Controller;
      var hasFocus = Controller.hasFocus,
          getIndex = Controller.getIndex,
          go = Controller.go;
      var resolve = Components2.Direction.resolve;
      var placeholder = Elements.pagination;
      var items = [];
      var list;
      var paginationClasses;

      function mount() {
        destroy();
        on([EVENT_UPDATED, EVENT_REFRESH, EVENT_END_INDEX_CHANGED], mount);
        var enabled = options.pagination;
        placeholder && display(placeholder, enabled ? "" : "none");

        if (enabled) {
          on([EVENT_MOVE, EVENT_SCROLL, EVENT_SCROLLED], update);
          createPagination();
          update();
          emit(EVENT_PAGINATION_MOUNTED, {
            list: list,
            items: items
          }, getAt(Splide2.index));
        }
      }

      function destroy() {
        if (list) {
          remove(placeholder ? slice(list.children) : list);
          removeClass(list, paginationClasses);
          empty(items);
          list = null;
        }

        event.destroy();
      }

      function createPagination() {
        var length = Splide2.length;
        var classes = options.classes,
            i18n = options.i18n,
            perPage = options.perPage;
        var max = hasFocus() ? Controller.getEnd() + 1 : ceil(length / perPage);
        list = placeholder || create("ul", classes.pagination, Elements.track.parentElement);
        addClass(list, paginationClasses = CLASS_PAGINATION + "--" + getDirection());
        setAttribute(list, ROLE, "tablist");
        setAttribute(list, ARIA_LABEL, i18n.select);
        setAttribute(list, ARIA_ORIENTATION, getDirection() === TTB ? "vertical" : "");

        for (var i = 0; i < max; i++) {
          var li = create("li", null, list);
          var button = create("button", {
            class: classes.page,
            type: "button"
          }, li);
          var controls = Slides.getIn(i).map(function (Slide) {
            return Slide.slide.id;
          });
          var text = !hasFocus() && perPage > 1 ? i18n.pageX : i18n.slideX;
          bind(button, "click", apply(onClick, i));

          if (options.paginationKeyboard) {
            bind(button, "keydown", apply(onKeydown, i));
          }

          setAttribute(li, ROLE, "presentation");
          setAttribute(button, ROLE, "tab");
          setAttribute(button, ARIA_CONTROLS, controls.join(" "));
          setAttribute(button, ARIA_LABEL, format(text, i + 1));
          setAttribute(button, TAB_INDEX, -1);
          items.push({
            li: li,
            button: button,
            page: i
          });
        }
      }

      function onClick(page) {
        go(">" + page, true);
      }

      function onKeydown(page, e) {
        var length = items.length;
        var key = normalizeKey(e);
        var dir = getDirection();
        var nextPage = -1;

        if (key === resolve(ARROW_RIGHT, false, dir)) {
          nextPage = ++page % length;
        } else if (key === resolve(ARROW_LEFT, false, dir)) {
          nextPage = (--page + length) % length;
        } else if (key === "Home") {
          nextPage = 0;
        } else if (key === "End") {
          nextPage = length - 1;
        }

        var item = items[nextPage];

        if (item) {
          focus(item.button);
          go(">" + nextPage);
          prevent(e, true);
        }
      }

      function getDirection() {
        return options.paginationDirection || options.direction;
      }

      function getAt(index) {
        return items[Controller.toPage(index)];
      }

      function update() {
        var prev = getAt(getIndex(true));
        var curr = getAt(getIndex());

        if (prev) {
          var button = prev.button;
          removeClass(button, CLASS_ACTIVE);
          removeAttribute(button, ARIA_SELECTED);
          setAttribute(button, TAB_INDEX, -1);
        }

        if (curr) {
          var _button = curr.button;
          addClass(_button, CLASS_ACTIVE);
          setAttribute(_button, ARIA_SELECTED, true);
          setAttribute(_button, TAB_INDEX, "");
        }

        emit(EVENT_PAGINATION_UPDATED, {
          list: list,
          items: items
        }, prev, curr);
      }

      return {
        items: items,
        mount: mount,
        destroy: destroy,
        getAt: getAt,
        update: update
      };
    }

    var TRIGGER_KEYS = [" ", "Enter"];

    function Sync(Splide2, Components2, options) {
      var isNavigation = options.isNavigation,
          slideFocus = options.slideFocus;
      var events = [];

      function mount() {
        Splide2.splides.forEach(function (target) {
          if (!target.isParent) {
            sync(Splide2, target.splide);
            sync(target.splide, Splide2);
          }
        });

        if (isNavigation) {
          navigate();
        }
      }

      function destroy() {
        events.forEach(function (event) {
          event.destroy();
        });
        empty(events);
      }

      function remount() {
        destroy();
        mount();
      }

      function sync(splide, target) {
        var event = EventInterface(splide);
        event.on(EVENT_MOVE, function (index, prev, dest) {
          target.go(target.is(LOOP) ? dest : index);
        });
        events.push(event);
      }

      function navigate() {
        var event = EventInterface(Splide2);
        var on = event.on;
        on(EVENT_CLICK, onClick);
        on(EVENT_SLIDE_KEYDOWN, onKeydown);
        on([EVENT_MOUNTED, EVENT_UPDATED], update);
        events.push(event);
        event.emit(EVENT_NAVIGATION_MOUNTED, Splide2.splides);
      }

      function update() {
        setAttribute(Components2.Elements.list, ARIA_ORIENTATION, options.direction === TTB ? "vertical" : "");
      }

      function onClick(Slide) {
        Splide2.go(Slide.index);
      }

      function onKeydown(Slide, e) {
        if (includes(TRIGGER_KEYS, normalizeKey(e))) {
          onClick(Slide);
          prevent(e);
        }
      }

      return {
        setup: apply(Components2.Media.set, {
          slideFocus: isUndefined(slideFocus) ? isNavigation : slideFocus
        }, true),
        mount: mount,
        destroy: destroy,
        remount: remount
      };
    }

    function Wheel(Splide2, Components2, options) {
      var _EventInterface12 = EventInterface(Splide2),
          bind = _EventInterface12.bind;

      var lastTime = 0;

      function mount() {
        if (options.wheel) {
          bind(Components2.Elements.track, "wheel", onWheel, SCROLL_LISTENER_OPTIONS);
        }
      }

      function onWheel(e) {
        if (e.cancelable) {
          var deltaY = e.deltaY;
          var backwards = deltaY < 0;
          var timeStamp = timeOf(e);

          var _min = options.wheelMinThreshold || 0;

          var sleep = options.wheelSleep || 0;

          if (abs(deltaY) > _min && timeStamp - lastTime > sleep) {
            Splide2.go(backwards ? "<" : ">");
            lastTime = timeStamp;
          }

          shouldPrevent(backwards) && prevent(e);
        }
      }

      function shouldPrevent(backwards) {
        return !options.releaseWheel || Splide2.state.is(MOVING) || Components2.Controller.getAdjacent(backwards) !== -1;
      }

      return {
        mount: mount
      };
    }

    var SR_REMOVAL_DELAY = 90;

    function Live(Splide2, Components2, options) {
      var _EventInterface13 = EventInterface(Splide2),
          on = _EventInterface13.on;

      var track = Components2.Elements.track;
      var enabled = options.live && !options.isNavigation;
      var sr = create("span", CLASS_SR);
      var interval = RequestInterval(SR_REMOVAL_DELAY, apply(toggle, false));

      function mount() {
        if (enabled) {
          disable(!Components2.Autoplay.isPaused());
          setAttribute(track, ARIA_ATOMIC, true);
          sr.textContent = "\u2026";
          on(EVENT_AUTOPLAY_PLAY, apply(disable, true));
          on(EVENT_AUTOPLAY_PAUSE, apply(disable, false));
          on([EVENT_MOVED, EVENT_SCROLLED], apply(toggle, true));
        }
      }

      function toggle(active) {
        setAttribute(track, ARIA_BUSY, active);

        if (active) {
          append(track, sr);
          interval.start();
        } else {
          remove(sr);
          interval.cancel();
        }
      }

      function destroy() {
        removeAttribute(track, [ARIA_LIVE, ARIA_ATOMIC, ARIA_BUSY]);
        remove(sr);
      }

      function disable(disabled) {
        if (enabled) {
          setAttribute(track, ARIA_LIVE, disabled ? "off" : "polite");
        }
      }

      return {
        mount: mount,
        disable: disable,
        destroy: destroy
      };
    }

    var ComponentConstructors = /*#__PURE__*/Object.freeze({
      __proto__: null,
      Media: Media,
      Direction: Direction,
      Elements: Elements,
      Slides: Slides,
      Layout: Layout,
      Clones: Clones,
      Move: Move,
      Controller: Controller,
      Arrows: Arrows,
      Autoplay: Autoplay,
      Cover: Cover,
      Scroll: Scroll,
      Drag: Drag,
      Keyboard: Keyboard,
      LazyLoad: LazyLoad,
      Pagination: Pagination,
      Sync: Sync,
      Wheel: Wheel,
      Live: Live
    });
    var I18N = {
      prev: "Previous slide",
      next: "Next slide",
      first: "Go to first slide",
      last: "Go to last slide",
      slideX: "Go to slide %s",
      pageX: "Go to page %s",
      play: "Start autoplay",
      pause: "Pause autoplay",
      carousel: "carousel",
      slide: "slide",
      select: "Select a slide to show",
      slideLabel: "%s of %s"
    };
    var DEFAULTS = {
      type: "slide",
      role: "region",
      speed: 400,
      perPage: 1,
      cloneStatus: true,
      arrows: true,
      pagination: true,
      paginationKeyboard: true,
      interval: 5e3,
      pauseOnHover: true,
      pauseOnFocus: true,
      resetProgress: true,
      easing: "cubic-bezier(0.25, 1, 0.5, 1)",
      drag: true,
      direction: "ltr",
      trimSpace: true,
      focusableNodes: "a, button, textarea, input, select, iframe",
      live: true,
      classes: CLASSES,
      i18n: I18N,
      reducedMotion: {
        speed: 0,
        rewindSpeed: 0,
        autoplay: "pause"
      }
    };

    function Fade(Splide2, Components2, options) {
      var Slides = Components2.Slides;

      function mount() {
        EventInterface(Splide2).on([EVENT_MOUNTED, EVENT_REFRESH], init);
      }

      function init() {
        Slides.forEach(function (Slide) {
          Slide.style("transform", "translateX(-" + 100 * Slide.index + "%)");
        });
      }

      function start(index, done) {
        Slides.style("transition", "opacity " + options.speed + "ms " + options.easing);
        nextTick(done);
      }

      return {
        mount: mount,
        start: start,
        cancel: noop
      };
    }

    function Slide(Splide2, Components2, options) {
      var Move = Components2.Move,
          Controller = Components2.Controller,
          Scroll = Components2.Scroll;
      var list = Components2.Elements.list;
      var transition = apply(style, list, "transition");
      var endCallback;

      function mount() {
        EventInterface(Splide2).bind(list, "transitionend", function (e) {
          if (e.target === list && endCallback) {
            cancel();
            endCallback();
          }
        });
      }

      function start(index, done) {
        var destination = Move.toPosition(index, true);
        var position = Move.getPosition();
        var speed = getSpeed(index);

        if (abs(destination - position) >= 1 && speed >= 1) {
          if (options.useScroll) {
            Scroll.scroll(destination, speed, false, done);
          } else {
            transition("transform " + speed + "ms " + options.easing);
            Move.translate(destination, true);
            endCallback = done;
          }
        } else {
          Move.jump(index);
          done();
        }
      }

      function cancel() {
        transition("");
        Scroll.cancel();
      }

      function getSpeed(index) {
        var rewindSpeed = options.rewindSpeed;

        if (Splide2.is(SLIDE) && rewindSpeed) {
          var prev = Controller.getIndex(true);
          var end = Controller.getEnd();

          if (prev === 0 && index >= end || prev >= end && index === 0) {
            return rewindSpeed;
          }
        }

        return options.speed;
      }

      return {
        mount: mount,
        start: start,
        cancel: cancel
      };
    }

    var _Splide = /*#__PURE__*/function () {
      function _Splide(target, options) {
        this.event = EventInterface();
        this.Components = {};
        this.state = State(CREATED);
        this.splides = [];
        this._o = {};
        this._E = {};
        var root = isString(target) ? query(document, target) : target;
        assert(root, root + " is invalid.");
        this.root = root;
        options = merge({
          label: getAttribute(root, ARIA_LABEL) || "",
          labelledby: getAttribute(root, ARIA_LABELLEDBY) || ""
        }, DEFAULTS, _Splide.defaults, options || {});

        try {
          merge(options, JSON.parse(getAttribute(root, DATA_ATTRIBUTE)));
        } catch (e) {
          assert(false, "Invalid JSON");
        }

        this._o = Object.create(merge({}, options));
      }

      var _proto = _Splide.prototype;

      _proto.mount = function mount(Extensions, Transition) {
        var _this = this;

        var state = this.state,
            Components2 = this.Components;
        assert(state.is([CREATED, DESTROYED]), "Already mounted!");
        state.set(CREATED);
        this._C = Components2;
        this._T = Transition || this._T || (this.is(FADE) ? Fade : Slide);
        this._E = Extensions || this._E;
        var Constructors = assign({}, ComponentConstructors, this._E, {
          Transition: this._T
        });
        forOwn(Constructors, function (Component, key) {
          var component = Component(_this, Components2, _this._o);
          Components2[key] = component;
          component.setup && component.setup();
        });
        forOwn(Components2, function (component) {
          component.mount && component.mount();
        });
        this.emit(EVENT_MOUNTED);
        addClass(this.root, CLASS_INITIALIZED);
        state.set(IDLE);
        this.emit(EVENT_READY);
        return this;
      };

      _proto.sync = function sync(splide) {
        this.splides.push({
          splide: splide
        });
        splide.splides.push({
          splide: this,
          isParent: true
        });

        if (this.state.is(IDLE)) {
          this._C.Sync.remount();

          splide.Components.Sync.remount();
        }

        return this;
      };

      _proto.go = function go(control) {
        this._C.Controller.go(control);

        return this;
      };

      _proto.on = function on(events, callback) {
        this.event.on(events, callback);
        return this;
      };

      _proto.off = function off(events) {
        this.event.off(events);
        return this;
      };

      _proto.emit = function emit(event) {
        var _this$event;

        (_this$event = this.event).emit.apply(_this$event, [event].concat(slice(arguments, 1)));

        return this;
      };

      _proto.add = function add(slides, index) {
        this._C.Slides.add(slides, index);

        return this;
      };

      _proto.remove = function remove(matcher) {
        this._C.Slides.remove(matcher);

        return this;
      };

      _proto.is = function is(type) {
        return this._o.type === type;
      };

      _proto.refresh = function refresh() {
        this.emit(EVENT_REFRESH);
        return this;
      };

      _proto.destroy = function destroy(completely) {
        if (completely === void 0) {
          completely = true;
        }

        var event = this.event,
            state = this.state;

        if (state.is(CREATED)) {
          EventInterface(this).on(EVENT_READY, this.destroy.bind(this, completely));
        } else {
          forOwn(this._C, function (component) {
            component.destroy && component.destroy(completely);
          }, true);
          event.emit(EVENT_DESTROY);
          event.destroy();
          completely && empty(this.splides);
          state.set(DESTROYED);
        }

        return this;
      };

      _createClass(_Splide, [{
        key: "options",
        get: function get() {
          return this._o;
        },
        set: function set(options) {
          this._C.Media.set(options, true, true);
        }
      }, {
        key: "length",
        get: function get() {
          return this._C.Slides.getLength(true);
        }
      }, {
        key: "index",
        get: function get() {
          return this._C.Controller.getIndex();
        }
      }]);

      return _Splide;
    }();

    var Splide = _Splide;
    Splide.defaults = {};
    Splide.STATES = STATES;

    const getTopArrowButtons = (slider) => {

        if (slider) {
            let heigthEl = slider.querySelector('picture').clientHeight;
            slider.querySelectorAll('.splide__arrow').forEach(btn => {
                btn.style.top = (heigthEl / 2) + 1 + 'px';
            });
        }
    };

    function storiesSlider() {
        // Инициализация основного слайдера
        const mainSliders = document.querySelectorAll('[data-slider="stories"]');

        mainSliders.forEach(slider => {
            slider['splide'] = new Splide(slider, {
                fixedWidth: 112,
                perMove: 1,
                omitEnd: true,
                gap: 16,
                pagination: false,
                breakpoints: {
                    1440: { gap: 24 },
                    1024: { gap: 16 },
                    768: { arrows: false }
                },
                arrowPath: 'M16.204 12.396a1 1 0 011.4-.192l5.618 4.267a4.391 4.391 0 010 7.058l-5.617 4.267a1 1 0 11-1.21-1.592l5.617-4.268c1.317-1 1.317-2.872 0-3.872l-5.616-4.268a1 1 0 01-.192-1.4z'
            });

            slider['splide'].on('mounted', (e) => {
                getTopArrowButtons(slider['splide'].root);
            });

            slider['splide'].on('resize', (e) => {
                getTopArrowButtons(slider['splide'].root);
            });

            slider['splide'].mount();
        });

        // Инициализация модального окна
        initGalleryModal$1();
    }

    function initGalleryModal$1() {
        const modal = document.querySelector('.gallery-modal');
        const modalOverlay = document.querySelector('.modal__overlay');
        const modalClose = document.querySelector('.modal__close');
        const modalBody = document.querySelector('.modal__body');
        const galleryContainer = document.querySelector('.gallery-main-container');
        const mainSlider = document.querySelector('[data-slider="stories"]');

        if (!modal || !galleryContainer || !mainSlider) return;

        let modalSplide = null;

        // Функция открытия модального окна
        function openModal(event) {
            const slide = event.target.closest('.splide__slide');
            if (!slide) return;

            // Получаем индекс кликнутого слайда
            const slides = Array.from(mainSlider.querySelectorAll('.splide__slide'));
            const index = slides.indexOf(slide);

            if (index === -1) return;

            // Клонируем и показываем модальный слайдер
            const galleryContent = galleryContainer.innerHTML;
            modalBody.innerHTML = galleryContent;

            modal.style.display = 'flex';
            document.body.style.overflow = 'hidden';

            // Инициализируем модальный слайдер
            const modalSlider = modalBody.querySelector('[data-slider="gallery-modal-video"]');

            if (modalSlider) {
                modalSplide = new Splide(modalSlider, {
                    type: 'slide',
                    perPage: 1,
                    perMove: 1,
                    gap: 0,
                    pagination: false,
                    arrows: true,
                    start: index,
                    speed: 400,
                    arrowPath: 'M16.204 12.396a1 1 0 011.4-.192l5.618 4.267a4.391 4.391 0 010 7.058l-5.617 4.267a1 1 0 11-1.21-1.592l5.617-4.268c1.317-1 1.317-2.872 0-3.872l-5.616-4.268a1 1 0 01-.192-1.4z'
                });

                modalSplide.on('move', (newIndex) => {
                    // Синхронизируем основной слайдер
                    if (mainSlider.splide) {
                        mainSlider.splide.go(newIndex);
                    }
                });

                modalSplide.mount();
            }
        }

        // Функция закрытия
        function closeModal() {
            modal.style.display = 'none';
            document.body.style.overflow = '';

            if (modalSplide) {
                modalSplide.destroy();
                modalSplide = null;
            }

            modalBody.innerHTML = '';
        }

        // Добавляем обработчики на основной слайдер
        if (mainSlider) {
            mainSlider.addEventListener('click', openModal);

            // Добавляем обработчики на все слайды для доступности
            mainSlider.querySelectorAll('.splide__slide').forEach(slide => {
                slide.setAttribute('tabindex', '0');
                slide.setAttribute('role', 'button');
                slide.setAttribute('aria-label', 'Открыть в галерее');

                slide.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        openModal(e);
                    }
                });
            });
        }

        // Закрытие модального окна
        modalOverlay?.addEventListener('click', closeModal);
        modalClose?.addEventListener('click', closeModal);

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && modal.style.display === 'flex') {
                closeModal();
            }
        });
    }

    function aboutCompany() {
        if (document.querySelector('[data-slider="aboutCompany"]')) {
            document.querySelectorAll('[data-slider="aboutCompany"]').forEach(slider => {
                slider['splide'] = new Splide(slider, {
                    type   : 'loop',
                    perPage: 1,
                    perMove: 1,
                    gap: 0,
                    pagination: false,
                    arrows: false,
                    omitEnd: true,
                    autoplay: true,
                });

                slider['splide'].mount();
            });
        }
    }

    function faq() {
        if (document.querySelectorAll('.faq-item__question')) {

            const faqItems = document.querySelectorAll('.faq-item__question');


            faqItems.forEach(function (item, index) {
                item.addEventListener('click', function () {
                    this.parentNode.classList.toggle('open');
                });
            });

        }
    }

    class SplideNavHelper {
        constructor(params) {
            this.params = params;
            this.slider = params.slider;
            this.btn = params.btn;
            this.container = params.container;
            this.dynamicMode = false;
            this.prevButton = null;
            this.nextButton = null;

            this.init();
        }

        init() {
            this.prevButton = this.container.querySelector('[data-slider-prev="' + this.btn + '"]');
            this.nextButton = this.container.querySelector('[data-slider-next="' + this.btn + '"]');

            if (this.prevButton) {
                this.prevButton.setAttribute('disabled', 'disabled');
            }

            this.addEvent();
        }

        scrollToElem(elem, container) {
            var rect = elem.getBoundingClientRect();
            var rectContainer = container.getBoundingClientRect();

            let elemOffset = {
                top: rect.top + document.body.scrollTop,
                left: rect.left + document.body.scrollLeft
            };

            let containerOffset = {
                top: rectContainer.top + document.body.scrollTop,
                left: rectContainer.left + document.body.scrollLeft
            };

            let leftPX = elemOffset.left - containerOffset.left + container.scrollLeft - (container.offsetWidth / 2) + ((elem.offsetWidth + 0) / 2);

            container.scrollTo({
                left: leftPX,
                behavior: 'smooth'
            });
        }

        addEvent() {
            if (this.prevButton) {
                this.prevButton.addEventListener('click', e => {
                    this.slider.go('<');
                });
            }

            if (this.nextButton) {
                this.nextButton.addEventListener('click', e => {
                    this.slider.go('>');
                });
            }

            this.slider.on('mounted refresh', () => {
                if (this.nextButton) {
                    this.nextButton.removeAttribute('disabled');
                }

                let is_overflow = !this.slider.root.classList.contains('is-overflow');

                if (this.nextButton) {
                    this.nextButton.classList.toggle('is-hide', is_overflow);
                }

                if (this.prevButton) {
                    this.prevButton.classList.toggle('is-hide', is_overflow);
                }

                setTimeout(() => {
                    if (this.container.querySelector('.splide-counter')) {
                        //скрыть счетчик если нету стрелок
                        this.container.querySelector('.splide-counter').classList.toggle('is-hide', is_overflow);
                    }

                    if(this.slider.Components.Pagination.items.length > 10) {
                        this.slider.root.classList.add('is-dynamic-pagination');
                        this.dynamicMode = true;
                    }

                }, 100);
            });

            this.slider.on('move', (newIndex, prevIndex, destIndex) => {
                if (this.nextButton) {
                    this.nextButton.removeAttribute('disabled');
                }

                if (this.prevButton) {
                    this.prevButton.removeAttribute('disabled');
                }

                if (this.slider.options.type == 'loop') {
                    return false
                }

                // Используем правильное свойство для общего количества слайдов
                const totalSlides = this.slider.Components.Elements.slides.length;
                const perPage = this.slider.options.perPage || 1;
                const isEnd = (destIndex + perPage) >= totalSlides;
                const isStart = destIndex === 0;

                if (this.prevButton) {
                    if (isStart) {
                        this.prevButton.setAttribute('disabled', 'disabled');
                    } else {
                        this.prevButton.removeAttribute('disabled');
                    }
                }

                if (this.nextButton) {
                    if (isEnd) {
                        this.nextButton.setAttribute('disabled', 'disabled');
                    } else {
                        this.nextButton.removeAttribute('disabled');
                    }
                }

                if (typeof this.params.onChange != 'undefined') {
                    this.params.onChange(destIndex + 1, totalSlides);
                }

                if(this.dynamicMode) {
                    const elem = this.slider.Components.Pagination.items[newIndex].li;
                    this.scrollToElem(elem, this.slider.root.querySelector('.splide__pagination'));
                }
            });
        }
    }

    const SLIDER_ARROW_PATH = 'M16.204 12.396a1 1 0 011.4-.192l5.618 4.267a4.391 4.391 0 010 7.058l-5.617 4.267a1 1 0 11-1.21-1.592l5.617-4.268c1.317-1 1.317-2.872 0-3.872l-5.616-4.268a1 1 0 01-.192-1.4z';

    function teamslider() {

        if (document.querySelector('[data-slider="team"]')) {


            document.querySelectorAll('[data-slider="team"]').forEach(slider => {
                slider['splide'] = new Splide(slider, {

                    perPage: 4,
                    perMove: 1,
                    gap: 12,
                    pagination: false,
                    arrows: false,
                    omitEnd: true,
                    breakpoints: {
                        1440: {

                        },
                        1024: {
                            perPage: 3,
                            arrows: false,
                        },
                        768: {
                            fixedWidth: 300,
                            perPage: 1,
                        },
                        480: {
                            destroy: true
                        },
                    },

                });

                // init splide nav
                new SplideNavHelper({
                    slider: slider['splide'],
                    btn: 'team',
                    container: slider.closest('section')
                });

                slider['splide'].mount();
            });
        }
    }

    class FilterOffeers {
        constructor(params) {
            this.$el = document.querySelector(params.el) || document;
            this.filterItems = this.$el.querySelectorAll('[data-filter]');
            this.currencyItems = this.$el.querySelectorAll('[data-currency]');
            // Сохраняем оригинальные слайды
            this.originalSlides = this.$el.querySelectorAll('[data-filter-id]');
            this.slider = params.slider;
            this.currentFilter = "0";
            this.currentCurrency = null;
            this.params = params;
            this.isSliderDestroyed = false;
            this.init();
        }

        init() {
            this.addEvent();
            this.updateFilterButtons();

            // Инициализируем отображение только с filterId="0"
            this.renderFilteredSlides();

            if (this.slider && this.slider.on) {
                this.slider.on('destroy', () => {
                    this.isSliderDestroyed = true;
                    console.log('Slider destroyed, filtering will work without slider methods');
                });
            }
        }

        renderFilteredSlides() {
            const splideList = this.$el.querySelector('.splide__list--offers');
            if (!splideList) return;

            // Очищаем список
            splideList.innerHTML = '';

            // Показываем слайды в зависимости от фильтра
            this.originalSlides.forEach(originalSlide => {
                const slideFilterId = originalSlide.getAttribute('data-filter-id');

                // Выводим только товары с filterId равным текущему фильтру
                if (slideFilterId === this.currentFilter) {
                    const clonedSlide = originalSlide.cloneNode(true);
                    splideList.appendChild(clonedSlide);
                }
            });

            // Обновляем валюту если выбрана
            if (this.currentCurrency) {
                this.applyCurrencyToSlides();
            }
        }

        applyCurrencyToSlides() {
            const slides = this.$el.querySelectorAll('.splide__slide');
            slides.forEach(slide => {
                const currencyElements = slide.querySelectorAll('[data-currency-id]');
                currencyElements.forEach(curr => {
                    curr.classList.toggle('is-active', curr.dataset.currencyId === this.currentCurrency);
                });
            });
        }

        changeFilter(el) {
            const filterValue = el.dataset.filter;

            // Если кликнули на уже активный фильтр - ничего не делаем
            if (this.currentFilter === filterValue) return;

            this.currentFilter = filterValue;

            // Рендерим слайды для выбранного фильтра
            this.renderFilteredSlides();

            // Обновляем слайдер
            if (!this.isSliderDestroyed && this.slider) {
                if (this.slider.refresh && typeof this.slider.refresh === 'function') {
                    try {
                        this.slider.refresh();
                        if (this.slider.go && typeof this.slider.go === 'function') {
                            this.slider.go(0);
                        }
                    } catch (error) {
                        console.warn('Slider methods failed, marking as destroyed:', error);
                        this.isSliderDestroyed = true;
                    }
                } else {
                    this.isSliderDestroyed = true;
                }
            }

            // Обновляем активные кнопки фильтров
            this.updateFilterButtons();
        }

        updateFilterButtons() {
            this.filterItems.forEach(el => {
                el.classList.toggle('is-active', el.dataset.filter === this.currentFilter);
            });
        }

        changeCurrency(el) {
            this.currentCurrency = el.dataset.currency;

            this.currencyItems.forEach(el => {
                el.classList.toggle('is-active', el.dataset.currency === this.currentCurrency);
            });

            this.applyCurrencyToSlides();
        }

        addEvent() {
            this.filterItems.forEach(el => {
                el.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.changeFilter(el);
                });
            });

            this.currencyItems.forEach(el => {
                el.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.changeCurrency(el);
                });
            });
        }
    }

    function offersSlider() {
        document
            .querySelectorAll('[data-slider="offers"]')
            .forEach(slider => {
                slider['Splide'] = new Splide(slider, {

                    arrows: true,
                    arrowPath: SLIDER_ARROW_PATH,
                    pagination: false,
                    gap: 12,
                    start: 0,
                    fixedWidth: '343px',
                    perMove: 1,
                    flickMaxPages: 1,
                    flickPower: 100,
                    offsetPagination: 2,
                    omitEnd: true,
                    breakpoints: {
                        480: {
                            arrows: false,
                            fixedWidth: '87.9vw',
                            pagination: false,
                        },

                        992: {
                            arrows: false,
                            fixedWidth: '343px',
                            pagination: false,
                        },
                    }

                });

                // disable drag on hover
                slider.querySelectorAll('.minicard__slider').forEach(gallery => {
                    gallery.addEventListener('mouseenter', () => {
                        slider['Splide'].options = {
                            drag: false,
                        };

                    });
                    gallery.addEventListener('mouseleave', () => {
                        slider['Splide'].options = {
                            drag: true,
                        };
                    });
                });

                // init splide nav
                // new SplideNavHelper({
                //     slider: slider['Splide'],
                //     btn: 'offers',
                //     container: slider.closest('section')
                // })

                //init filter

                new FilterOffeers({
                    el: '.section-best-offers',
                    slider: slider['Splide']
                });

                // slider['splide'].mount();
                if (document.body.clientWidth > 769) {
                    slider['Splide'].mount();
                }
            });

    }

    function aboutUsSlider() {
        document
            .querySelectorAll('[data-slider="aboutUs"]')
            .forEach(slider => {
                if (slider['Splide']) {
                    return;
                }

                slider['Splide'] = new Splide(slider, {
                    // fixedWidth: 412,
                    // perMove: 1,
                    perPage: 2,
                    perMove: 1,
                    omitEnd: true,
                    gap: 16,
                    pagination: false,
                    breakpoints: {
                        1440: { gap: 24 },
                        1024: { gap: 16 },
                        768: {
                            arrows: false,
                            perPage: 1,
                            pagination: true,
                            fixedWidth: 300,
                            focus: 'center',
                        }
                    },
                    arrowPath: 'M16.204 12.396a1 1 0 011.4-.192l5.618 4.267a4.391 4.391 0 010 7.058l-5.617 4.267a1 1 0 11-1.21-1.592l5.617-4.268c1.317-1 1.317-2.872 0-3.872l-5.616-4.268a1 1 0 01-.192-1.4z'
                });

                slider['Splide'].on('mounted', (e) => {
                    getTopArrowButtons(slider['splide'].root);
                });

                slider['Splide'].on('resize', (e) => {
                    getTopArrowButtons(slider['splide'].root);
                });

                slider['Splide'].mount();
            });
    }

    function initProductGallery() {
        let verticalThumbs, mainSlider;
        let isMobile = window.innerWidth <= 767;

        const verticalThumbsEl = document.querySelector('[data-slider="left-vertical-thumbs"]');
        const mainSliderEl = document.querySelector('[data-slider="main-slider"]');

        if (!verticalThumbsEl || !mainSliderEl) {
            return;
        }

        // Функция инициализации в зависимости от разрешения
        function initSliders() {
            isMobile = window.innerWidth <= 767;

            // Уничтожаем предыдущие слайдеры если они есть
            if (verticalThumbs) {
                verticalThumbs.destroy();
                verticalThumbs = null;
            }
            if (mainSlider) {
                mainSlider.destroy();
                mainSlider = null;
            }

            // Показываем/скрываем элементы
            if (isMobile) {
                // На мобилке показываем только вертикальные миниатюры как горизонтальный слайдер
                verticalThumbsEl.style.display = 'block';
                mainSliderEl.style.display = 'none';

                // Инициализируем горизонтальный слайдер на мобилке
                verticalThumbs = new Splide(verticalThumbsEl, {
                    type   : 'loop',
                    arrows: false,
                    pagination: false,
                    gap: 6,
                    start: 0,
                    perMove: 1,
                    flickMaxPages: 1,
                    flickPower: 100,
                    offsetPagination: 2,
                    omitEnd: true,
                    focus: 'center',
                    height: '400px',
                    width: '296px',

                }).mount();
            } else {
                verticalThumbsEl.style.display = 'block';
                mainSliderEl.style.display = 'block';

                // Проверяем количество слайдов
                const verticalThumbsCount = verticalThumbsEl.querySelectorAll('.splide__slide').length;
                const mainSlidesCount = mainSliderEl.querySelectorAll('.splide__slide').length;

                if (verticalThumbsCount !== mainSlidesCount) {
                    console.warn('Количество слайдов не совпадает! Синхронизация невозможна.');
                }

                // Вертикальные миниатюры
                verticalThumbs = new Splide(verticalThumbsEl, {
                    direction: 'ttb',
                    height: 680,
                    gap: 10,
                    pagination: false,
                    arrows: false,
                    isNavigation: true,
                    fixedWidth: 88,
                    fixedHeight: 120,
                    focus: 'top',
                    cover: true,
                    wheel: true,
                    snap: false,
                    wheelSleep: 600,
                    breakpoints: {
                        1199: {
                            height: 520,
                        },
                        767: {
                            destroy: true
                        }
                    }
                }).mount();

                // Основной слайдер
                mainSlider = new Splide(mainSliderEl, {
                    type: 'fade',
                    height: 680,
                    pagination: false,
                    arrows: false,
                    rewind: true,
                    breakpoints: {
                        1199: {
                            height: 520,
                        },
                        767: {
                            destroy: true
                        }
                    }
                }).mount();

                // Ручная синхронизация
                verticalThumbs.on('click', (slide) => {
                    const index = slide.index;
                    mainSlider.go(index);
                });

                verticalThumbs.on('move', (index) => {
                    mainSlider.go(index);
                });

                // Обработка клика по основному слайдеру для открытия модалки (только на десктопе)
                const mainSlides = mainSliderEl.querySelectorAll('.splide__slide');
                mainSlides.forEach((slide, index) => {
                    slide.style.cursor = 'pointer';
                    // Удаляем старые обработчики
                    slide.removeEventListener('click', handleMainSlideClick);
                    // Добавляем новый
                    slide.addEventListener('click', handleMainSlideClick);

                    function handleMainSlideClick() {
                        openGalleryModal(index);
                    }
                });
            }
        }

        // Инициализация при загрузке
        initSliders();

        // Реинициализация при изменении размера окна
        let resizeTimeout;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                const newIsMobile = window.innerWidth <= 767;
                if (isMobile !== newIsMobile) {
                    initSliders();
                }
            }, 250);
        });

        // Инициализация модального окна (только для десктопа)
        if (window.innerWidth > 767) {
            initGalleryModal();
        }
    }

    function initGalleryModal() {
        const modal = document.querySelector('.gallery-modal');
        if (!modal) {
            console.warn('Модальное окно не найдено');
            return;
        }

        const closeBtn = modal.querySelector('.modal__close');
        const overlay = modal.querySelector('.modal__overlay');

        if (closeBtn) {
            closeBtn.addEventListener('click', closeGalleryModal);
        }

        if (overlay) {
            overlay.addEventListener('click', closeGalleryModal);
        }

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && modal.classList.contains('active')) {
                closeGalleryModal();
            }
        });
    }

    function openGalleryModal(slideIndex = 0) {
        // Проверяем, что не на мобилке
        if (window.innerWidth <= 767) {s;
            console.log('Модалка недоступна на мобильных устройствах');
            return;
        }

        const modal = document.querySelector('.gallery-modal');
        const gallerySliderEl = document.querySelector('[data-slider="gallery-modal"]');
        const modalBody = modal?.querySelector('.modal__body');

        if (!modal || !gallerySliderEl || !modalBody) {
            console.error('Элементы галереи не найдены');
            return;
        }

        // Перемещаем слайдер в модалку
        modalBody.appendChild(gallerySliderEl);
        gallerySliderEl.style.display = 'block';

        // Уничтожаем старый слайдер если есть
        if (gallerySliderEl['splide']) {
            gallerySliderEl['splide'].destroy();
        }

        // Инициализация слайдера в модалке
        const gallerySlider = new Splide(gallerySliderEl, {
            start: slideIndex,
            type: 'fade',
            pagination: false,
            arrows: true,
            rewind: true,
            arrowPath: 'M16.204 12.396a1 1 0 011.4-.192l5.618 4.267a4.391 4.391 0 010 7.058l-5.617 4.267a1 1 0 11-1.21-1.592l5.617-4.268c1.317-1 1.317-2.872 0-3.872l-5.616-4.268a1 1 0 01-.192-1.4z'
        }).mount();

        gallerySliderEl['splide'] = gallerySlider;

        // Открываем модалку
        modal.classList.add('active');
        document.body.style.overflow = 'hidden';
    }

    function closeGalleryModal() {
        // Проверяем, что не на мобилке
        if (window.innerWidth <= 767) return;

        const modal = document.querySelector('.gallery-modal');
        const gallerySliderEl = document.querySelector('[data-slider="gallery-modal"]');
        const originalContainer = document.querySelector('.gallery-main-container');

        if (modal) {
            modal.classList.remove('active');
        }

        if (gallerySliderEl) {
            if (gallerySliderEl['splide']) {
                gallerySliderEl['splide'].destroy();
                gallerySliderEl['splide'] = null;
            }

            if (originalContainer) {
                originalContainer.appendChild(gallerySliderEl);
            }

            gallerySliderEl.style.display = 'none';
        }

        document.body.style.overflow = '';
    }

    document.addEventListener('DOMContentLoaded', initProductGallery);

    var S = Object.defineProperty;
    var x = (n, t, e) => t in n ? S(n, t, { enumerable: true, configurable: true, writable: true, value: e }) : n[t] = e;
    var A = (n, t, e) => x(n, typeof t != "symbol" ? t + "" : t, e);
    const R = {
      "#": { pattern: /[0-9]/ },
      "@": { pattern: /[a-zA-Z]/ },
      "*": { pattern: /[a-zA-Z0-9]/ }
    }, N = (n, t, e) => n.replaceAll(t, "").replace(e, ".").replace("..", ".").replace(/[^.\d]/g, ""), w = (n, t, e) => {
      var s;
      return new Intl.NumberFormat(((s = e.number) == null ? void 0 : s.locale) ?? "en", {
        minimumFractionDigits: n,
        maximumFractionDigits: t,
        roundingMode: "trunc"
      });
    }, P = (n, t = true, e) => {
      var k, g, b, d;
      const s = ((k = e.number) == null ? void 0 : k.unsigned) !== true && n.startsWith("-") ? "-" : "", r = ((g = e.number) == null ? void 0 : g.fraction) ?? 0;
      let a = w(0, r, e);
      const u = a.formatToParts(1000.12), p = ((b = u.find((o) => o.type === "group")) == null ? void 0 : b.value) ?? " ", f = ((d = u.find((o) => o.type === "decimal")) == null ? void 0 : d.value) ?? ".", i = N(n, p, f);
      if (Number.isNaN(parseFloat(i))) return s;
      const h = i.split(".");
      if (h[1] != null && h[1].length >= 1) {
        const o = h[1].length <= r ? h[1].length : r;
        a = w(o, r, e);
      }
      let l = a.format(parseFloat(i));
      return t ? r > 0 && i.endsWith(".") && !i.slice(0, -1).includes(".") && (l += f) : l = N(l, p, f), s + l;
    }, C = (n) => JSON.parse(n.replaceAll("'", '"')), F = (n, t = {}) => {
      const e = { ...t };
      n.dataset.maska != null && n.dataset.maska !== "" && (e.mask = T(n.dataset.maska)), n.dataset.maskaEager != null && (e.eager = E(n.dataset.maskaEager)), n.dataset.maskaReversed != null && (e.reversed = E(n.dataset.maskaReversed)), n.dataset.maskaTokensReplace != null && (e.tokensReplace = E(n.dataset.maskaTokensReplace)), n.dataset.maskaTokens != null && (e.tokens = W(n.dataset.maskaTokens));
      const s = {};
      return n.dataset.maskaNumberLocale != null && (s.locale = n.dataset.maskaNumberLocale), n.dataset.maskaNumberFraction != null && (s.fraction = parseInt(n.dataset.maskaNumberFraction)), n.dataset.maskaNumberUnsigned != null && (s.unsigned = E(n.dataset.maskaNumberUnsigned)), (n.dataset.maskaNumber != null || Object.values(s).length > 0) && (e.number = s), e;
    }, E = (n) => n !== "" ? !!JSON.parse(n) : true, T = (n) => n.startsWith("[") && n.endsWith("]") ? C(n) : n, W = (n) => {
      if (n.startsWith("{") && n.endsWith("}"))
        return C(n);
      const t = {};
      return n.split("|").forEach((e) => {
        const s = e.split(":");
        t[s[0]] = {
          pattern: I() ? new RegExp(s[1], "u") : new RegExp(s[1]),
          optional: s[2] === "optional",
          multiple: s[2] === "multiple",
          repeated: s[2] === "repeated"
        };
      }), t;
    }, I = () => {
      try {
        return new RegExp("\\p{L}", "u"), !0;
      } catch {
        return false;
      }
    };
    class O {
      constructor(t = {}) {
        A(this, "opts", {});
        A(this, "memo", /* @__PURE__ */ new Map());
        const e = { ...t };
        if (e.tokens != null) {
          e.tokens = e.tokensReplace ? { ...e.tokens } : { ...R, ...e.tokens };
          for (const s of Object.values(e.tokens))
            typeof s.pattern == "string" && (s.pattern = I() ? new RegExp(s.pattern, "u") : new RegExp(s.pattern));
        } else
          e.tokens = R;
        Array.isArray(e.mask) && (e.mask.length > 1 ? e.mask = [...e.mask].sort((s, r) => s.length - r.length) : e.mask = e.mask[0] ?? ""), e.mask === "" && (e.mask = null), this.opts = e;
      }
      masked(t) {
        return this.process(String(t), this.findMask(String(t)));
      }
      unmasked(t) {
        return this.process(String(t), this.findMask(String(t)), false);
      }
      isEager() {
        return this.opts.eager === true;
      }
      isReversed() {
        return this.opts.reversed === true;
      }
      completed(t) {
        const e = this.findMask(String(t));
        if (this.opts.mask == null || e == null) return false;
        const s = this.process(String(t), e).length;
        return typeof this.opts.mask == "string" ? s >= this.opts.mask.length : s >= e.length;
      }
      findMask(t) {
        const e = this.opts.mask;
        if (e == null)
          return null;
        if (typeof e == "string")
          return e;
        if (typeof e == "function")
          return e(t);
        const s = this.process(t, e.slice(-1).pop() ?? "", false);
        return e.find((r) => this.process(t, r, false).length >= s.length) ?? "";
      }
      escapeMask(t) {
        const e = [], s = [];
        return t.split("").forEach((r, a) => {
          r === "!" && t[a - 1] !== "!" ? s.push(a - s.length) : e.push(r);
        }), { mask: e.join(""), escaped: s };
      }
      process(t, e, s = true) {
        if (this.opts.number != null) return P(t, s, this.opts);
        if (e == null) return t;
        const r = `v=${t},mr=${e},m=${s ? 1 : 0}`;
        if (this.memo.has(r)) return this.memo.get(r);
        const { mask: a, escaped: u } = this.escapeMask(e), p = [], f = this.opts.tokens != null ? this.opts.tokens : {}, i = this.isReversed() ? -1 : 1, h = this.isReversed() ? "unshift" : "push", l = this.isReversed() ? 0 : a.length - 1, k = this.isReversed() ? () => o > -1 && c > -1 : () => o < a.length && c < t.length, g = (v) => !this.isReversed() && v <= l || this.isReversed() && v >= l;
        let b, d = -1, o = this.isReversed() ? a.length - 1 : 0, c = this.isReversed() ? t.length - 1 : 0, M = false;
        for (; k(); ) {
          const v = a.charAt(o), m = f[v], y = (m == null ? void 0 : m.transform) != null ? m.transform(t.charAt(c)) : t.charAt(c);
          if (!u.includes(o) && m != null ? (y.match(m.pattern) != null ? (p[h](y), m.repeated ? (d === -1 ? d = o : o === l && o !== d && (o = d - i), l === d && (o -= i)) : m.multiple && (M = true, o -= i), o += i) : m.multiple ? M && (o += i, c -= i, M = false) : y === b ? b = void 0 : m.optional && (o += i, c -= i), c += i) : (s && !this.isEager() && p[h](v), y === v && !this.isEager() ? c += i : b = v, this.isEager() || (o += i)), this.isEager())
            for (; g(o) && (f[a.charAt(o)] == null || u.includes(o)); ) {
              if (s) {
                if (p[h](a.charAt(o)), t.charAt(c) === a.charAt(o)) {
                  o += i, c += i;
                  continue;
                }
              } else a.charAt(o) === t.charAt(c) && (c += i);
              o += i;
            }
        }
        return this.memo.set(r, p.join("")), this.memo.get(r);
      }
    }
    class V {
      constructor(t, e = {}) {
        A(this, "items", /* @__PURE__ */ new Map());
        A(this, "eventAbortController");
        A(this, "onInput", (t) => {
          if (t instanceof CustomEvent && t.type === "input" && !t.isTrusted && !t.bubbles)
            return;
          const e = t.target, s = this.items.get(e);
          if (s === void 0) return;
          const r = "inputType" in t && t.inputType.startsWith("delete"), a = s.isEager(), u = r && a && s.unmasked(e.value) === "" ? "" : e.value;
          this.fixCursor(e, r, () => this.setValue(e, u));
        });
        this.options = e, this.eventAbortController = new AbortController(), this.init(this.getInputs(t));
      }
      update(t = {}) {
        this.options = { ...t }, this.init(Array.from(this.items.keys()));
      }
      updateValue(t) {
        var e;
        t.value !== "" && t.value !== ((e = this.processInput(t)) == null ? void 0 : e.masked) && this.setValue(t, t.value);
      }
      destroy() {
        this.eventAbortController.abort(), this.items.clear();
      }
      init(t) {
        const e = this.getOptions(this.options);
        for (const s of t) {
          if (!this.items.has(s)) {
            const { signal: a } = this.eventAbortController;
            s.addEventListener("input", this.onInput, { capture: true, signal: a });
          }
          const r = new O(F(s, e));
          this.items.set(s, r), queueMicrotask(() => this.updateValue(s)), s.selectionStart === null && r.isEager() && console.warn("Maska: input of `%s` type is not supported", s.type);
        }
      }
      getInputs(t) {
        return typeof t == "string" ? Array.from(document.querySelectorAll(t)) : "length" in t ? Array.from(t) : [t];
      }
      getOptions(t) {
        const { onMaska: e, preProcess: s, postProcess: r, ...a } = t;
        return a;
      }
      fixCursor(t, e, s) {
        var k, g;
        const r = t.selectionStart, a = t.value;
        if (s(), r === null || r === a.length && !e) return;
        const u = t.value, p = a.slice(0, r), f = u.slice(0, r), i = (k = this.processInput(t, p)) == null ? void 0 : k.unmasked, h = (g = this.processInput(t, f)) == null ? void 0 : g.unmasked;
        if (i === void 0 || h === void 0) return;
        let l = r;
        p !== f && (l += e ? u.length - a.length : i.length - h.length), t.setSelectionRange(l, l);
      }
      setValue(t, e) {
        const s = this.processInput(t, e);
        s !== void 0 && (t.value = s.masked, this.options.onMaska != null && (Array.isArray(this.options.onMaska) ? this.options.onMaska.forEach((r) => r(s)) : this.options.onMaska(s)), t.dispatchEvent(new CustomEvent("maska", { detail: s })), t.dispatchEvent(new CustomEvent("input", { detail: s.masked })));
      }
      processInput(t, e) {
        const s = this.items.get(t);
        if (s === void 0) return;
        let r = e ?? t.value;
        this.options.preProcess != null && (r = this.options.preProcess(r));
        let a = s.masked(r);
        return this.options.postProcess != null && (a = this.options.postProcess(a)), {
          masked: a,
          unmasked: s.unmasked(r),
          completed: s.completed(r)
        };
      }
    }

    document.addEventListener('DOMContentLoaded', function (event) {

        /* =================================================
        css variable
        =================================================*/

        function css_variable() {
            let vh = window.innerHeight * 0.01;
            let hgtheader = document.querySelector('header') ? document.querySelector('header').clientHeight : 64;
            let hgtheadertop = document.querySelector('.header-top') ? document.querySelector('.header-top').clientHeight : 41;
            let sphead = document.querySelector('.sp-head') ? document.querySelector('.sp-head').clientHeight : 41;

            document.documentElement.style.setProperty('--vh', vh + 'px');
            document.documentElement.style.setProperty('--hgt-header', hgtheader + 'px');
            document.documentElement.style.setProperty('--hgt-header-top', hgtheadertop + 'px');
            document.documentElement.style.setProperty('--hgt-sp-head', sphead + 'px');

            return {
                vh,
                hgtheader,
                hgtheadertop,
                sphead
            }
        }

        window.addEventListener('load', css_variable);
        window.addEventListener('resize', css_variable);

        /* =================================================
        load ymaps api
        =================================================*/

        window.loadApiYmaps = function (callback) {

            if (window.ymaps == undefined && !window.stateLoadingApi) {
                window.stateLoadingApi = true;
                const script = document.createElement('script');
                script.src = API_YMAPS;
                script.onload = () => {
                    callback(window.ymaps);
                };
                document.head.append(script);
            } else {
                callback(window.ymaps);
            }

        };

        /* =================================================
        smooth scroll
        ================================================= */

        window.scrollToTargetAdjusted = function (params) {

            let element = typeof params.elem == 'string' ? document.querySelector(params.elem) : params.elem;
            let elementPosition = element.getBoundingClientRect().top + window.scrollY;

            let offsetPosition = elementPosition;
            offsetPosition -= (params.offset ? params.offset : 0);

            window.scrollTo({
                top: Number(offsetPosition),
                behavior: "smooth"
            });
        };

        /* =================================================
        preloader
        ================================================= */

        class Preloader {

            constructor() {
                this.$el = this.init();
                this.state = false;
            }

            init() {
                const el = document.createElement('div');
                el.classList.add('loading');
                el.innerHTML = '<div class="indeterminate"></div>';
                document.body.append(el);
                return el;
            }

            load() {

                this.state = true;

                setTimeout(() => {
                    if (this.state) this.$el.classList.add('load');
                }, 300);
            }

            stop() {

                this.state = false;

                setTimeout(() => {
                    if (this.$el.classList.contains('load'))
                        this.$el.classList.remove('load');
                }, 200);
            }

        }

        window.preloader = new Preloader();


        /* ==============================================
        Status
        ============================================== */

        function Status() {

            this.containerElem = '#status';
            this.headerElem = '#status_header';
            this.msgElem = '#status_msg';
            this.btnElem = '#status_btn';
            this.timeOut = 10000,
                this.autoHide = true;

            this.init = function () {
                let elem = document.createElement('div');
                elem.setAttribute('id', 'status');
                elem.innerHTML = '<div id="status_header"></div> <div id="status_msg"></div><div id="status_btn"></div>';
                document.body.append(elem);

                document.querySelector(this.btnElem).addEventListener('click', function () {
                    this.parentNode.setAttribute('class', '');
                });
            };

            this.msg = function (_msg, _header) {
                _header = (_header ? _header : 'Отлично!');
                this.onShow('complete', _header, _msg);
                if (this.autoHide) {
                    this.onHide();
                }
            };
            this.err = function (_msg, _header) {
                _header = (_header ? _header : 'Ошибка');
                this.onShow('error', _header, _msg);
                if (this.autoHide) {
                    this.onHide();
                }
            };
            this.wrn = function (_msg, _header) {
                _header = (_header ? _header : 'Внимание');
                this.onShow('warning', _header, _msg);
                if (this.autoHide) {
                    this.onHide();
                }
            };

            this.onShow = function (_type, _header, _msg) {
                document.querySelector(this.headerElem).innerText = _header;
                document.querySelector(this.msgElem).innerText = _msg;
                document.querySelector(this.containerElem).classList.add(_type);
            };

            this.onHide = function () {
                setTimeout(() => {
                    document.querySelector(this.containerElem).setAttribute('class', '');
                }, this.timeOut);
            };

        }

        window.STATUS = new Status();
        const STATUS = window.STATUS;
        STATUS.init();

        /* ==============================================
        ajax request
        ============================================== */

        window.ajax = function (params, response) {

            //params Object
            //dom element
            //collback function

            window.preloader.load();

            let xhr = new XMLHttpRequest();
            xhr.open((params.type ? params.type : 'POST'), params.url);

            if (params.headers) {
                for (let key in params.headers) {
                    xhr.setRequestHeader(key, params.headers[key]);
                }
            }

            if (params.responseType == 'json') {
                xhr.responseType = 'json';
                xhr.setRequestHeader('Content-type', 'application/json; charset=utf-8');
                xhr.send(JSON.stringify(params.data));
            } else {
                let formData = new FormData();
                for (key in params.data) {
                    formData.append(key, params.data[key]);
                }
                xhr.send(formData);
            }

            xhr.onload = function () {

                response ? response(xhr.status, xhr.response) : '';
                window.preloader.stop();
                setTimeout(function () {
                    if (params.btn) {
                        params.btn.classList.remove('btn-loading');
                    }
                }, 300);
            };

            xhr.onerror = function () {
                window.STATUS.err('Error: ajax request failed');
            };

            xhr.onreadystatechange = function () {
                if (xhr.readyState == 3) {
                    if (params.btn) {
                        params.btn.classList.add('btn-loading');
                    }
                }
            };
        };

        /* ==================================================
        maska
        ==================================================*/

        function initMaska() {
            new V("[data-maska]");

            new V("[data-input-mask='name']", {
                mask: 'A',
                tokens: {
                    A: {
                        pattern: /[a-zA-ZА-Яа-я ]/,
                        repeated: true
                    },
                }
            });

        }

        initMaska();


        /* ==================================================
        burgerMenu
        ==================================================*/

        class MainMenu {
            constructor(ctx) {
                this.$el = ctx;
                this.btns = this.$el.querySelectorAll('[data-menu="open"]');
                this.container = this.$el.querySelector('[data-menu="container"]');

                this.addEvent();
                this.afterLoad();
            }

            toggleMenu(item) {
                item.classList.toggle('is-open');

                if (!item.classList.contains('is-open')) {
                    this.closeMenu();
                } else {
                    this.openMenu();
                }
            }

            openMenu() {
                this.container.classList.toggle('is-open');
                this.$el.body.classList.toggle('page-hidden');
                this.$el.body.classList.toggle('open-modile-menu');

            }

            closeMenu() {
                this.btns.forEach(item => {
                    !item.classList.contains('is-open') || item.classList.remove('is-open');
                });

                !this.$el.body.classList.contains('open-modile-menu') || !this.$el.body.classList.remove('open-modile-menu');
                !this.container.classList.contains('is-open') || this.container.classList.remove('is-open');
                !this.$el.body.classList.contains('page-hidden') || this.$el.body.classList.remove('page-hidden');
            }


            afterLoad() {
                this.container.querySelectorAll('.isset-sub').forEach(item => {
                    item.addEventListener('click', e => {
                        e.stopPropagation();


                        if (e.target.classList.contains('is-open')) {
                            e.target.classList.remove('is-open');
                            return false;
                        }

                        e.target.closest('ul').querySelectorAll('.is-open').forEach(li => {
                            li.classList.remove('is-open');
                        });

                        e.target.classList.toggle('is-open');
                    });
                });
            }

            addEvent() {
                this.btns.forEach(item => {
                    item.addEventListener('click', e => this.toggleMenu(item));
                });

                this.$el.querySelectorAll('[data-menu="close"]').forEach(item => {
                    item.addEventListener('click', () => {
                        this.closeMenu();
                    });
                });
            }
        }

        if (document.querySelector('[data-menu="open"]')) {
            window.MainMenu = new MainMenu(document);
        }
        /* =================================================
            popups
            =================================================*/

        function popupSuccess() {

            const instansePopup = new afLightbox({
                mobileInBottom: true
            });

            instansePopup.open(`

           <div class="popup-thanks" >

           <h2> Спасибо! </h2>
           <p>Мы свяжемся с вами в ближайшее время!</p>

           </div>

            `, false);

        }

        if (document.querySelector('[data-modal]')) {
            const items = document.querySelectorAll('[data-modal]');

            items.forEach(item => {
                item.addEventListener('click', e => {

                    window.ajax({
                        type: 'GET',
                        url: item.dataset.modal
                    }, (status, response) => {

                        const instansePopup = new afLightbox({
                            mobileInBottom: true
                        });

                        instansePopup.open(response, (instanse) => {
                            initMaska();

                            if (instanse.querySelector('form')) {
                                const form = instanse.querySelector('form');

                                form.addEventListener('submit', e => {

                                    e.preventDefault();

                                    const formData = new FormData(e.target);
                                    let params = {};
                                    let btn = form.querySelector('.btn');

                                    for (let [name, value] of formData) {
                                        params[name] = value;
                                    }

                                    btn.classList.add('btn-loading');

                                    window.ajax({
                                        type: 'POST',
                                        url: form.getAttribute('action'),
                                        data: params

                                    }, (status, response) => {

                                        if (status == 200) {
                                            popupSuccess();
                                            !btn.classList.contains('btn-loading') || btn.classList.remove('btn-loading');
                                            instansePopup.close();
                                        }


                                    });
                                });
                            }

                            if (item.dataset.title) {
                                instanse.querySelector('.popup-form__title').innerHTML = item.dataset.title;
                            }

                            if (item.dataset.desc) {
                                instanse.querySelector('.popup-form__desc').innerHTML = item.dataset.desc;
                            }
                        });
                    });

                });
            });
        }



    }); //dcl




    document.addEventListener('DOMContentLoaded', function() {
        const heads = document.querySelectorAll('.footer-category__head');

        heads.forEach(function(head) {
            head.addEventListener('click', function(e) {
                e.preventDefault();
                const category = this.closest('.footer-category');
                if (category) {
                    category.classList.toggle('open');
                }
            });
        });
    });

    // Вариант 3: Компактный и чистый
    document.addEventListener('DOMContentLoaded', function() {
        const tabs = document.querySelectorAll('[data-tab]');
        const contents = document.querySelectorAll('[data-content]');

        function showTab(index) {
            tabs.forEach(tab => {
                tab.classList.toggle('active', parseInt(tab.dataset.tab) === index);
            });

            contents.forEach(content => {
                const isActive = parseInt(content.dataset.content) === index;
                content.classList.toggle('active', isActive);
                content.style.display = isActive ? 'block' : 'none';
            });
        }

        tabs.forEach(tab => {
            tab.addEventListener('click', function(e) {
                if (this.tagName === 'A') e.preventDefault();
                showTab(parseInt(this.dataset.tab));
            });
        });

        // Показываем активный или первый
        const activeTab = document.querySelector('[data-tab].active');
        showTab(activeTab ? parseInt(activeTab.dataset.tab) : 0);


    });

    function initCommentButtons() {
        document.querySelectorAll('.aboutSlider__item_comment-text').forEach(textElement => {
            const comment = textElement.closest('.aboutSlider__item_comment');
            const btn = comment?.querySelector('.aboutSlider__item_comment-btn');

            if (!btn) return;

            function toggleButton() {
                const isOverflowing = textElement.scrollHeight > textElement.clientHeight;
                btn.classList.toggle('visible', isOverflowing);
            }

            // Задержка для полной загрузки контента
            const checkWithDelay = () => {
                setTimeout(toggleButton, 200);
            };

            // Проверяем сразу
            checkWithDelay();

            // Проверяем после загрузки всех ресурсов
            window.addEventListener('load', checkWithDelay);

            // Проверяем при изменении размера
            window.addEventListener('resize', toggleButton);

            // Используем ResizeObserver если доступен
            if (window.ResizeObserver) {
                const resizeObserver = new ResizeObserver(() => {
                    toggleButton();
                });
                resizeObserver.observe(textElement);
            }

            // Проверяем при прокрутке (на случай, если элементы появляются с задержкой)
            document.addEventListener('scroll', () => {
                const rect = textElement.getBoundingClientRect();
                if (rect.top < window.innerHeight && rect.bottom > 0) {
                    toggleButton();
                }
            }, { once: true });
        });
    }

    // Запускаем после DOM готов
    document.addEventListener('DOMContentLoaded', initCommentButtons);
    // И после полной загрузки
    window.addEventListener('load', initCommentButtons);

    document.addEventListener('DOMContentLoaded', function (event) {


        /* ==================================
        Team slider
        ==================================*/
        teamslider();

        /* ==================================
        stories slider
        ==================================*/
        storiesSlider();

        /*============aboutCompany======================*/
        aboutCompany();

        /* ==================================
        stories slider
        ==================================*/
        offersSlider();
        /* ==================================
        thumbSlider
        ==================================*/
        initProductGallery();
        /* ==================================
        stories slider
        ==================================*/
        aboutUsSlider();
        /* ==================================
       FAQ()
        ==================================*/
        faq();


    });

})();
